export interface CityMetrics {
  name: string;
  country: string;
  costOfLivingIndex: number;
  rentIndex: number;
  groceriesIndex: number;
  restaurantIndex: number;
  purchasingPowerIndex: number;
  safetyIndex: number;
  climateIndex: number;
  healthcareIndex: number;
  trafficEfficiencyIndex: number;
  pollutionControlIndex: number;
  internetSpeedIndex: number;
  typicalExpenses: {
    mealInexpensive: string;
    coffee: string;
    apartment1BedCenter: string;
    monthlyPass: string;
    utilitiesBasic: string;
  };
}

export const CITY_DATABASE: CityMetrics[] = [
  {
    "name": "New York",
    "country": "United States",
    "costOfLivingIndex": 101.8,
    "rentIndex": 102,
    "groceriesIndex": 101.5,
    "restaurantIndex": 102,
    "purchasingPowerIndex": 100,
    "safetyIndex": 51.2,
    "climateIndex": 78.4,
    "healthcareIndex": 65.4,
    "trafficEfficiencyIndex": 45.2,
    "pollutionControlIndex": 52.1,
    "internetSpeedIndex": 92.5,
    "typicalExpenses": {
      "mealInexpensive": "$26.50",
      "coffee": "$5.80",
      "apartment1BedCenter": "$4,031",
      "monthlyPass": "$140",
      "utilitiesBasic": "$196"
    }
  },
  {
    "name": "London",
    "country": "United Kingdom",
    "costOfLivingIndex": 83.9,
    "rentIndex": 79.8,
    "groceriesIndex": 69.5,
    "restaurantIndex": 85.8,
    "purchasingPowerIndex": 92.4,
    "safetyIndex": 47.8,
    "climateIndex": 85.2,
    "healthcareIndex": 72.8,
    "trafficEfficiencyIndex": 42.1,
    "pollutionControlIndex": 58.4,
    "internetSpeedIndex": 88.6,
    "typicalExpenses": {
      "mealInexpensive": "£20.80",
      "coffee": "£4.26",
      "apartment1BedCenter": "£2,548",
      "monthlyPass": "£187.20",
      "utilitiesBasic": "£218.40"
    }
  },
  {
    "name": "Tokyo",
    "country": "Japan",
    "costOfLivingIndex": 59.8,
    "rentIndex": 32.7,
    "groceriesIndex": 65.2,
    "restaurantIndex": 39.4,
    "purchasingPowerIndex": 84.5,
    "safetyIndex": 77.9,
    "climateIndex": 82.5,
    "healthcareIndex": 86.4,
    "trafficEfficiencyIndex": 87.1,
    "pollutionControlIndex": 81.3,
    "internetSpeedIndex": 94.8,
    "typicalExpenses": {
      "mealInexpensive": "¥1,144",
      "coffee": "¥541",
      "apartment1BedCenter": "¥156,000",
      "monthlyPass": "¥10,400",
      "utilitiesBasic": "¥22,880"
    }
  },
  {
    "name": "Paris",
    "country": "France",
    "costOfLivingIndex": 80.5,
    "rentIndex": 49.7,
    "groceriesIndex": 75.9,
    "restaurantIndex": 73.5,
    "purchasingPowerIndex": 87.2,
    "safetyIndex": 43.1,
    "climateIndex": 83.1,
    "healthcareIndex": 81.2,
    "trafficEfficiencyIndex": 51.4,
    "pollutionControlIndex": 64.2,
    "internetSpeedIndex": 91,
    "typicalExpenses": {
      "mealInexpensive": "€18.72",
      "coffee": "€4.68",
      "apartment1BedCenter": "€1,404",
      "monthlyPass": "€87.36",
      "utilitiesBasic": "€202.85"
    }
  },
  {
    "name": "Singapore",
    "country": "Singapore",
    "costOfLivingIndex": 96.3,
    "rentIndex": 93.9,
    "groceriesIndex": 80.6,
    "restaurantIndex": 69.6,
    "purchasingPowerIndex": 114.9,
    "safetyIndex": 76.5,
    "climateIndex": 60.2,
    "healthcareIndex": 85.9,
    "trafficEfficiencyIndex": 89.4,
    "pollutionControlIndex": 84.6,
    "internetSpeedIndex": 98.2,
    "typicalExpenses": {
      "mealInexpensive": "S$15.60",
      "coffee": "S$6.76",
      "apartment1BedCenter": "S$4,368",
      "monthlyPass": "S$133.12",
      "utilitiesBasic": "S$187.20"
    }
  },
  {
    "name": "Zurich",
    "country": "Switzerland",
    "costOfLivingIndex": 126.7,
    "rentIndex": 88.1,
    "groceriesIndex": 123.9,
    "restaurantIndex": 121.3,
    "purchasingPowerIndex": 120.3,
    "safetyIndex": 81.3,
    "climateIndex": 79.1,
    "healthcareIndex": 84.2,
    "trafficEfficiencyIndex": 78.5,
    "pollutionControlIndex": 89.4,
    "internetSpeedIndex": 95.2,
    "typicalExpenses": {
      "mealInexpensive": "CHF 31.20",
      "coffee": "CHF 6.03",
      "apartment1BedCenter": "CHF 2,288",
      "monthlyPass": "CHF 88.40",
      "utilitiesBasic": "CHF 260.00"
    }
  },
  {
    "name": "Berlin",
    "country": "Germany",
    "costOfLivingIndex": 74.8,
    "rentIndex": 48.9,
    "groceriesIndex": 63,
    "restaurantIndex": 61.7,
    "purchasingPowerIndex": 98.4,
    "safetyIndex": 58.9,
    "climateIndex": 80.4,
    "healthcareIndex": 82.1,
    "trafficEfficiencyIndex": 68.4,
    "pollutionControlIndex": 74.3,
    "internetSpeedIndex": 87.4,
    "typicalExpenses": {
      "mealInexpensive": "€14.56",
      "coffee": "€4.06",
      "apartment1BedCenter": "€1,300",
      "monthlyPass": "€50.96",
      "utilitiesBasic": "€291.20"
    }
  },
  {
    "name": "Sydney",
    "country": "Australia",
    "costOfLivingIndex": 85.6,
    "rentIndex": 71.7,
    "groceriesIndex": 81.1,
    "restaurantIndex": 77.9,
    "purchasingPowerIndex": 104.2,
    "safetyIndex": 66.2,
    "climateIndex": 91.5,
    "healthcareIndex": 78.4,
    "trafficEfficiencyIndex": 62.1,
    "pollutionControlIndex": 82.5,
    "internetSpeedIndex": 89.1,
    "typicalExpenses": {
      "mealInexpensive": "A$24.96",
      "coffee": "A$5.41",
      "apartment1BedCenter": "A$3,224",
      "monthlyPass": "A$197.60",
      "utilitiesBasic": "A$239.20"
    }
  },
  {
    "name": "Dubai",
    "country": "United Arab Emirates",
    "costOfLivingIndex": 72.7,
    "rentIndex": 64.1,
    "groceriesIndex": 52.3,
    "restaurantIndex": 65.3,
    "purchasingPowerIndex": 110.1,
    "safetyIndex": 83.6,
    "climateIndex": 42.1,
    "healthcareIndex": 76.5,
    "trafficEfficiencyIndex": 82.3,
    "pollutionControlIndex": 56.1,
    "internetSpeedIndex": 96.4,
    "typicalExpenses": {
      "mealInexpensive": "AED 46.80",
      "coffee": "AED 23.92",
      "apartment1BedCenter": "AED 7,800",
      "monthlyPass": "AED 312.00",
      "utilitiesBasic": "AED 748.80"
    }
  },
  {
    "name": "Toronto",
    "country": "Canada",
    "costOfLivingIndex": 74.7,
    "rentIndex": 56.4,
    "groceriesIndex": 73.2,
    "restaurantIndex": 70.8,
    "purchasingPowerIndex": 91.4,
    "safetyIndex": 56.4,
    "climateIndex": 74.1,
    "healthcareIndex": 75.3,
    "trafficEfficiencyIndex": 44.5,
    "pollutionControlIndex": 68.2,
    "internetSpeedIndex": 91.2,
    "typicalExpenses": {
      "mealInexpensive": "C$26.00",
      "coffee": "C$5.04",
      "apartment1BedCenter": "C$2,392",
      "monthlyPass": "C$162.24",
      "utilitiesBasic": "C$166.40"
    }
  },
  {
    "name": "Moscow",
    "country": "Russia",
    "costOfLivingIndex": 47,
    "rentIndex": 29.1,
    "groceriesIndex": 39.7,
    "restaurantIndex": 42.3,
    "purchasingPowerIndex": 58.7,
    "safetyIndex": 61.4,
    "climateIndex": 50.1,
    "healthcareIndex": 68.1,
    "trafficEfficiencyIndex": 72.4,
    "pollutionControlIndex": 55.3,
    "internetSpeedIndex": 91.5,
    "typicalExpenses": {
      "mealInexpensive": "₽1,061",
      "coffee": "₽297",
      "apartment1BedCenter": "₽90,168",
      "monthlyPass": "₽2,896",
      "utilitiesBasic": "₽10,078"
    }
  },
  {
    "name": "Hong Kong",
    "country": "Hong Kong",
    "costOfLivingIndex": 73.7,
    "rentIndex": 76,
    "groceriesIndex": 69.5,
    "restaurantIndex": 62.4,
    "purchasingPowerIndex": 58.1,
    "safetyIndex": 78.5,
    "climateIndex": 72.4,
    "healthcareIndex": 65.2,
    "trafficEfficiencyIndex": 72.1,
    "pollutionControlIndex": 46.5,
    "internetSpeedIndex": 165.2,
    "typicalExpenses": {
      "mealInexpensive": "HK$ 67.60",
      "coffee": "HK$ 43.68",
      "apartment1BedCenter": "HK$ 17,160",
      "monthlyPass": "HK$ 520.00",
      "utilitiesBasic": "HK$ 1,612"
    }
  },
  {
    "name": "Barcelona",
    "country": "Spain",
    "costOfLivingIndex": 62.6,
    "rentIndex": 45.2,
    "groceriesIndex": 52,
    "restaurantIndex": 57.5,
    "purchasingPowerIndex": 80.5,
    "safetyIndex": 49.5,
    "climateIndex": 90.1,
    "healthcareIndex": 80.1,
    "trafficEfficiencyIndex": 71.5,
    "pollutionControlIndex": 59.8,
    "internetSpeedIndex": 92.8,
    "typicalExpenses": {
      "mealInexpensive": "€15.60",
      "coffee": "€2.60",
      "apartment1BedCenter": "€1,248",
      "monthlyPass": "€41.60",
      "utilitiesBasic": "€164.32"
    }
  },
  {
    "name": "Rome",
    "country": "Italy",
    "costOfLivingIndex": 64.5,
    "rentIndex": 39.3,
    "groceriesIndex": 57,
    "restaurantIndex": 60.3,
    "purchasingPowerIndex": 68.4,
    "safetyIndex": 48.9,
    "climateIndex": 91.2,
    "healthcareIndex": 72.1,
    "trafficEfficiencyIndex": 41.5,
    "pollutionControlIndex": 54.3,
    "internetSpeedIndex": 86.4,
    "typicalExpenses": {
      "mealInexpensive": "€15.60",
      "coffee": "€1.56",
      "apartment1BedCenter": "€1,144",
      "monthlyPass": "€36.40",
      "utilitiesBasic": "€182.00"
    }
  },
  {
    "name": "Amsterdam",
    "country": "Netherlands",
    "costOfLivingIndex": 82.9,
    "rentIndex": 61.7,
    "groceriesIndex": 66.3,
    "restaurantIndex": 77.7,
    "purchasingPowerIndex": 102.1,
    "safetyIndex": 68.5,
    "climateIndex": 82.4,
    "healthcareIndex": 81.5,
    "trafficEfficiencyIndex": 70.1,
    "pollutionControlIndex": 79.8,
    "internetSpeedIndex": 94.1,
    "typicalExpenses": {
      "mealInexpensive": "€18.72",
      "coffee": "€4.68",
      "apartment1BedCenter": "€1,924",
      "monthlyPass": "€98.80",
      "utilitiesBasic": "€218.40"
    }
  },
  {
    "name": "Vienna",
    "country": "Austria",
    "costOfLivingIndex": 69.7,
    "rentIndex": 33.8,
    "groceriesIndex": 62.1,
    "restaurantIndex": 60.6,
    "purchasingPowerIndex": 94.1,
    "safetyIndex": 79.1,
    "climateIndex": 83.4,
    "healthcareIndex": 85.2,
    "trafficEfficiencyIndex": 79.8,
    "pollutionControlIndex": 84.1,
    "internetSpeedIndex": 89.4,
    "typicalExpenses": {
      "mealInexpensive": "€14.04",
      "coffee": "€4.11",
      "apartment1BedCenter": "€988",
      "monthlyPass": "€34.32",
      "utilitiesBasic": "€228.80"
    }
  },
  {
    "name": "Los Angeles",
    "country": "United States",
    "costOfLivingIndex": 86.1,
    "rentIndex": 72.6,
    "groceriesIndex": 89.8,
    "restaurantIndex": 80.7,
    "purchasingPowerIndex": 110.2,
    "safetyIndex": 48.9,
    "climateIndex": 94.2,
    "healthcareIndex": 74.8,
    "trafficEfficiencyIndex": 38.4,
    "pollutionControlIndex": 45.1,
    "internetSpeedIndex": 95.1,
    "typicalExpenses": {
      "mealInexpensive": "$21.20",
      "coffee": "$5.60",
      "apartment1BedCenter": "$2,758",
      "monthlyPass": "$106",
      "utilitiesBasic": "$183"
    }
  },
  {
    "name": "Seoul",
    "country": "South Korea",
    "costOfLivingIndex": 74.4,
    "rentIndex": 33.2,
    "groceriesIndex": 89.7,
    "restaurantIndex": 45,
    "purchasingPowerIndex": 82.4,
    "safetyIndex": 71.5,
    "climateIndex": 79.4,
    "healthcareIndex": 88.2,
    "trafficEfficiencyIndex": 85.4,
    "pollutionControlIndex": 45.1,
    "internetSpeedIndex": 98.6,
    "typicalExpenses": {
      "mealInexpensive": "₩10,400",
      "coffee": "₩5,200",
      "apartment1BedCenter": "₩1,144,000",
      "monthlyPass": "₩57,200",
      "utilitiesBasic": "₩187,200"
    }
  },
  {
    "name": "San Francisco",
    "country": "United States",
    "costOfLivingIndex": 94.1,
    "rentIndex": 87,
    "groceriesIndex": 97.6,
    "restaurantIndex": 90.7,
    "purchasingPowerIndex": 125.4,
    "safetyIndex": 53.1,
    "climateIndex": 86.7,
    "healthcareIndex": 78.5,
    "trafficEfficiencyIndex": 41.6,
    "pollutionControlIndex": 68.2,
    "internetSpeedIndex": 98.4,
    "typicalExpenses": {
      "mealInexpensive": "$23.30",
      "coffee": "$6.10",
      "apartment1BedCenter": "$3,289",
      "monthlyPass": "$101.80",
      "utilitiesBasic": "$207"
    }
  },
  {
    "name": "Chicago",
    "country": "United States",
    "costOfLivingIndex": 79.6,
    "rentIndex": 57.5,
    "groceriesIndex": 82.5,
    "restaurantIndex": 76,
    "purchasingPowerIndex": 104.1,
    "safetyIndex": 44.8,
    "climateIndex": 71.2,
    "healthcareIndex": 72.4,
    "trafficEfficiencyIndex": 51.5,
    "pollutionControlIndex": 61.2,
    "internetSpeedIndex": 90.8,
    "typicalExpenses": {
      "mealInexpensive": "$19.60",
      "coffee": "$5.30",
      "apartment1BedCenter": "$2,228",
      "monthlyPass": "$79.60",
      "utilitiesBasic": "$170"
    }
  },
  {
    "name": "Madrid",
    "country": "Spain",
    "costOfLivingIndex": 59.5,
    "rentIndex": 35.8,
    "groceriesIndex": 50,
    "restaurantIndex": 53.9,
    "purchasingPowerIndex": 84.1,
    "safetyIndex": 70.1,
    "climateIndex": 89.2,
    "healthcareIndex": 81.2,
    "trafficEfficiencyIndex": 74.2,
    "pollutionControlIndex": 65.4,
    "internetSpeedIndex": 94.2,
    "typicalExpenses": {
      "mealInexpensive": "€13.52",
      "coffee": "€2.29",
      "apartment1BedCenter": "€1,092",
      "monthlyPass": "€56.16",
      "utilitiesBasic": "€150.80"
    }
  },
  {
    "name": "Istanbul",
    "country": "Turkey",
    "costOfLivingIndex": 33,
    "rentIndex": 16.8,
    "groceriesIndex": 30.6,
    "restaurantIndex": 22.8,
    "purchasingPowerIndex": 36.1,
    "safetyIndex": 51.5,
    "climateIndex": 85.1,
    "healthcareIndex": 74.8,
    "trafficEfficiencyIndex": 32.1,
    "pollutionControlIndex": 38.6,
    "internetSpeedIndex": 72.4,
    "typicalExpenses": {
      "mealInexpensive": "₺265",
      "coffee": "₺89.80",
      "apartment1BedCenter": "₺19,094",
      "monthlyPass": "₺1,432",
      "utilitiesBasic": "₺2,069"
    }
  },
  {
    "name": "Prague",
    "country": "Czech Republic",
    "costOfLivingIndex": 49.4,
    "rentIndex": 26.9,
    "groceriesIndex": 41.8,
    "restaurantIndex": 41.3,
    "purchasingPowerIndex": 76.2,
    "safetyIndex": 78.4,
    "climateIndex": 81.4,
    "healthcareIndex": 79.1,
    "trafficEfficiencyIndex": 74.2,
    "pollutionControlIndex": 71.3,
    "internetSpeedIndex": 89.2,
    "typicalExpenses": {
      "mealInexpensive": "Kč 234",
      "coffee": "Kč 72.40",
      "apartment1BedCenter": "Kč 22,277",
      "monthlyPass": "Kč 583",
      "utilitiesBasic": "Kč 5,410"
    }
  },
  {
    "name": "Warsaw",
    "country": "Poland",
    "costOfLivingIndex": 45,
    "rentIndex": 24,
    "groceriesIndex": 36.9,
    "restaurantIndex": 39.9,
    "purchasingPowerIndex": 72.1,
    "safetyIndex": 75.2,
    "climateIndex": 78.4,
    "healthcareIndex": 68.4,
    "trafficEfficiencyIndex": 71.4,
    "pollutionControlIndex": 62.4,
    "internetSpeedIndex": 91.4,
    "typicalExpenses": {
      "mealInexpensive": "zł 42.80",
      "coffee": "zł 15.30",
      "apartment1BedCenter": "zł 3,289",
      "monthlyPass": "zł 116",
      "utilitiesBasic": "zł 945"
    }
  },
  {
    "name": "Lisbon",
    "country": "Portugal",
    "costOfLivingIndex": 52.3,
    "rentIndex": 39.4,
    "groceriesIndex": 42.1,
    "restaurantIndex": 46.1,
    "purchasingPowerIndex": 61.2,
    "safetyIndex": 70.4,
    "climateIndex": 94.1,
    "healthcareIndex": 78.4,
    "trafficEfficiencyIndex": 61.2,
    "pollutionControlIndex": 74.1,
    "internetSpeedIndex": 92.5,
    "typicalExpenses": {
      "mealInexpensive": "€12.48",
      "coffee": "€1.66",
      "apartment1BedCenter": "€1,144",
      "monthlyPass": "€41.60",
      "utilitiesBasic": "€140.40"
    }
  },
  {
    "name": "Bangkok",
    "country": "Thailand",
    "costOfLivingIndex": 40.2,
    "rentIndex": 21.8,
    "groceriesIndex": 46.8,
    "restaurantIndex": 21.7,
    "purchasingPowerIndex": 38.5,
    "safetyIndex": 59.4,
    "climateIndex": 68.2,
    "healthcareIndex": 78.4,
    "trafficEfficiencyIndex": 36.1,
    "pollutionControlIndex": 34.2,
    "internetSpeedIndex": 96.1,
    "typicalExpenses": {
      "mealInexpensive": "฿106",
      "coffee": "฿84.70",
      "apartment1BedCenter": "฿19,094",
      "monthlyPass": "฿1,326",
      "utilitiesBasic": "฿2,758"
    }
  },
  {
    "name": "Munich",
    "country": "Germany",
    "costOfLivingIndex": 81.2,
    "rentIndex": 57.3,
    "groceriesIndex": 67.4,
    "restaurantIndex": 66.4,
    "purchasingPowerIndex": 106.1,
    "safetyIndex": 74.2,
    "climateIndex": 78.1,
    "healthcareIndex": 84.5,
    "trafficEfficiencyIndex": 72.1,
    "pollutionControlIndex": 78.4,
    "internetSpeedIndex": 89.2,
    "typicalExpenses": {
      "mealInexpensive": "€16.64",
      "coffee": "€4.37",
      "apartment1BedCenter": "€1,716",
      "monthlyPass": "€61.36",
      "utilitiesBasic": "€306.80"
    }
  },
  {
    "name": "Stockholm",
    "country": "Sweden",
    "costOfLivingIndex": 73.7,
    "rentIndex": 40.6,
    "groceriesIndex": 65.1,
    "restaurantIndex": 67.8,
    "purchasingPowerIndex": 94.6,
    "safetyIndex": 58.2,
    "climateIndex": 74.5,
    "healthcareIndex": 79.8,
    "trafficEfficiencyIndex": 71.4,
    "pollutionControlIndex": 84.2,
    "internetSpeedIndex": 96.1,
    "typicalExpenses": {
      "mealInexpensive": "kr 159",
      "coffee": "kr 44.90",
      "apartment1BedCenter": "kr 14,321",
      "monthlyPass": "kr 1,082",
      "utilitiesBasic": "kr 1,273"
    }
  },
  {
    "name": "Oslo",
    "country": "Norway",
    "costOfLivingIndex": 90.1,
    "rentIndex": 45.1,
    "groceriesIndex": 82.4,
    "restaurantIndex": 84.2,
    "purchasingPowerIndex": 92.4,
    "safetyIndex": 68.4,
    "climateIndex": 70.1,
    "healthcareIndex": 76.2,
    "trafficEfficiencyIndex": 74.5,
    "pollutionControlIndex": 85.3,
    "internetSpeedIndex": 95.8,
    "typicalExpenses": {
      "mealInexpensive": "kr 234",
      "coffee": "kr 55.10",
      "apartment1BedCenter": "kr 16,442",
      "monthlyPass": "kr 902",
      "utilitiesBasic": "kr 1,697"
    }
  },
  {
    "name": "Copenhagen",
    "country": "Denmark",
    "costOfLivingIndex": 85.6,
    "rentIndex": 52.4,
    "groceriesIndex": 69.2,
    "restaurantIndex": 83.7,
    "purchasingPowerIndex": 96.4,
    "safetyIndex": 72.8,
    "climateIndex": 78.4,
    "healthcareIndex": 79.1,
    "trafficEfficiencyIndex": 78.1,
    "pollutionControlIndex": 86.4,
    "internetSpeedIndex": 94.2,
    "typicalExpenses": {
      "mealInexpensive": "kr 159",
      "coffee": "kr 51.00",
      "apartment1BedCenter": "kr 13,260",
      "monthlyPass": "kr 658",
      "utilitiesBasic": "kr 1,538"
    }
  },
  {
    "name": "Helsinki",
    "country": "Finland",
    "costOfLivingIndex": 72.5,
    "rentIndex": 36.5,
    "groceriesIndex": 61,
    "restaurantIndex": 69.8,
    "purchasingPowerIndex": 95.1,
    "safetyIndex": 74.8,
    "climateIndex": 71.5,
    "healthcareIndex": 81.3,
    "trafficEfficiencyIndex": 72.4,
    "pollutionControlIndex": 88.5,
    "internetSpeedIndex": 92.1,
    "typicalExpenses": {
      "mealInexpensive": "€14.56",
      "coffee": "€4.37",
      "apartment1BedCenter": "€1,019",
      "monthlyPass": "€67.60",
      "utilitiesBasic": "€140.40"
    }
  },
  {
    "name": "Vancouver",
    "country": "Canada",
    "costOfLivingIndex": 79.5,
    "rentIndex": 62.4,
    "groceriesIndex": 77.5,
    "restaurantIndex": 75,
    "purchasingPowerIndex": 94.6,
    "safetyIndex": 61.2,
    "climateIndex": 84.1,
    "healthcareIndex": 76.5,
    "trafficEfficiencyIndex": 48.2,
    "pollutionControlIndex": 81.3,
    "internetSpeedIndex": 93.6,
    "typicalExpenses": {
      "mealInexpensive": "C$27.04",
      "coffee": "C$5.30",
      "apartment1BedCenter": "C$2,652",
      "monthlyPass": "C$124.80",
      "utilitiesBasic": "C$150.80"
    }
  },
  {
    "name": "Melbourne",
    "country": "Australia",
    "costOfLivingIndex": 79.9,
    "rentIndex": 53.1,
    "groceriesIndex": 76.4,
    "restaurantIndex": 72.6,
    "purchasingPowerIndex": 101.4,
    "safetyIndex": 61.2,
    "climateIndex": 88.4,
    "healthcareIndex": 79.1,
    "trafficEfficiencyIndex": 64.3,
    "pollutionControlIndex": 80.5,
    "internetSpeedIndex": 87.4,
    "typicalExpenses": {
      "mealInexpensive": "A$21.84",
      "coffee": "A$5.20",
      "apartment1BedCenter": "A$2,288",
      "monthlyPass": "A$182.00",
      "utilitiesBasic": "A$223.60"
    }
  },
  {
    "name": "Buenos Aires",
    "country": "Argentina",
    "costOfLivingIndex": 33.1,
    "rentIndex": 11.6,
    "groceriesIndex": 28.6,
    "restaurantIndex": 30.1,
    "purchasingPowerIndex": 25.1,
    "safetyIndex": 56.4,
    "climateIndex": 88.2,
    "healthcareIndex": 65.4,
    "trafficEfficiencyIndex": 43.1,
    "pollutionControlIndex": 51.2,
    "internetSpeedIndex": 68.5,
    "typicalExpenses": {
      "mealInexpensive": "ARS$ 8.50",
      "coffee": "ARS$ 3.00",
      "apartment1BedCenter": "ARS$ 371",
      "monthlyPass": "ARS$ 15.90",
      "utilitiesBasic": "ARS$ 69.00"
    }
  },
  {
    "name": "Rio de Janeiro",
    "country": "Brazil",
    "costOfLivingIndex": 35.4,
    "rentIndex": 12.8,
    "groceriesIndex": 29.5,
    "restaurantIndex": 31.6,
    "purchasingPowerIndex": 28.4,
    "safetyIndex": 22.5,
    "climateIndex": 84.1,
    "healthcareIndex": 55.4,
    "trafficEfficiencyIndex": 35.1,
    "pollutionControlIndex": 45.2,
    "internetSpeedIndex": 88,
    "typicalExpenses": {
      "mealInexpensive": "R$ 36.40",
      "coffee": "R$ 9.36",
      "apartment1BedCenter": "R$ 2,288",
      "monthlyPass": "R$ 187.20",
      "utilitiesBasic": "R$ 395"
    }
  },
  {
    "name": "Shanghai",
    "country": "China",
    "costOfLivingIndex": 43.9,
    "rentIndex": 27,
    "groceriesIndex": 45.2,
    "restaurantIndex": 35.8,
    "purchasingPowerIndex": 61.2,
    "safetyIndex": 71.4,
    "climateIndex": 68.2,
    "healthcareIndex": 65.4,
    "trafficEfficiencyIndex": 58.5,
    "pollutionControlIndex": 51.2,
    "internetSpeedIndex": 152.1,
    "typicalExpenses": {
      "mealInexpensive": "¥ 41.60",
      "coffee": "¥ 29.12",
      "apartment1BedCenter": "¥ 7,800",
      "monthlyPass": "¥ 260.00",
      "utilitiesBasic": "¥ 468.00"
    }
  },
  {
    "name": "Beijing",
    "country": "China",
    "costOfLivingIndex": 42.2,
    "rentIndex": 24.6,
    "groceriesIndex": 41.8,
    "restaurantIndex": 33.2,
    "purchasingPowerIndex": 59.5,
    "safetyIndex": 74.2,
    "climateIndex": 60.1,
    "healthcareIndex": 68.2,
    "trafficEfficiencyIndex": 54.1,
    "pollutionControlIndex": 45.2,
    "internetSpeedIndex": 148.5,
    "typicalExpenses": {
      "mealInexpensive": "¥ 36.40",
      "coffee": "¥ 27.04",
      "apartment1BedCenter": "¥ 7,072",
      "monthlyPass": "¥ 249.60",
      "utilitiesBasic": "¥ 436.80"
    }
  },
  {
    "name": "Kuala Lumpur",
    "country": "Malaysia",
    "costOfLivingIndex": 32.7,
    "rentIndex": 11.7,
    "groceriesIndex": 29.9,
    "restaurantIndex": 24.6,
    "purchasingPowerIndex": 52.4,
    "safetyIndex": 62.1,
    "climateIndex": 68.4,
    "healthcareIndex": 72.1,
    "trafficEfficiencyIndex": 45.1,
    "pollutionControlIndex": 52.5,
    "internetSpeedIndex": 112.5,
    "typicalExpenses": {
      "mealInexpensive": "RM 15.60",
      "coffee": "RM 12.48",
      "apartment1BedCenter": "RM 2,184",
      "monthlyPass": "RM 52.00",
      "utilitiesBasic": "RM 249.60"
    }
  },
  {
    "name": "Jakarta",
    "country": "Indonesia",
    "costOfLivingIndex": 32,
    "rentIndex": 12.3,
    "groceriesIndex": 33,
    "restaurantIndex": 23.3,
    "purchasingPowerIndex": 35.1,
    "safetyIndex": 48.2,
    "climateIndex": 61.4,
    "healthcareIndex": 50.1,
    "trafficEfficiencyIndex": 22.1,
    "pollutionControlIndex": 21.2,
    "internetSpeedIndex": 48.5,
    "typicalExpenses": {
      "mealInexpensive": "Rp 47,736",
      "coffee": "Rp 37,128",
      "apartment1BedCenter": "Rp 7,956,000",
      "monthlyPass": "Rp 233,376",
      "utilitiesBasic": "Rp 1,272,960"
    }
  },
  {
    "name": "Manila",
    "country": "Philippines",
    "costOfLivingIndex": 34.1,
    "rentIndex": 15.1,
    "groceriesIndex": 34.7,
    "restaurantIndex": 25.9,
    "purchasingPowerIndex": 28.5,
    "safetyIndex": 38.2,
    "climateIndex": 62.4,
    "healthcareIndex": 55.1,
    "trafficEfficiencyIndex": 24.1,
    "pollutionControlIndex": 25.2,
    "internetSpeedIndex": 62.1,
    "typicalExpenses": {
      "mealInexpensive": "₱265",
      "coffee": "₱149",
      "apartment1BedCenter": "₱29,702",
      "monthlyPass": "₱902",
      "utilitiesBasic": "₱6,895"
    }
  },
  {
    "name": "Taipei",
    "country": "Taiwan",
    "costOfLivingIndex": 45.3,
    "rentIndex": 18.6,
    "groceriesIndex": 59,
    "restaurantIndex": 25,
    "purchasingPowerIndex": 79.5,
    "safetyIndex": 84.1,
    "climateIndex": 75.1,
    "healthcareIndex": 89.4,
    "trafficEfficiencyIndex": 78.1,
    "pollutionControlIndex": 58.2,
    "internetSpeedIndex": 95.3,
    "typicalExpenses": {
      "mealInexpensive": "NT$156",
      "coffee": "NT$99",
      "apartment1BedCenter": "NT$20,280",
      "monthlyPass": "NT$1,248",
      "utilitiesBasic": "NT$2,496"
    }
  },
  {
    "name": "Riyadh",
    "country": "Saudi Arabia",
    "costOfLivingIndex": 49.1,
    "rentIndex": 24.6,
    "groceriesIndex": 40.1,
    "restaurantIndex": 42,
    "purchasingPowerIndex": 94.2,
    "safetyIndex": 78.5,
    "climateIndex": 45.1,
    "healthcareIndex": 71.2,
    "trafficEfficiencyIndex": 52.1,
    "pollutionControlIndex": 48.2,
    "internetSpeedIndex": 125.4,
    "typicalExpenses": {
      "mealInexpensive": "SAR 31.20",
      "coffee": "SAR 18.72",
      "apartment1BedCenter": "SAR 4,368",
      "monthlyPass": "SAR 156.00",
      "utilitiesBasic": "SAR 468.00"
    }
  },
  {
    "name": "Abu Dhabi",
    "country": "United Arab Emirates",
    "costOfLivingIndex": 67.4,
    "rentIndex": 51.1,
    "groceriesIndex": 48,
    "restaurantIndex": 59.4,
    "purchasingPowerIndex": 115.4,
    "safetyIndex": 87.1,
    "climateIndex": 43.4,
    "healthcareIndex": 78.2,
    "trafficEfficiencyIndex": 84.1,
    "pollutionControlIndex": 68.2,
    "internetSpeedIndex": 94.6,
    "typicalExpenses": {
      "mealInexpensive": "AED 41.60",
      "coffee": "AED 21.84",
      "apartment1BedCenter": "AED 6,448",
      "monthlyPass": "AED 228.80",
      "utilitiesBasic": "AED 676.00"
    }
  },
  {
    "name": "Athens",
    "country": "Greece",
    "costOfLivingIndex": 50.4,
    "rentIndex": 18.8,
    "groceriesIndex": 42.7,
    "restaurantIndex": 42,
    "purchasingPowerIndex": 48.9,
    "safetyIndex": 54.2,
    "climateIndex": 91.2,
    "healthcareIndex": 69.1,
    "trafficEfficiencyIndex": 48.5,
    "pollutionControlIndex": 51.4,
    "internetSpeedIndex": 81.2,
    "typicalExpenses": {
      "mealInexpensive": "€12.48",
      "coffee": "€3.64",
      "apartment1BedCenter": "€572",
      "monthlyPass": "€31.20",
      "utilitiesBasic": "€161.20"
    }
  },
  {
    "name": "Budapest",
    "country": "Hungary",
    "costOfLivingIndex": 45.3,
    "rentIndex": 18.5,
    "groceriesIndex": 39.1,
    "restaurantIndex": 40,
    "purchasingPowerIndex": 51.5,
    "safetyIndex": 68.4,
    "climateIndex": 78.5,
    "healthcareIndex": 52.4,
    "trafficEfficiencyIndex": 54.2,
    "pollutionControlIndex": 58.1,
    "internetSpeedIndex": 122.5,
    "typicalExpenses": {
      "mealInexpensive": "Ft 4,243",
      "coffee": "Ft 1,008",
      "apartment1BedCenter": "Ft 254,592",
      "monthlyPass": "Ft 10,078",
      "utilitiesBasic": "Ft 58,344"
    }
  },
  {
    "name": "Dublin",
    "country": "Ireland",
    "costOfLivingIndex": 80,
    "rentIndex": 66.7,
    "groceriesIndex": 62.1,
    "restaurantIndex": 76.3,
    "purchasingPowerIndex": 93.5,
    "safetyIndex": 51.4,
    "climateIndex": 81.2,
    "healthcareIndex": 68.2,
    "trafficEfficiencyIndex": 39.1,
    "pollutionControlIndex": 69.4,
    "internetSpeedIndex": 91.2,
    "typicalExpenses": {
      "mealInexpensive": "€18.72",
      "coffee": "€4.11",
      "apartment1BedCenter": "€2,028",
      "monthlyPass": "€119.60",
      "utilitiesBasic": "€205.92"
    }
  },
  {
    "name": "Geneva",
    "country": "Switzerland",
    "costOfLivingIndex": 120.5,
    "rentIndex": 83.7,
    "groceriesIndex": 116.2,
    "restaurantIndex": 113.6,
    "purchasingPowerIndex": 112.4,
    "safetyIndex": 71.8,
    "climateIndex": 80.5,
    "healthcareIndex": 83.6,
    "trafficEfficiencyIndex": 68.2,
    "pollutionControlIndex": 84.1,
    "internetSpeedIndex": 94.1,
    "typicalExpenses": {
      "mealInexpensive": "CHF 29.12",
      "coffee": "CHF 5.72",
      "apartment1BedCenter": "CHF 2,184",
      "monthlyPass": "CHF 78.00",
      "utilitiesBasic": "CHF 249.60"
    }
  },
  {
    "name": "Edinburgh",
    "country": "United Kingdom",
    "costOfLivingIndex": 67,
    "rentIndex": 42.9,
    "groceriesIndex": 60.3,
    "restaurantIndex": 68.5,
    "purchasingPowerIndex": 88.9,
    "safetyIndex": 64.2,
    "climateIndex": 81.2,
    "healthcareIndex": 73.4,
    "trafficEfficiencyIndex": 58.1,
    "pollutionControlIndex": 74.8,
    "internetSpeedIndex": 86.4,
    "typicalExpenses": {
      "mealInexpensive": "£16.64",
      "coffee": "£3.95",
      "apartment1BedCenter": "£1,404",
      "monthlyPass": "£67.60",
      "utilitiesBasic": "£197.60"
    }
  },
  {
    "name": "Miami",
    "country": "United States",
    "costOfLivingIndex": 84,
    "rentIndex": 74.3,
    "groceriesIndex": 85.4,
    "restaurantIndex": 83.9,
    "purchasingPowerIndex": 92.1,
    "safetyIndex": 52.4,
    "climateIndex": 81.2,
    "healthcareIndex": 68.9,
    "trafficEfficiencyIndex": 42.1,
    "pollutionControlIndex": 59.4,
    "internetSpeedIndex": 93.6,
    "typicalExpenses": {
      "mealInexpensive": "$22.30",
      "coffee": "$5.40",
      "apartment1BedCenter": "$2,811",
      "monthlyPass": "$119",
      "utilitiesBasic": "$178"
    }
  },
  {
    "name": "Tirana",
    "country": "Albania",
    "costOfLivingIndex": 36.9,
    "rentIndex": 14.8,
    "groceriesIndex": 32.3,
    "restaurantIndex": 27,
    "purchasingPowerIndex": 35.1,
    "safetyIndex": 61.2,
    "climateIndex": 84.1,
    "healthcareIndex": 50.1,
    "trafficEfficiencyIndex": 32.4,
    "pollutionControlIndex": 44.1,
    "internetSpeedIndex": 82.4,
    "typicalExpenses": {
      "mealInexpensive": "Lek 690",
      "coffee": "Lek 159",
      "apartment1BedCenter": "Lek 44,554",
      "monthlyPass": "Lek 1,697",
      "utilitiesBasic": "Lek 10,078"
    }
  },
  {
    "name": "Andorra la Vella",
    "country": "Andorra",
    "costOfLivingIndex": 62.3,
    "rentIndex": 29.1,
    "groceriesIndex": 53.2,
    "restaurantIndex": 56.2,
    "purchasingPowerIndex": 82.4,
    "safetyIndex": 88.4,
    "climateIndex": 84.1,
    "healthcareIndex": 84.5,
    "trafficEfficiencyIndex": 71.2,
    "pollutionControlIndex": 85.2,
    "internetSpeedIndex": 120.4,
    "typicalExpenses": {
      "mealInexpensive": "€14.30",
      "coffee": "€2.10",
      "apartment1BedCenter": "€918",
      "monthlyPass": "€32.60",
      "utilitiesBasic": "€128"
    }
  },
  {
    "name": "Luanda",
    "country": "Angola",
    "costOfLivingIndex": 47.4,
    "rentIndex": 32.6,
    "groceriesIndex": 42.8,
    "restaurantIndex": 40.8,
    "purchasingPowerIndex": 22.4,
    "safetyIndex": 38,
    "climateIndex": 72,
    "healthcareIndex": 39,
    "trafficEfficiencyIndex": 30,
    "pollutionControlIndex": 28,
    "internetSpeedIndex": 35,
    "typicalExpenses": {
      "mealInexpensive": "Kz 14.50",
      "coffee": "Kz 3.60",
      "apartment1BedCenter": "Kz 1,120",
      "monthlyPass": "Kz 36.40",
      "utilitiesBasic": "Kz 98.80"
    }
  },
  {
    "name": "Cordoba",
    "country": "Argentina",
    "costOfLivingIndex": 30.1,
    "rentIndex": 11.7,
    "groceriesIndex": 27,
    "restaurantIndex": 24,
    "purchasingPowerIndex": 31.6,
    "safetyIndex": 48,
    "climateIndex": 82,
    "healthcareIndex": 65,
    "trafficEfficiencyIndex": 52,
    "pollutionControlIndex": 58,
    "internetSpeedIndex": 60,
    "typicalExpenses": {
      "mealInexpensive": "ARS$ 6.70",
      "coffee": "ARS$ 2.10",
      "apartment1BedCenter": "ARS$ 400",
      "monthlyPass": "ARS$ 18.70",
      "utilitiesBasic": "ARS$ 46.80"
    }
  },
  {
    "name": "Yerevan",
    "country": "Armenia",
    "costOfLivingIndex": 38.9,
    "rentIndex": 27,
    "groceriesIndex": 32.6,
    "restaurantIndex": 35.2,
    "purchasingPowerIndex": 37.4,
    "safetyIndex": 81.2,
    "climateIndex": 83.1,
    "healthcareIndex": 64.1,
    "trafficEfficiencyIndex": 48.2,
    "pollutionControlIndex": 44.2,
    "internetSpeedIndex": 76.5,
    "typicalExpenses": {
      "mealInexpensive": "֏ 4,243",
      "coffee": "֏ 1,273",
      "apartment1BedCenter": "֏ 297,024",
      "monthlyPass": "֏ 6,365",
      "utilitiesBasic": "֏ 47,736"
    }
  },
  {
    "name": "Brisbane",
    "country": "Australia",
    "costOfLivingIndex": 76.1,
    "rentIndex": 42.9,
    "groceriesIndex": 74.6,
    "restaurantIndex": 69.8,
    "purchasingPowerIndex": 98.4,
    "safetyIndex": 64.2,
    "climateIndex": 88.4,
    "healthcareIndex": 76.2,
    "trafficEfficiencyIndex": 51.2,
    "pollutionControlIndex": 79.5,
    "internetSpeedIndex": 115.4,
    "typicalExpenses": {
      "mealInexpensive": "A$ 24.96",
      "coffee": "A$ 5.30",
      "apartment1BedCenter": "A$ 2,496",
      "monthlyPass": "A$ 135.20",
      "utilitiesBasic": "A$ 270.40"
    }
  },
  {
    "name": "Salzburg",
    "country": "Austria",
    "costOfLivingIndex": 67.4,
    "rentIndex": 30.8,
    "groceriesIndex": 61.4,
    "restaurantIndex": 59.3,
    "purchasingPowerIndex": 91.5,
    "safetyIndex": 82.5,
    "climateIndex": 80.5,
    "healthcareIndex": 83.1,
    "trafficEfficiencyIndex": 74.3,
    "pollutionControlIndex": 85.2,
    "internetSpeedIndex": 87.1,
    "typicalExpenses": {
      "mealInexpensive": "€14.56",
      "coffee": "€4.26",
      "apartment1BedCenter": "€915",
      "monthlyPass": "€50.96",
      "utilitiesBasic": "€202.80"
    }
  },
  {
    "name": "Baku",
    "country": "Azerbaijan",
    "costOfLivingIndex": 33.1,
    "rentIndex": 14.1,
    "groceriesIndex": 27.9,
    "restaurantIndex": 25.9,
    "purchasingPowerIndex": 38.1,
    "safetyIndex": 71.4,
    "climateIndex": 82.1,
    "healthcareIndex": 51.2,
    "trafficEfficiencyIndex": 45.2,
    "pollutionControlIndex": 48.5,
    "internetSpeedIndex": 72.5,
    "typicalExpenses": {
      "mealInexpensive": "₼ 10.60",
      "coffee": "₼ 5.80",
      "apartment1BedCenter": "₼ 721",
      "monthlyPass": "₼ 21.20",
      "utilitiesBasic": "₼ 90.20"
    }
  },
  {
    "name": "Minsk",
    "country": "Belarus",
    "costOfLivingIndex": 32,
    "rentIndex": 13.8,
    "groceriesIndex": 28.9,
    "restaurantIndex": 27.7,
    "purchasingPowerIndex": 41.8,
    "safetyIndex": 71.2,
    "climateIndex": 61.4,
    "healthcareIndex": 63.8,
    "trafficEfficiencyIndex": 56.4,
    "pollutionControlIndex": 58.2,
    "internetSpeedIndex": 84.1,
    "typicalExpenses": {
      "mealInexpensive": "Br 23.50",
      "coffee": "Br 6.90",
      "apartment1BedCenter": "Br 1,008",
      "monthlyPass": "Br 47.90",
      "utilitiesBasic": "Br 149"
    }
  },
  {
    "name": "Santa Cruz",
    "country": "Bolivia",
    "costOfLivingIndex": 27.5,
    "rentIndex": 12.8,
    "groceriesIndex": 25.5,
    "restaurantIndex": 22,
    "purchasingPowerIndex": 28.6,
    "safetyIndex": 52,
    "climateIndex": 72,
    "healthcareIndex": 48,
    "trafficEfficiencyIndex": 45,
    "pollutionControlIndex": 48,
    "internetSpeedIndex": 42,
    "typicalExpenses": {
      "mealInexpensive": "Bs 5.20",
      "coffee": "Bs 2.00",
      "apartment1BedCenter": "Bs 430",
      "monthlyPass": "Bs 15.60",
      "utilitiesBasic": "Bs 43.70"
    }
  },
  {
    "name": "Sarajevo",
    "country": "Bosnia and Herzegovina",
    "costOfLivingIndex": 33,
    "rentIndex": 9.7,
    "groceriesIndex": 29.9,
    "restaurantIndex": 22.8,
    "purchasingPowerIndex": 44.8,
    "safetyIndex": 58.2,
    "climateIndex": 72.1,
    "healthcareIndex": 54.2,
    "trafficEfficiencyIndex": 41.5,
    "pollutionControlIndex": 42.5,
    "internetSpeedIndex": 92.4,
    "typicalExpenses": {
      "mealInexpensive": "KM 10.60",
      "coffee": "KM 2.70",
      "apartment1BedCenter": "KM 583",
      "monthlyPass": "KM 56.10",
      "utilitiesBasic": "KM 275"
    }
  },
  {
    "name": "Gaborone",
    "country": "Botswana",
    "costOfLivingIndex": 32.6,
    "rentIndex": 14.1,
    "groceriesIndex": 30.1,
    "restaurantIndex": 27,
    "purchasingPowerIndex": 42.8,
    "safetyIndex": 54,
    "climateIndex": 78,
    "healthcareIndex": 56,
    "trafficEfficiencyIndex": 58,
    "pollutionControlIndex": 60,
    "internetSpeedIndex": 40,
    "typicalExpenses": {
      "mealInexpensive": "P 7.30",
      "coffee": "P 2.40",
      "apartment1BedCenter": "P 470",
      "monthlyPass": "P 20.80",
      "utilitiesBasic": "P 62.40"
    }
  },
  {
    "name": "Sao Paulo",
    "country": "Brazil",
    "costOfLivingIndex": 37.1,
    "rentIndex": 15.9,
    "groceriesIndex": 32.3,
    "restaurantIndex": 31.1,
    "purchasingPowerIndex": 42.8,
    "safetyIndex": 29.8,
    "climateIndex": 85.4,
    "healthcareIndex": 61.2,
    "trafficEfficiencyIndex": 28.5,
    "pollutionControlIndex": 35.1,
    "internetSpeedIndex": 124.5,
    "typicalExpenses": {
      "mealInexpensive": "R$ 36.40",
      "coffee": "R$ 8.84",
      "apartment1BedCenter": "R$ 2,912",
      "monthlyPass": "R$ 229",
      "utilitiesBasic": "R$ 437"
    }
  },
  {
    "name": "Sofia",
    "country": "Bulgaria",
    "costOfLivingIndex": 39.2,
    "rentIndex": 13.1,
    "groceriesIndex": 36.7,
    "restaurantIndex": 33,
    "purchasingPowerIndex": 52.8,
    "safetyIndex": 58.2,
    "climateIndex": 74.2,
    "healthcareIndex": 53.6,
    "trafficEfficiencyIndex": 38.1,
    "pollutionControlIndex": 45.2,
    "internetSpeedIndex": 145.4,
    "typicalExpenses": {
      "mealInexpensive": "лв 17.30",
      "coffee": "лв 4.80",
      "apartment1BedCenter": "лв 902",
      "monthlyPass": "лв 53.00",
      "utilitiesBasic": "лв 234"
    }
  },
  {
    "name": "Phnom Penh",
    "country": "Cambodia",
    "costOfLivingIndex": 32.7,
    "rentIndex": 12.6,
    "groceriesIndex": 29.5,
    "restaurantIndex": 22.8,
    "purchasingPowerIndex": 19.5,
    "safetyIndex": 55.4,
    "climateIndex": 71.2,
    "healthcareIndex": 46.5,
    "trafficEfficiencyIndex": 41.5,
    "pollutionControlIndex": 35.1,
    "internetSpeedIndex": 34.5,
    "typicalExpenses": {
      "mealInexpensive": "$3.60",
      "coffee": "$2.20",
      "apartment1BedCenter": "$388",
      "monthlyPass": "$25.50",
      "utilitiesBasic": "$86.70"
    }
  },
  {
    "name": "Montreal",
    "country": "Canada",
    "costOfLivingIndex": 65.4,
    "rentIndex": 36.5,
    "groceriesIndex": 64,
    "restaurantIndex": 62.4,
    "purchasingPowerIndex": 88.5,
    "safetyIndex": 68.4,
    "climateIndex": 71.4,
    "healthcareIndex": 72.8,
    "trafficEfficiencyIndex": 53.4,
    "pollutionControlIndex": 70.1,
    "internetSpeedIndex": 88.5,
    "typicalExpenses": {
      "mealInexpensive": "C$21.84",
      "coffee": "C$4.68",
      "apartment1BedCenter": "C$1,508",
      "monthlyPass": "C$97.76",
      "utilitiesBasic": "C$156.00"
    }
  },
  {
    "name": "Santiago",
    "country": "Chile",
    "costOfLivingIndex": 42.2,
    "rentIndex": 16.5,
    "groceriesIndex": 39,
    "restaurantIndex": 36.8,
    "purchasingPowerIndex": 48.6,
    "safetyIndex": 42.5,
    "climateIndex": 88.5,
    "healthcareIndex": 62.4,
    "trafficEfficiencyIndex": 45.4,
    "pollutionControlIndex": 41.2,
    "internetSpeedIndex": 188.5,
    "typicalExpenses": {
      "mealInexpensive": "CLP$ 9,017",
      "coffee": "CLP$ 2,546",
      "apartment1BedCenter": "CLP$ 477,360",
      "monthlyPass": "CLP$ 38,189",
      "utilitiesBasic": "CLP$ 116,688"
    }
  },
  {
    "name": "Shenzhen",
    "country": "China",
    "costOfLivingIndex": 40.2,
    "rentIndex": 20.8,
    "groceriesIndex": 39.1,
    "restaurantIndex": 26.6,
    "purchasingPowerIndex": 62.4,
    "safetyIndex": 74.2,
    "climateIndex": 76.5,
    "healthcareIndex": 70.1,
    "trafficEfficiencyIndex": 65.4,
    "pollutionControlIndex": 58.2,
    "internetSpeedIndex": 120.4,
    "typicalExpenses": {
      "mealInexpensive": "¥36.70",
      "coffee": "¥29.60",
      "apartment1BedCenter": "¥5,834",
      "monthlyPass": "¥265",
      "utilitiesBasic": "¥477"
    }
  },
  {
    "name": "Bogota",
    "country": "Colombia",
    "costOfLivingIndex": 28.9,
    "rentIndex": 10,
    "groceriesIndex": 26.9,
    "restaurantIndex": 22.8,
    "purchasingPowerIndex": 32.1,
    "safetyIndex": 33.5,
    "climateIndex": 82.4,
    "healthcareIndex": 68.1,
    "trafficEfficiencyIndex": 18.5,
    "pollutionControlIndex": 34.2,
    "internetSpeedIndex": 90.4,
    "typicalExpenses": {
      "mealInexpensive": "COP$ 21,216",
      "coffee": "COP$ 5,834",
      "apartment1BedCenter": "COP$ 1,538,160",
      "monthlyPass": "COP$ 121,992",
      "utilitiesBasic": "COP$ 339,456"
    }
  },
  {
    "name": "San Jose",
    "country": "Costa Rica",
    "costOfLivingIndex": 49.4,
    "rentIndex": 18.6,
    "groceriesIndex": 45.8,
    "restaurantIndex": 42,
    "purchasingPowerIndex": 48.9,
    "safetyIndex": 54.1,
    "climateIndex": 89.1,
    "healthcareIndex": 78.4,
    "trafficEfficiencyIndex": 32.4,
    "pollutionControlIndex": 61.2,
    "internetSpeedIndex": 98.4,
    "typicalExpenses": {
      "mealInexpensive": "₡5,834",
      "coffee": "₡2,228",
      "apartment1BedCenter": "₡403,104",
      "monthlyPass": "₡37,128",
      "utilitiesBasic": "₡72,134"
    }
  },
  {
    "name": "Zagreb",
    "country": "Croatia",
    "costOfLivingIndex": 46,
    "rentIndex": 17.7,
    "groceriesIndex": 42.7,
    "restaurantIndex": 39.4,
    "purchasingPowerIndex": 61.2,
    "safetyIndex": 78.4,
    "climateIndex": 76.5,
    "healthcareIndex": 64.2,
    "trafficEfficiencyIndex": 42.8,
    "pollutionControlIndex": 68.4,
    "internetSpeedIndex": 110.2,
    "typicalExpenses": {
      "mealInexpensive": "€10.10",
      "coffee": "€2.20",
      "apartment1BedCenter": "€637",
      "monthlyPass": "€51.00",
      "utilitiesBasic": "€164"
    }
  },
  {
    "name": "Nicosia",
    "country": "Cyprus",
    "costOfLivingIndex": 57.4,
    "rentIndex": 26.6,
    "groceriesIndex": 48.9,
    "restaurantIndex": 52.3,
    "purchasingPowerIndex": 74.1,
    "safetyIndex": 69.1,
    "climateIndex": 88.5,
    "healthcareIndex": 71.5,
    "trafficEfficiencyIndex": 62.4,
    "pollutionControlIndex": 64.1,
    "internetSpeedIndex": 86.2,
    "typicalExpenses": {
      "mealInexpensive": "€14.56",
      "coffee": "€3.64",
      "apartment1BedCenter": "€780",
      "monthlyPass": "€41.60",
      "utilitiesBasic": "€166.40"
    }
  },
  {
    "name": "Santo Domingo",
    "country": "Dominican Republic",
    "costOfLivingIndex": 34.1,
    "rentIndex": 16.3,
    "groceriesIndex": 30.6,
    "restaurantIndex": 27.5,
    "purchasingPowerIndex": 30.6,
    "safetyIndex": 42,
    "climateIndex": 80,
    "healthcareIndex": 52,
    "trafficEfficiencyIndex": 38,
    "pollutionControlIndex": 40,
    "internetSpeedIndex": 58,
    "typicalExpenses": {
      "mealInexpensive": "RD$ 7.80",
      "coffee": "RD$ 2.30",
      "apartment1BedCenter": "RD$ 565",
      "monthlyPass": "RD$ 22.80",
      "utilitiesBasic": "RD$ 67.60"
    }
  },
  {
    "name": "Quito",
    "country": "Ecuador",
    "costOfLivingIndex": 33.1,
    "rentIndex": 11.6,
    "groceriesIndex": 28.8,
    "restaurantIndex": 24.6,
    "purchasingPowerIndex": 35.2,
    "safetyIndex": 48.2,
    "climateIndex": 91.5,
    "healthcareIndex": 64.2,
    "trafficEfficiencyIndex": 54.2,
    "pollutionControlIndex": 61.2,
    "internetSpeedIndex": 38.4,
    "typicalExpenses": {
      "mealInexpensive": "$5.10",
      "coffee": "$2.60",
      "apartment1BedCenter": "$388",
      "monthlyPass": "$22.40",
      "utilitiesBasic": "$76.50"
    }
  },
  {
    "name": "Cairo",
    "country": "Egypt",
    "costOfLivingIndex": 23.2,
    "rentIndex": 6.6,
    "groceriesIndex": 21.5,
    "restaurantIndex": 19.9,
    "purchasingPowerIndex": 14.5,
    "safetyIndex": 51.4,
    "climateIndex": 75.1,
    "healthcareIndex": 42.1,
    "trafficEfficiencyIndex": 31.4,
    "pollutionControlIndex": 28.5,
    "internetSpeedIndex": 45.1,
    "typicalExpenses": {
      "mealInexpensive": "EGP 156.00",
      "coffee": "EGP 57.20",
      "apartment1BedCenter": "EGP 6,760",
      "monthlyPass": "EGP 364.00",
      "utilitiesBasic": "EGP 1,248"
    }
  },
  {
    "name": "San Salvador",
    "country": "El Salvador",
    "costOfLivingIndex": 33.7,
    "rentIndex": 13.1,
    "groceriesIndex": 29.9,
    "restaurantIndex": 25.7,
    "purchasingPowerIndex": 24.1,
    "safetyIndex": 61.2,
    "climateIndex": 82.1,
    "healthcareIndex": 58.4,
    "trafficEfficiencyIndex": 44.5,
    "pollutionControlIndex": 48.1,
    "internetSpeedIndex": 35.2,
    "typicalExpenses": {
      "mealInexpensive": "$6.10",
      "coffee": "$2.90",
      "apartment1BedCenter": "$428",
      "monthlyPass": "$20.40",
      "utilitiesBasic": "$83.60"
    }
  },
  {
    "name": "Tallinn",
    "country": "Estonia",
    "costOfLivingIndex": 56.8,
    "rentIndex": 22.8,
    "groceriesIndex": 52.9,
    "restaurantIndex": 50.5,
    "purchasingPowerIndex": 81.2,
    "safetyIndex": 76.4,
    "climateIndex": 62.4,
    "healthcareIndex": 75.1,
    "trafficEfficiencyIndex": 65.2,
    "pollutionControlIndex": 85.4,
    "internetSpeedIndex": 160.5,
    "typicalExpenses": {
      "mealInexpensive": "€12.70",
      "coffee": "€3.40",
      "apartment1BedCenter": "€721",
      "monthlyPass": "€0.00",
      "utilitiesBasic": "€222"
    }
  },
  {
    "name": "Addis Ababa",
    "country": "Ethiopia",
    "costOfLivingIndex": 28,
    "rentIndex": 15.3,
    "groceriesIndex": 26.5,
    "restaurantIndex": 23,
    "purchasingPowerIndex": 20.4,
    "safetyIndex": 52,
    "climateIndex": 88,
    "healthcareIndex": 42,
    "trafficEfficiencyIndex": 35,
    "pollutionControlIndex": 32,
    "internetSpeedIndex": 28,
    "typicalExpenses": {
      "mealInexpensive": "ETB 5.20",
      "coffee": "ETB 1.55",
      "apartment1BedCenter": "ETB 490",
      "monthlyPass": "ETB 12.50",
      "utilitiesBasic": "ETB 36.40"
    }
  },
  {
    "name": "Lyon",
    "country": "France",
    "costOfLivingIndex": 63.6,
    "rentIndex": 29,
    "groceriesIndex": 62.1,
    "restaurantIndex": 59.3,
    "purchasingPowerIndex": 83.4,
    "safetyIndex": 54.3,
    "climateIndex": 84.2,
    "healthcareIndex": 80.5,
    "trafficEfficiencyIndex": 62.1,
    "pollutionControlIndex": 71.5,
    "internetSpeedIndex": 88.4,
    "typicalExpenses": {
      "mealInexpensive": "€14.56",
      "coffee": "€3.64",
      "apartment1BedCenter": "€884",
      "monthlyPass": "€67.60",
      "utilitiesBasic": "€174.72"
    }
  },
  {
    "name": "Tbilisi",
    "country": "Georgia",
    "costOfLivingIndex": 36,
    "rentIndex": 23.3,
    "groceriesIndex": 29.9,
    "restaurantIndex": 31.8,
    "purchasingPowerIndex": 38.1,
    "safetyIndex": 78.4,
    "climateIndex": 82.5,
    "healthcareIndex": 62.5,
    "trafficEfficiencyIndex": 46.2,
    "pollutionControlIndex": 41.5,
    "internetSpeedIndex": 78.2,
    "typicalExpenses": {
      "mealInexpensive": "₾ 26.50",
      "coffee": "₾ 8.20",
      "apartment1BedCenter": "₾ 1,697",
      "monthlyPass": "₾ 42.80",
      "utilitiesBasic": "₾ 234"
    }
  },
  {
    "name": "Frankfurt",
    "country": "Germany",
    "costOfLivingIndex": 75.4,
    "rentIndex": 46.2,
    "groceriesIndex": 62.4,
    "restaurantIndex": 62.4,
    "purchasingPowerIndex": 104.5,
    "safetyIndex": 63.1,
    "climateIndex": 79.5,
    "healthcareIndex": 81.3,
    "trafficEfficiencyIndex": 70.1,
    "pollutionControlIndex": 72.4,
    "internetSpeedIndex": 91.5,
    "typicalExpenses": {
      "mealInexpensive": "€15.60",
      "coffee": "€4.16",
      "apartment1BedCenter": "€1,227",
      "monthlyPass": "€85.28",
      "utilitiesBasic": "€280.80"
    }
  },
  {
    "name": "Accra",
    "country": "Ghana",
    "costOfLivingIndex": 29.9,
    "rentIndex": 18.6,
    "groceriesIndex": 26.9,
    "restaurantIndex": 22.5,
    "purchasingPowerIndex": 12.4,
    "safetyIndex": 58.4,
    "climateIndex": 74.2,
    "healthcareIndex": 51.5,
    "trafficEfficiencyIndex": 35.1,
    "pollutionControlIndex": 28.2,
    "internetSpeedIndex": 24.5,
    "typicalExpenses": {
      "mealInexpensive": "GH₵ 45.90",
      "coffee": "GH₵ 25.50",
      "apartment1BedCenter": "GH₵ 4,590",
      "monthlyPass": "GH₵ 326",
      "utilitiesBasic": "GH₵ 663"
    }
  },
  {
    "name": "Thessaloniki",
    "country": "Greece",
    "costOfLivingIndex": 50.4,
    "rentIndex": 16.7,
    "groceriesIndex": 44.9,
    "restaurantIndex": 42.3,
    "purchasingPowerIndex": 45.8,
    "safetyIndex": 54.2,
    "climateIndex": 86.4,
    "healthcareIndex": 58.4,
    "trafficEfficiencyIndex": 48.2,
    "pollutionControlIndex": 52.1,
    "internetSpeedIndex": 78.4,
    "typicalExpenses": {
      "mealInexpensive": "€12.70",
      "coffee": "€3.70",
      "apartment1BedCenter": "€509",
      "monthlyPass": "€31.60",
      "utilitiesBasic": "€154"
    }
  },
  {
    "name": "Guatemala City",
    "country": "Guatemala",
    "costOfLivingIndex": 35.1,
    "rentIndex": 14.4,
    "groceriesIndex": 31.7,
    "restaurantIndex": 27.3,
    "purchasingPowerIndex": 31.4,
    "safetyIndex": 42.1,
    "climateIndex": 88.4,
    "healthcareIndex": 61.5,
    "trafficEfficiencyIndex": 39.5,
    "pollutionControlIndex": 41.2,
    "internetSpeedIndex": 36.4,
    "typicalExpenses": {
      "mealInexpensive": "Q 45.90",
      "coffee": "Q 22.40",
      "apartment1BedCenter": "Q 3,876",
      "monthlyPass": "Q 153",
      "utilitiesBasic": "Q 632"
    }
  },
  {
    "name": "Tegucigalpa",
    "country": "Honduras",
    "costOfLivingIndex": 28.9,
    "rentIndex": 10.4,
    "groceriesIndex": 25.2,
    "restaurantIndex": 21.6,
    "purchasingPowerIndex": 22.4,
    "safetyIndex": 38.5,
    "climateIndex": 81.2,
    "healthcareIndex": 54.1,
    "trafficEfficiencyIndex": 41.2,
    "pollutionControlIndex": 36.2,
    "internetSpeedIndex": 28.1,
    "typicalExpenses": {
      "mealInexpensive": "L 122",
      "coffee": "L 56.10",
      "apartment1BedCenter": "L 8,670",
      "monthlyPass": "L 357",
      "utilitiesBasic": "L 1,428"
    }
  },
  {
    "name": "Reykjavik",
    "country": "Iceland",
    "costOfLivingIndex": 93.1,
    "rentIndex": 50.3,
    "groceriesIndex": 89.7,
    "restaurantIndex": 91.9,
    "purchasingPowerIndex": 86.4,
    "safetyIndex": 78.2,
    "climateIndex": 53.4,
    "healthcareIndex": 77.2,
    "trafficEfficiencyIndex": 73.1,
    "pollutionControlIndex": 89.2,
    "internetSpeedIndex": 94.6,
    "typicalExpenses": {
      "mealInexpensive": "kr 3,395",
      "coffee": "kr 721",
      "apartment1BedCenter": "kr 254,592",
      "monthlyPass": "kr 9,653",
      "utilitiesBasic": "kr 16,442"
    }
  },
  {
    "name": "Mumbai",
    "country": "India",
    "costOfLivingIndex": 24.5,
    "rentIndex": 15.5,
    "groceriesIndex": 23.1,
    "restaurantIndex": 19.9,
    "purchasingPowerIndex": 42.1,
    "safetyIndex": 53.5,
    "climateIndex": 62.4,
    "healthcareIndex": 55.1,
    "trafficEfficiencyIndex": 28.5,
    "pollutionControlIndex": 24.2,
    "internetSpeedIndex": 65.4,
    "typicalExpenses": {
      "mealInexpensive": "₹ 364.00",
      "coffee": "₹ 187.20",
      "apartment1BedCenter": "₹ 57,200",
      "monthlyPass": "₹ 468.00",
      "utilitiesBasic": "₹ 4,368"
    }
  },
  {
    "name": "Bali",
    "country": "Indonesia",
    "costOfLivingIndex": 34,
    "rentIndex": 14.8,
    "groceriesIndex": 34.7,
    "restaurantIndex": 18.9,
    "purchasingPowerIndex": 24.5,
    "safetyIndex": 58.4,
    "climateIndex": 82.1,
    "healthcareIndex": 52.4,
    "trafficEfficiencyIndex": 35.1,
    "pollutionControlIndex": 42.5,
    "internetSpeedIndex": 45.2,
    "typicalExpenses": {
      "mealInexpensive": "Rp 37,128",
      "coffee": "Rp 40,310",
      "apartment1BedCenter": "Rp 6,895,200",
      "monthlyPass": "Rp 265,200",
      "utilitiesBasic": "Rp 1,272,960"
    }
  },
  {
    "name": "Cork",
    "country": "Ireland",
    "costOfLivingIndex": 71.8,
    "rentIndex": 45.1,
    "groceriesIndex": 66.2,
    "restaurantIndex": 69.5,
    "purchasingPowerIndex": 84.1,
    "safetyIndex": 64.2,
    "climateIndex": 78.5,
    "healthcareIndex": 62.4,
    "trafficEfficiencyIndex": 54.1,
    "pollutionControlIndex": 72.4,
    "internetSpeedIndex": 92.1,
    "typicalExpenses": {
      "mealInexpensive": "€19.10",
      "coffee": "€4.00",
      "apartment1BedCenter": "€1,750",
      "monthlyPass": "€90.20",
      "utilitiesBasic": "€175"
    }
  },
  {
    "name": "Tel Aviv",
    "country": "Israel",
    "costOfLivingIndex": 83.6,
    "rentIndex": 57.5,
    "groceriesIndex": 79.7,
    "restaurantIndex": 77.7,
    "purchasingPowerIndex": 74.5,
    "safetyIndex": 71.2,
    "climateIndex": 89.2,
    "healthcareIndex": 74.1,
    "trafficEfficiencyIndex": 42.1,
    "pollutionControlIndex": 55.4,
    "internetSpeedIndex": 110.5,
    "typicalExpenses": {
      "mealInexpensive": "₪ 78.00",
      "coffee": "₪ 17.16",
      "apartment1BedCenter": "₪ 7,072",
      "monthlyPass": "₪ 234.00",
      "utilitiesBasic": "₪ 884.00"
    }
  },
  {
    "name": "Milan",
    "country": "Italy",
    "costOfLivingIndex": 75.8,
    "rentIndex": 52.4,
    "groceriesIndex": 65.1,
    "restaurantIndex": 72.9,
    "purchasingPowerIndex": 83.1,
    "safetyIndex": 46.2,
    "climateIndex": 85.4,
    "healthcareIndex": 74.8,
    "trafficEfficiencyIndex": 59.4,
    "pollutionControlIndex": 48.1,
    "internetSpeedIndex": 92.5,
    "typicalExpenses": {
      "mealInexpensive": "€20.80",
      "coffee": "€1.87",
      "apartment1BedCenter": "€1,560",
      "monthlyPass": "€40.56",
      "utilitiesBasic": "€213.20"
    }
  },
  {
    "name": "Osaka",
    "country": "Japan",
    "costOfLivingIndex": 52.3,
    "rentIndex": 20.2,
    "groceriesIndex": 54.9,
    "restaurantIndex": 33,
    "purchasingPowerIndex": 81.2,
    "safetyIndex": 79.5,
    "climateIndex": 83.1,
    "healthcareIndex": 85.2,
    "trafficEfficiencyIndex": 84.3,
    "pollutionControlIndex": 78.4,
    "internetSpeedIndex": 92.1,
    "typicalExpenses": {
      "mealInexpensive": "¥936",
      "coffee": "¥468",
      "apartment1BedCenter": "¥88,400",
      "monthlyPass": "¥9,880",
      "utilitiesBasic": "¥20,280"
    }
  },
  {
    "name": "Amman",
    "country": "Jordan",
    "costOfLivingIndex": 46.2,
    "rentIndex": 14.8,
    "groceriesIndex": 38.8,
    "restaurantIndex": 35.8,
    "purchasingPowerIndex": 38.4,
    "safetyIndex": 68.2,
    "climateIndex": 82.5,
    "healthcareIndex": 71.4,
    "trafficEfficiencyIndex": 48.5,
    "pollutionControlIndex": 45.1,
    "internetSpeedIndex": 62.1,
    "typicalExpenses": {
      "mealInexpensive": "JD 6.10",
      "coffee": "JD 3.30",
      "apartment1BedCenter": "JD 357",
      "monthlyPass": "JD 25.50",
      "utilitiesBasic": "JD 86.70"
    }
  },
  {
    "name": "Almaty",
    "country": "Kazakhstan",
    "costOfLivingIndex": 33.2,
    "rentIndex": 18.6,
    "groceriesIndex": 29,
    "restaurantIndex": 27.4,
    "purchasingPowerIndex": 39.2,
    "safetyIndex": 61.2,
    "climateIndex": 68.5,
    "healthcareIndex": 58,
    "trafficEfficiencyIndex": 48.2,
    "pollutionControlIndex": 42,
    "internetSpeedIndex": 62.4,
    "typicalExpenses": {
      "mealInexpensive": "₸ 7.80",
      "coffee": "₸ 2.70",
      "apartment1BedCenter": "₸ 670",
      "monthlyPass": "₸ 22.80",
      "utilitiesBasic": "₸ 67.60"
    }
  },
  {
    "name": "Nairobi",
    "country": "Kenya",
    "costOfLivingIndex": 30,
    "rentIndex": 9.4,
    "groceriesIndex": 28.8,
    "restaurantIndex": 22.5,
    "purchasingPowerIndex": 25.1,
    "safetyIndex": 41.2,
    "climateIndex": 94.1,
    "healthcareIndex": 53.4,
    "trafficEfficiencyIndex": 25.1,
    "pollutionControlIndex": 32.4,
    "internetSpeedIndex": 42.1,
    "typicalExpenses": {
      "mealInexpensive": "KSh 530",
      "coffee": "KSh 297",
      "apartment1BedCenter": "KSh 44,554",
      "monthlyPass": "KSh 4,243",
      "utilitiesBasic": "KSh 4,455"
    }
  },
  {
    "name": "Pristina",
    "country": "Kosovo",
    "costOfLivingIndex": 28.7,
    "rentIndex": 9.6,
    "groceriesIndex": 23.9,
    "restaurantIndex": 18.6,
    "purchasingPowerIndex": 35.1,
    "safetyIndex": 72.1,
    "climateIndex": 78.4,
    "healthcareIndex": 56.4,
    "trafficEfficiencyIndex": 62.1,
    "pollutionControlIndex": 55.4,
    "internetSpeedIndex": 68.2,
    "typicalExpenses": {
      "mealInexpensive": "€4.60",
      "coffee": "€1.20",
      "apartment1BedCenter": "€286",
      "monthlyPass": "€15.30",
      "utilitiesBasic": "€86.70"
    }
  },
  {
    "name": "Bishkek",
    "country": "Kyrgyzstan",
    "costOfLivingIndex": 26.8,
    "rentIndex": 14.4,
    "groceriesIndex": 25,
    "restaurantIndex": 21.4,
    "purchasingPowerIndex": 28.6,
    "safetyIndex": 58.5,
    "climateIndex": 72,
    "healthcareIndex": 49.2,
    "trafficEfficiencyIndex": 42,
    "pollutionControlIndex": 38,
    "internetSpeedIndex": 52,
    "typicalExpenses": {
      "mealInexpensive": "с 5.70",
      "coffee": "с 2.20",
      "apartment1BedCenter": "с 495",
      "monthlyPass": "с 12.50",
      "utilitiesBasic": "с 46.80"
    }
  },
  {
    "name": "Vientiane",
    "country": "Laos",
    "costOfLivingIndex": 21.6,
    "rentIndex": 8.6,
    "groceriesIndex": 19.8,
    "restaurantIndex": 15.5,
    "purchasingPowerIndex": 14.5,
    "safetyIndex": 68.4,
    "climateIndex": 72.1,
    "healthcareIndex": 42.1,
    "trafficEfficiencyIndex": 49.5,
    "pollutionControlIndex": 44.1,
    "internetSpeedIndex": 25.1,
    "typicalExpenses": {
      "mealInexpensive": "₭ 45,900",
      "coffee": "₭ 28,560",
      "apartment1BedCenter": "₭ 4,284,000",
      "monthlyPass": "₭ 183,600",
      "utilitiesBasic": "₭ 693,600"
    }
  },
  {
    "name": "Riga",
    "country": "Latvia",
    "costOfLivingIndex": 47.6,
    "rentIndex": 15.1,
    "groceriesIndex": 43.1,
    "restaurantIndex": 40.6,
    "purchasingPowerIndex": 62.4,
    "safetyIndex": 62.8,
    "climateIndex": 64.8,
    "healthcareIndex": 61.2,
    "trafficEfficiencyIndex": 51.4,
    "pollutionControlIndex": 74.2,
    "internetSpeedIndex": 140.2,
    "typicalExpenses": {
      "mealInexpensive": "€10.10",
      "coffee": "€3.00",
      "apartment1BedCenter": "€509",
      "monthlyPass": "€31.60",
      "utilitiesBasic": "€207"
    }
  },
  {
    "name": "Vaduz",
    "country": "Liechtenstein",
    "costOfLivingIndex": 104.2,
    "rentIndex": 59.6,
    "groceriesIndex": 105.8,
    "restaurantIndex": 100.5,
    "purchasingPowerIndex": 132.5,
    "safetyIndex": 89.2,
    "climateIndex": 72.4,
    "healthcareIndex": 86.2,
    "trafficEfficiencyIndex": 74.2,
    "pollutionControlIndex": 88.4,
    "internetSpeedIndex": 110.5,
    "typicalExpenses": {
      "mealInexpensive": "CHF 25.50",
      "coffee": "CHF 5.30",
      "apartment1BedCenter": "CHF 1,632",
      "monthlyPass": "CHF 71.40",
      "utilitiesBasic": "CHF 224"
    }
  },
  {
    "name": "Vilnius",
    "country": "Lithuania",
    "costOfLivingIndex": 50.1,
    "rentIndex": 20.8,
    "groceriesIndex": 45.5,
    "restaurantIndex": 43.4,
    "purchasingPowerIndex": 72.1,
    "safetyIndex": 71.5,
    "climateIndex": 65.4,
    "healthcareIndex": 72.8,
    "trafficEfficiencyIndex": 54.8,
    "pollutionControlIndex": 78.5,
    "internetSpeedIndex": 175.4,
    "typicalExpenses": {
      "mealInexpensive": "€10.60",
      "coffee": "€3.10",
      "apartment1BedCenter": "€690",
      "monthlyPass": "€30.60",
      "utilitiesBasic": "€175"
    }
  },
  {
    "name": "Macau",
    "country": "Macau",
    "costOfLivingIndex": 59.2,
    "rentIndex": 29,
    "groceriesIndex": 52.9,
    "restaurantIndex": 47.4,
    "purchasingPowerIndex": 78.4,
    "safetyIndex": 82.5,
    "climateIndex": 74.1,
    "healthcareIndex": 76.2,
    "trafficEfficiencyIndex": 61.2,
    "pollutionControlIndex": 62.4,
    "internetSpeedIndex": 124.5,
    "typicalExpenses": {
      "mealInexpensive": "MOP$ 81.60",
      "coffee": "MOP$ 38.80",
      "apartment1BedCenter": "MOP$ 8,670",
      "monthlyPass": "MOP$ 286",
      "utilitiesBasic": "MOP$ 1,122"
    }
  },
  {
    "name": "Penang",
    "country": "Malaysia",
    "costOfLivingIndex": 32.1,
    "rentIndex": 10.6,
    "groceriesIndex": 31,
    "restaurantIndex": 15.5,
    "purchasingPowerIndex": 48.2,
    "safetyIndex": 59.2,
    "climateIndex": 72.1,
    "healthcareIndex": 75.4,
    "trafficEfficiencyIndex": 51.2,
    "pollutionControlIndex": 54.1,
    "internetSpeedIndex": 82.1,
    "typicalExpenses": {
      "mealInexpensive": "RM 16.30",
      "coffee": "RM 12.20",
      "apartment1BedCenter": "RM 1,485",
      "monthlyPass": "RM 106",
      "utilitiesBasic": "RM 234"
    }
  },
  {
    "name": "Valletta",
    "country": "Malta",
    "costOfLivingIndex": 60.5,
    "rentIndex": 31.8,
    "groceriesIndex": 52.2,
    "restaurantIndex": 55.3,
    "purchasingPowerIndex": 68.5,
    "safetyIndex": 76.5,
    "climateIndex": 92.4,
    "healthcareIndex": 81.2,
    "trafficEfficiencyIndex": 52.1,
    "pollutionControlIndex": 64.2,
    "internetSpeedIndex": 88.5,
    "typicalExpenses": {
      "mealInexpensive": "€15.30",
      "coffee": "€2.40",
      "apartment1BedCenter": "€969",
      "monthlyPass": "€26.50",
      "utilitiesBasic": "€112"
    }
  },
  {
    "name": "Mexico City",
    "country": "Mexico",
    "costOfLivingIndex": 42.2,
    "rentIndex": 20.2,
    "groceriesIndex": 39.1,
    "restaurantIndex": 35.8,
    "purchasingPowerIndex": 42.1,
    "safetyIndex": 32.5,
    "climateIndex": 88.5,
    "healthcareIndex": 60.1,
    "trafficEfficiencyIndex": 30.5,
    "pollutionControlIndex": 38.4,
    "internetSpeedIndex": 65.2,
    "typicalExpenses": {
      "mealInexpensive": "MXN 187",
      "coffee": "MXN 68",
      "apartment1BedCenter": "MXN 17,160",
      "monthlyPass": "MXN 468",
      "utilitiesBasic": "MXN 1,456"
    }
  },
  {
    "name": "Chisinau",
    "country": "Moldova",
    "costOfLivingIndex": 32,
    "rentIndex": 12,
    "groceriesIndex": 26.8,
    "restaurantIndex": 23.6,
    "purchasingPowerIndex": 29.5,
    "safetyIndex": 68.4,
    "climateIndex": 74.2,
    "healthcareIndex": 60.1,
    "trafficEfficiencyIndex": 58.1,
    "pollutionControlIndex": 52.4,
    "internetSpeedIndex": 82.5,
    "typicalExpenses": {
      "mealInexpensive": "MDL 122",
      "coffee": "MDL 42.80",
      "apartment1BedCenter": "MDL 6,324",
      "monthlyPass": "MDL 245",
      "utilitiesBasic": "MDL 2,856"
    }
  },
  {
    "name": "Ulaanbaatar",
    "country": "Mongolia",
    "costOfLivingIndex": 27.3,
    "rentIndex": 10,
    "groceriesIndex": 24.6,
    "restaurantIndex": 19.9,
    "purchasingPowerIndex": 28.4,
    "safetyIndex": 46.5,
    "climateIndex": 38.4,
    "healthcareIndex": 49.5,
    "trafficEfficiencyIndex": 31.4,
    "pollutionControlIndex": 21.4,
    "internetSpeedIndex": 38.5,
    "typicalExpenses": {
      "mealInexpensive": "₮ 12,240",
      "coffee": "₮ 6,630",
      "apartment1BedCenter": "₮ 1,224,000",
      "monthlyPass": "₮ 30,600",
      "utilitiesBasic": "₮ 183,600"
    }
  },
  {
    "name": "Podgorica",
    "country": "Montenegro",
    "costOfLivingIndex": 39.2,
    "rentIndex": 13.1,
    "groceriesIndex": 34.7,
    "restaurantIndex": 30.1,
    "purchasingPowerIndex": 46.5,
    "safetyIndex": 65.4,
    "climateIndex": 82.4,
    "healthcareIndex": 52.1,
    "trafficEfficiencyIndex": 51.2,
    "pollutionControlIndex": 61.2,
    "internetSpeedIndex": 88.5,
    "typicalExpenses": {
      "mealInexpensive": "€8.50",
      "coffee": "€1.90",
      "apartment1BedCenter": "€446",
      "monthlyPass": "€31.60",
      "utilitiesBasic": "€122"
    }
  },
  {
    "name": "Casablanca",
    "country": "Morocco",
    "costOfLivingIndex": 33,
    "rentIndex": 11.3,
    "groceriesIndex": 30.2,
    "restaurantIndex": 25,
    "purchasingPowerIndex": 34.2,
    "safetyIndex": 46.5,
    "climateIndex": 88.1,
    "healthcareIndex": 50.4,
    "trafficEfficiencyIndex": 38.2,
    "pollutionControlIndex": 41.2,
    "internetSpeedIndex": 58.4,
    "typicalExpenses": {
      "mealInexpensive": "MAD 47.90",
      "coffee": "MAD 19.40",
      "apartment1BedCenter": "MAD 4,774",
      "monthlyPass": "MAD 159",
      "utilitiesBasic": "MAD 477"
    }
  },
  {
    "name": "Maputo",
    "country": "Mozambique",
    "costOfLivingIndex": 32.1,
    "rentIndex": 17.3,
    "groceriesIndex": 29.1,
    "restaurantIndex": 25.5,
    "purchasingPowerIndex": 21.4,
    "safetyIndex": 45,
    "climateIndex": 75,
    "healthcareIndex": 40,
    "trafficEfficiencyIndex": 36,
    "pollutionControlIndex": 38,
    "internetSpeedIndex": 35,
    "typicalExpenses": {
      "mealInexpensive": "MZN 7.50",
      "coffee": "MZN 2.30",
      "apartment1BedCenter": "MZN 595",
      "monthlyPass": "MZN 20.80",
      "utilitiesBasic": "MZN 57.20"
    }
  },
  {
    "name": "Yangon",
    "country": "Myanmar",
    "costOfLivingIndex": 21.8,
    "rentIndex": 11.4,
    "groceriesIndex": 20.4,
    "restaurantIndex": 13.8,
    "purchasingPowerIndex": 12.1,
    "safetyIndex": 48.5,
    "climateIndex": 68.2,
    "healthcareIndex": 44.5,
    "trafficEfficiencyIndex": 35.4,
    "pollutionControlIndex": 28.5,
    "internetSpeedIndex": 21.2,
    "typicalExpenses": {
      "mealInexpensive": "K 4,590",
      "coffee": "K 2,856",
      "apartment1BedCenter": "K 591,600",
      "monthlyPass": "K 18,360",
      "utilitiesBasic": "K 66,300"
    }
  },
  {
    "name": "Windhoek",
    "country": "Namibia",
    "costOfLivingIndex": 34.2,
    "rentIndex": 15.5,
    "groceriesIndex": 31.6,
    "restaurantIndex": 29.6,
    "purchasingPowerIndex": 38.8,
    "safetyIndex": 56,
    "climateIndex": 80,
    "healthcareIndex": 58,
    "trafficEfficiencyIndex": 62,
    "pollutionControlIndex": 65,
    "internetSpeedIndex": 45,
    "typicalExpenses": {
      "mealInexpensive": "N$ 7.80",
      "coffee": "N$ 2.50",
      "apartment1BedCenter": "N$ 510",
      "monthlyPass": "N$ 22.90",
      "utilitiesBasic": "N$ 72.80"
    }
  },
  {
    "name": "Kathmandu",
    "country": "Nepal",
    "costOfLivingIndex": 21.2,
    "rentIndex": 5.2,
    "groceriesIndex": 18.7,
    "restaurantIndex": 13.1,
    "purchasingPowerIndex": 16.4,
    "safetyIndex": 66.2,
    "climateIndex": 82.4,
    "healthcareIndex": 51.2,
    "trafficEfficiencyIndex": 32.4,
    "pollutionControlIndex": 22.4,
    "internetSpeedIndex": 22.5,
    "typicalExpenses": {
      "mealInexpensive": "NPR 326",
      "coffee": "NPR 184",
      "apartment1BedCenter": "NPR 22,440",
      "monthlyPass": "NPR 1,224",
      "utilitiesBasic": "NPR 4,284"
    }
  },
  {
    "name": "Rotterdam",
    "country": "Netherlands",
    "costOfLivingIndex": 71.1,
    "rentIndex": 40.3,
    "groceriesIndex": 60,
    "restaurantIndex": 66.7,
    "purchasingPowerIndex": 98.4,
    "safetyIndex": 69.2,
    "climateIndex": 81.2,
    "healthcareIndex": 80.1,
    "trafficEfficiencyIndex": 73.4,
    "pollutionControlIndex": 76.5,
    "internetSpeedIndex": 91.5,
    "typicalExpenses": {
      "mealInexpensive": "€15.60",
      "coffee": "€4.26",
      "apartment1BedCenter": "€1,248",
      "monthlyPass": "€82.16",
      "utilitiesBasic": "€192.40"
    }
  },
  {
    "name": "Auckland",
    "country": "New Zealand",
    "costOfLivingIndex": 73.8,
    "rentIndex": 39.2,
    "groceriesIndex": 72.5,
    "restaurantIndex": 67.5,
    "purchasingPowerIndex": 89.4,
    "safetyIndex": 54.8,
    "climateIndex": 86.2,
    "healthcareIndex": 72.8,
    "trafficEfficiencyIndex": 44.1,
    "pollutionControlIndex": 78.4,
    "internetSpeedIndex": 145.2,
    "typicalExpenses": {
      "mealInexpensive": "NZ$ 26.00",
      "coffee": "NZ$ 5.72",
      "apartment1BedCenter": "NZ$ 2,288",
      "monthlyPass": "NZ$ 187.20",
      "utilitiesBasic": "NZ$ 228.80"
    }
  },
  {
    "name": "Managua",
    "country": "Nicaragua",
    "costOfLivingIndex": 27.7,
    "rentIndex": 9.7,
    "groceriesIndex": 23.8,
    "restaurantIndex": 20.2,
    "purchasingPowerIndex": 18.5,
    "safetyIndex": 52.4,
    "climateIndex": 80.5,
    "healthcareIndex": 52.4,
    "trafficEfficiencyIndex": 43.1,
    "pollutionControlIndex": 39.5,
    "internetSpeedIndex": 26.4,
    "typicalExpenses": {
      "mealInexpensive": "C$ 184",
      "coffee": "C$ 71.40",
      "apartment1BedCenter": "C$ 11,220",
      "monthlyPass": "C$ 428",
      "utilitiesBasic": "C$ 1,836"
    }
  },
  {
    "name": "Lagos",
    "country": "Nigeria",
    "costOfLivingIndex": 19.7,
    "rentIndex": 10.7,
    "groceriesIndex": 18.8,
    "restaurantIndex": 15.5,
    "purchasingPowerIndex": 12.1,
    "safetyIndex": 31.4,
    "climateIndex": 65.4,
    "healthcareIndex": 38.5,
    "trafficEfficiencyIndex": 12.4,
    "pollutionControlIndex": 15.4,
    "internetSpeedIndex": 35.2,
    "typicalExpenses": {
      "mealInexpensive": "₦2,652",
      "coffee": "₦1,591",
      "apartment1BedCenter": "₦371,280",
      "monthlyPass": "₦19,094",
      "utilitiesBasic": "₦26,520"
    }
  },
  {
    "name": "Skopje",
    "country": "North Macedonia",
    "costOfLivingIndex": 32.1,
    "rentIndex": 9,
    "groceriesIndex": 28.8,
    "restaurantIndex": 21.9,
    "purchasingPowerIndex": 38.9,
    "safetyIndex": 59.4,
    "climateIndex": 76.2,
    "healthcareIndex": 51.4,
    "trafficEfficiencyIndex": 48.5,
    "pollutionControlIndex": 32.4,
    "internetSpeedIndex": 84.5,
    "typicalExpenses": {
      "mealInexpensive": "ден 265",
      "coffee": "ден 95.90",
      "apartment1BedCenter": "ден 15,382",
      "monthlyPass": "ден 1,697",
      "utilitiesBasic": "ден 7,213"
    }
  },
  {
    "name": "Bergen",
    "country": "Norway",
    "costOfLivingIndex": 82.7,
    "rentIndex": 33.2,
    "groceriesIndex": 79.6,
    "restaurantIndex": 75.7,
    "purchasingPowerIndex": 86.5,
    "safetyIndex": 79.2,
    "climateIndex": 48.5,
    "healthcareIndex": 78.1,
    "trafficEfficiencyIndex": 68.4,
    "pollutionControlIndex": 84.1,
    "internetSpeedIndex": 105.2,
    "typicalExpenses": {
      "mealInexpensive": "kr 202",
      "coffee": "kr 51.00",
      "apartment1BedCenter": "kr 12,199",
      "monthlyPass": "kr 827",
      "utilitiesBasic": "kr 1,538"
    }
  },
  {
    "name": "Panama City",
    "country": "Panama",
    "costOfLivingIndex": 47,
    "rentIndex": 26.9,
    "groceriesIndex": 42.7,
    "restaurantIndex": 39.3,
    "purchasingPowerIndex": 51.4,
    "safetyIndex": 56.4,
    "climateIndex": 74.2,
    "healthcareIndex": 64.1,
    "trafficEfficiencyIndex": 38.2,
    "pollutionControlIndex": 51.4,
    "internetSpeedIndex": 112.5,
    "typicalExpenses": {
      "mealInexpensive": "$10.60",
      "coffee": "$4.00",
      "apartment1BedCenter": "$902",
      "monthlyPass": "$37.10",
      "utilitiesBasic": "$117"
    }
  },
  {
    "name": "Asuncion",
    "country": "Paraguay",
    "costOfLivingIndex": 28.8,
    "rentIndex": 13.3,
    "groceriesIndex": 26.5,
    "restaurantIndex": 23.3,
    "purchasingPowerIndex": 30.6,
    "safetyIndex": 50,
    "climateIndex": 70,
    "healthcareIndex": 50,
    "trafficEfficiencyIndex": 46,
    "pollutionControlIndex": 52,
    "internetSpeedIndex": 48,
    "typicalExpenses": {
      "mealInexpensive": "₲ 5.70",
      "coffee": "₲ 2.10",
      "apartment1BedCenter": "₲ 450",
      "monthlyPass": "₲ 18.70",
      "utilitiesBasic": "₲ 46.80"
    }
  },
  {
    "name": "Lima",
    "country": "Peru",
    "costOfLivingIndex": 33.1,
    "rentIndex": 12,
    "groceriesIndex": 30.9,
    "restaurantIndex": 26.3,
    "purchasingPowerIndex": 35.4,
    "safetyIndex": 30.1,
    "climateIndex": 86.4,
    "healthcareIndex": 51.5,
    "trafficEfficiencyIndex": 20.4,
    "pollutionControlIndex": 28.5,
    "internetSpeedIndex": 85.2,
    "typicalExpenses": {
      "mealInexpensive": "S/ 23.90",
      "coffee": "S/ 10.60",
      "apartment1BedCenter": "S/ 1,856",
      "monthlyPass": "S/ 128",
      "utilitiesBasic": "S/ 297"
    }
  },
  {
    "name": "Cebu",
    "country": "Philippines",
    "costOfLivingIndex": 30,
    "rentIndex": 11.4,
    "groceriesIndex": 28.9,
    "restaurantIndex": 16.7,
    "purchasingPowerIndex": 24.1,
    "safetyIndex": 54.2,
    "climateIndex": 65.4,
    "healthcareIndex": 58.1,
    "trafficEfficiencyIndex": 32.1,
    "pollutionControlIndex": 31.4,
    "internetSpeedIndex": 52.1,
    "typicalExpenses": {
      "mealInexpensive": "₱191",
      "coffee": "₱138",
      "apartment1BedCenter": "₱19,094",
      "monthlyPass": "₱1,273",
      "utilitiesBasic": "₱5,092"
    }
  },
  {
    "name": "Krakow",
    "country": "Poland",
    "costOfLivingIndex": 42.2,
    "rentIndex": 21.6,
    "groceriesIndex": 35.6,
    "restaurantIndex": 37.5,
    "purchasingPowerIndex": 70.4,
    "safetyIndex": 76.5,
    "climateIndex": 79.1,
    "healthcareIndex": 67.2,
    "trafficEfficiencyIndex": 68.2,
    "pollutionControlIndex": 58.1,
    "internetSpeedIndex": 89.1,
    "typicalExpenses": {
      "mealInexpensive": "zł 36.70",
      "coffee": "zł 14.30",
      "apartment1BedCenter": "zł 2,864",
      "monthlyPass": "zł 116",
      "utilitiesBasic": "zł 859"
    }
  },
  {
    "name": "Porto",
    "country": "Portugal",
    "costOfLivingIndex": 46.6,
    "rentIndex": 28.7,
    "groceriesIndex": 38.8,
    "restaurantIndex": 39.4,
    "purchasingPowerIndex": 59.5,
    "safetyIndex": 72.8,
    "climateIndex": 91.5,
    "healthcareIndex": 76.5,
    "trafficEfficiencyIndex": 64.3,
    "pollutionControlIndex": 76.2,
    "internetSpeedIndex": 89.4,
    "typicalExpenses": {
      "mealInexpensive": "€10.40",
      "coffee": "€1.35",
      "apartment1BedCenter": "€853",
      "monthlyPass": "€36.40",
      "utilitiesBasic": "€119.60"
    }
  },
  {
    "name": "Bucharest",
    "country": "Romania",
    "costOfLivingIndex": 39.9,
    "rentIndex": 14.8,
    "groceriesIndex": 36.3,
    "restaurantIndex": 34.9,
    "purchasingPowerIndex": 56.4,
    "safetyIndex": 71.4,
    "climateIndex": 72.1,
    "healthcareIndex": 55.4,
    "trafficEfficiencyIndex": 32.1,
    "pollutionControlIndex": 42.5,
    "internetSpeedIndex": 185.2,
    "typicalExpenses": {
      "mealInexpensive": "lei 47.90",
      "coffee": "lei 15.30",
      "apartment1BedCenter": "lei 2,546",
      "monthlyPass": "lei 84.70",
      "utilitiesBasic": "lei 690"
    }
  },
  {
    "name": "Saint Petersburg",
    "country": "Russia",
    "costOfLivingIndex": 40.1,
    "rentIndex": 16.5,
    "groceriesIndex": 34.7,
    "restaurantIndex": 36.8,
    "purchasingPowerIndex": 51.4,
    "safetyIndex": 60.5,
    "climateIndex": 45.2,
    "healthcareIndex": 66.4,
    "trafficEfficiencyIndex": 65.1,
    "pollutionControlIndex": 51.3,
    "internetSpeedIndex": 88.4,
    "typicalExpenses": {
      "mealInexpensive": "₽849",
      "coffee": "₽234",
      "apartment1BedCenter": "₽50,918",
      "monthlyPass": "₽2,546",
      "utilitiesBasic": "₽8,699"
    }
  },
  {
    "name": "Kigali",
    "country": "Rwanda",
    "costOfLivingIndex": 23.9,
    "rentIndex": 9.3,
    "groceriesIndex": 21.5,
    "restaurantIndex": 16.7,
    "purchasingPowerIndex": 15.4,
    "safetyIndex": 76.4,
    "climateIndex": 84.2,
    "healthcareIndex": 62.4,
    "trafficEfficiencyIndex": 48.5,
    "pollutionControlIndex": 42.1,
    "internetSpeedIndex": 22.1,
    "typicalExpenses": {
      "mealInexpensive": "RWF 3,570",
      "coffee": "RWF 2,244",
      "apartment1BedCenter": "RWF 357,000",
      "monthlyPass": "RWF 15,300",
      "utilitiesBasic": "RWF 45,900"
    }
  },
  {
    "name": "San Marino",
    "country": "San Marino",
    "costOfLivingIndex": 59.1,
    "rentIndex": 21.8,
    "groceriesIndex": 52.9,
    "restaurantIndex": 52.5,
    "purchasingPowerIndex": 78.5,
    "safetyIndex": 86.4,
    "climateIndex": 82.4,
    "healthcareIndex": 82.1,
    "trafficEfficiencyIndex": 68.5,
    "pollutionControlIndex": 81.4,
    "internetSpeedIndex": 94.2,
    "typicalExpenses": {
      "mealInexpensive": "€15.30",
      "coffee": "€1.80",
      "apartment1BedCenter": "€714",
      "monthlyPass": "€38.80",
      "utilitiesBasic": "€143"
    }
  },
  {
    "name": "Jeddah",
    "country": "Saudi Arabia",
    "costOfLivingIndex": 47,
    "rentIndex": 18.9,
    "groceriesIndex": 42.7,
    "restaurantIndex": 33,
    "purchasingPowerIndex": 82.5,
    "safetyIndex": 78.4,
    "climateIndex": 52.1,
    "healthcareIndex": 71.4,
    "trafficEfficiencyIndex": 61.2,
    "pollutionControlIndex": 64.2,
    "internetSpeedIndex": 98.2,
    "typicalExpenses": {
      "mealInexpensive": "SAR 36.70",
      "coffee": "SAR 19.40",
      "apartment1BedCenter": "SAR 2,546",
      "monthlyPass": "SAR 159",
      "utilitiesBasic": "SAR 446"
    }
  },
  {
    "name": "Dakar",
    "country": "Senegal",
    "costOfLivingIndex": 34.8,
    "rentIndex": 16.8,
    "groceriesIndex": 32.6,
    "restaurantIndex": 26.9,
    "purchasingPowerIndex": 15.8,
    "safetyIndex": 52.1,
    "climateIndex": 78.4,
    "healthcareIndex": 48.5,
    "trafficEfficiencyIndex": 38.2,
    "pollutionControlIndex": 31.4,
    "internetSpeedIndex": 28.5,
    "typicalExpenses": {
      "mealInexpensive": "CFA 3,570",
      "coffee": "CFA 1,836",
      "apartment1BedCenter": "CFA 285,600",
      "monthlyPass": "CFA 18,360",
      "utilitiesBasic": "CFA 76,500"
    }
  },
  {
    "name": "Belgrade",
    "country": "Serbia",
    "costOfLivingIndex": 42.9,
    "rentIndex": 21.8,
    "groceriesIndex": 34.7,
    "restaurantIndex": 36.5,
    "purchasingPowerIndex": 45.4,
    "safetyIndex": 63.5,
    "climateIndex": 82.1,
    "healthcareIndex": 61.2,
    "trafficEfficiencyIndex": 50.4,
    "pollutionControlIndex": 44.5,
    "internetSpeedIndex": 86.4,
    "typicalExpenses": {
      "mealInexpensive": "RSD 1,167",
      "coffee": "RSD 297",
      "apartment1BedCenter": "RSD 74,256",
      "monthlyPass": "RSD 3,501",
      "utilitiesBasic": "RSD 17,503"
    }
  },
  {
    "name": "Bratislava",
    "country": "Slovakia",
    "costOfLivingIndex": 49.5,
    "rentIndex": 21.6,
    "groceriesIndex": 46.1,
    "restaurantIndex": 42.9,
    "purchasingPowerIndex": 68.5,
    "safetyIndex": 68.2,
    "climateIndex": 73.8,
    "healthcareIndex": 58.5,
    "trafficEfficiencyIndex": 48.1,
    "pollutionControlIndex": 62.4,
    "internetSpeedIndex": 125.8,
    "typicalExpenses": {
      "mealInexpensive": "€10.60",
      "coffee": "€2.60",
      "apartment1BedCenter": "€743",
      "monthlyPass": "€31.60",
      "utilitiesBasic": "€202"
    }
  },
  {
    "name": "Ljubljana",
    "country": "Slovenia",
    "costOfLivingIndex": 53.3,
    "rentIndex": 23.3,
    "groceriesIndex": 49.6,
    "restaurantIndex": 47.1,
    "purchasingPowerIndex": 74.3,
    "safetyIndex": 82.1,
    "climateIndex": 79.1,
    "healthcareIndex": 70.4,
    "trafficEfficiencyIndex": 55.4,
    "pollutionControlIndex": 81.2,
    "internetSpeedIndex": 135.6,
    "typicalExpenses": {
      "mealInexpensive": "€11.70",
      "coffee": "€2.40",
      "apartment1BedCenter": "€796",
      "monthlyPass": "€38.80",
      "utilitiesBasic": "€191"
    }
  },
  {
    "name": "Cape Town",
    "country": "South Africa",
    "costOfLivingIndex": 39.1,
    "rentIndex": 18.6,
    "groceriesIndex": 33,
    "restaurantIndex": 35.8,
    "purchasingPowerIndex": 56.2,
    "safetyIndex": 45.1,
    "climateIndex": 92.4,
    "healthcareIndex": 68.2,
    "trafficEfficiencyIndex": 48.5,
    "pollutionControlIndex": 65.4,
    "internetSpeedIndex": 55.1,
    "typicalExpenses": {
      "mealInexpensive": "R 156.00",
      "coffee": "R 36.40",
      "apartment1BedCenter": "R 11,960",
      "monthlyPass": "R 644.80",
      "utilitiesBasic": "R 1,508"
    }
  },
  {
    "name": "Busan",
    "country": "South Korea",
    "costOfLivingIndex": 62.3,
    "rentIndex": 18.9,
    "groceriesIndex": 77.6,
    "restaurantIndex": 37.1,
    "purchasingPowerIndex": 78.1,
    "safetyIndex": 74.1,
    "climateIndex": 82.1,
    "healthcareIndex": 86.4,
    "trafficEfficiencyIndex": 81.2,
    "pollutionControlIndex": 51.4,
    "internetSpeedIndex": 96.2,
    "typicalExpenses": {
      "mealInexpensive": "₩8,320",
      "coffee": "₩4,680",
      "apartment1BedCenter": "₩676,000",
      "monthlyPass": "₩52,000",
      "utilitiesBasic": "₩156,000"
    }
  },
  {
    "name": "Valencia",
    "country": "Spain",
    "costOfLivingIndex": 52.1,
    "rentIndex": 27,
    "groceriesIndex": 43.7,
    "restaurantIndex": 45.7,
    "purchasingPowerIndex": 81.3,
    "safetyIndex": 74.5,
    "climateIndex": 92.4,
    "healthcareIndex": 83.4,
    "trafficEfficiencyIndex": 75.1,
    "pollutionControlIndex": 72.1,
    "internetSpeedIndex": 91.1,
    "typicalExpenses": {
      "mealInexpensive": "€11.44",
      "coffee": "€1.98",
      "apartment1BedCenter": "€811",
      "monthlyPass": "€36.40",
      "utilitiesBasic": "€124.80"
    }
  },
  {
    "name": "Colombo",
    "country": "Sri Lanka",
    "costOfLivingIndex": 21.9,
    "rentIndex": 7.3,
    "groceriesIndex": 22.7,
    "restaurantIndex": 14.8,
    "purchasingPowerIndex": 18.2,
    "safetyIndex": 62.1,
    "climateIndex": 64.2,
    "healthcareIndex": 66.5,
    "trafficEfficiencyIndex": 42.1,
    "pollutionControlIndex": 38.4,
    "internetSpeedIndex": 32.5,
    "typicalExpenses": {
      "mealInexpensive": "Rs 714",
      "coffee": "Rs 663",
      "apartment1BedCenter": "Rs 96,900",
      "monthlyPass": "Rs 3,570",
      "utilitiesBasic": "Rs 16,320"
    }
  },
  {
    "name": "Gothenburg",
    "country": "Sweden",
    "costOfLivingIndex": 66.3,
    "rentIndex": 30.1,
    "groceriesIndex": 60.3,
    "restaurantIndex": 59.4,
    "purchasingPowerIndex": 91.3,
    "safetyIndex": 61.5,
    "climateIndex": 75.1,
    "healthcareIndex": 80.4,
    "trafficEfficiencyIndex": 68.2,
    "pollutionControlIndex": 82.1,
    "internetSpeedIndex": 93.4,
    "typicalExpenses": {
      "mealInexpensive": "kr 138",
      "coffee": "kr 41.80",
      "apartment1BedCenter": "kr 9,759",
      "monthlyPass": "kr 885",
      "utilitiesBasic": "kr 1,114"
    }
  },
  {
    "name": "Basel",
    "country": "Switzerland",
    "costOfLivingIndex": 117.5,
    "rentIndex": 62.8,
    "groceriesIndex": 101.3,
    "restaurantIndex": 94.5,
    "purchasingPowerIndex": 73.3,
    "safetyIndex": 78.2,
    "climateIndex": 80.1,
    "healthcareIndex": 84.1,
    "trafficEfficiencyIndex": 77,
    "pollutionControlIndex": 60.6,
    "internetSpeedIndex": 93.1,
    "typicalExpenses": {
      "mealInexpensive": "CHF 20.80",
      "coffee": "CHF 5.20",
      "apartment1BedCenter": "CHF 1,716",
      "monthlyPass": "CHF 109",
      "utilitiesBasic": "CHF 276"
    }
  },
  {
    "name": "Dushanbe",
    "country": "Tajikistan",
    "costOfLivingIndex": 25.3,
    "rentIndex": 12.8,
    "groceriesIndex": 23.5,
    "restaurantIndex": 19.9,
    "purchasingPowerIndex": 22.8,
    "safetyIndex": 64,
    "climateIndex": 70,
    "healthcareIndex": 45,
    "trafficEfficiencyIndex": 50,
    "pollutionControlIndex": 48,
    "internetSpeedIndex": 38,
    "typicalExpenses": {
      "mealInexpensive": "SM 5.00",
      "coffee": "SM 2.00",
      "apartment1BedCenter": "SM 430",
      "monthlyPass": "SM 10.40",
      "utilitiesBasic": "SM 41.60"
    }
  },
  {
    "name": "Dar es Salaam",
    "country": "Tanzania",
    "costOfLivingIndex": 29.1,
    "rentIndex": 14.3,
    "groceriesIndex": 27,
    "restaurantIndex": 23.5,
    "purchasingPowerIndex": 23.5,
    "safetyIndex": 49,
    "climateIndex": 70,
    "healthcareIndex": 43,
    "trafficEfficiencyIndex": 32,
    "pollutionControlIndex": 35,
    "internetSpeedIndex": 38,
    "typicalExpenses": {
      "mealInexpensive": "TZS 5.70",
      "coffee": "TZS 2.10",
      "apartment1BedCenter": "TZS 470",
      "monthlyPass": "TZS 16.60",
      "utilitiesBasic": "TZS 50.00"
    }
  },
  {
    "name": "Phuket",
    "country": "Thailand",
    "costOfLivingIndex": 36.7,
    "rentIndex": 18.9,
    "groceriesIndex": 43,
    "restaurantIndex": 24,
    "purchasingPowerIndex": 34.2,
    "safetyIndex": 61.2,
    "climateIndex": 70.1,
    "healthcareIndex": 71.3,
    "trafficEfficiencyIndex": 51.2,
    "pollutionControlIndex": 58.1,
    "internetSpeedIndex": 91.5,
    "typicalExpenses": {
      "mealInexpensive": "฿95.90",
      "coffee": "฿89.80",
      "apartment1BedCenter": "฿14,851",
      "monthlyPass": "฿1,167",
      "utilitiesBasic": "฿2,493"
    }
  },
  {
    "name": "Tunis",
    "country": "Tunisia",
    "costOfLivingIndex": 24.6,
    "rentIndex": 6.9,
    "groceriesIndex": 21.7,
    "restaurantIndex": 16.8,
    "purchasingPowerIndex": 22.1,
    "safetyIndex": 54.2,
    "climateIndex": 84.1,
    "healthcareIndex": 58.5,
    "trafficEfficiencyIndex": 52.1,
    "pollutionControlIndex": 48.2,
    "internetSpeedIndex": 18.5,
    "typicalExpenses": {
      "mealInexpensive": "DT 10.20",
      "coffee": "DT 3.60",
      "apartment1BedCenter": "DT 663",
      "monthlyPass": "DT 45.90",
      "utilitiesBasic": "DT 143"
    }
  },
  {
    "name": "Ankara",
    "country": "Turkey",
    "costOfLivingIndex": 32.7,
    "rentIndex": 12.8,
    "groceriesIndex": 29.8,
    "restaurantIndex": 24.6,
    "purchasingPowerIndex": 38.4,
    "safetyIndex": 61.2,
    "climateIndex": 78.4,
    "healthcareIndex": 72.1,
    "trafficEfficiencyIndex": 54.1,
    "pollutionControlIndex": 58.5,
    "internetSpeedIndex": 41.5,
    "typicalExpenses": {
      "mealInexpensive": "₺212",
      "coffee": "₺89.80",
      "apartment1BedCenter": "₺15,912",
      "monthlyPass": "₺658",
      "utilitiesBasic": "₺2,069"
    }
  },
  {
    "name": "Ashgabat",
    "country": "Turkmenistan",
    "costOfLivingIndex": 38.8,
    "rentIndex": 16.3,
    "groceriesIndex": 35.7,
    "restaurantIndex": 30.6,
    "purchasingPowerIndex": 25.5,
    "safetyIndex": 72,
    "climateIndex": 60,
    "healthcareIndex": 52,
    "trafficEfficiencyIndex": 65,
    "pollutionControlIndex": 60,
    "internetSpeedIndex": 32,
    "typicalExpenses": {
      "mealInexpensive": "TMT 9.35",
      "coffee": "TMT 3.00",
      "apartment1BedCenter": "TMT 565",
      "monthlyPass": "TMT 15.60",
      "utilitiesBasic": "TMT 36.40"
    }
  },
  {
    "name": "Kampala",
    "country": "Uganda",
    "costOfLivingIndex": 22.8,
    "rentIndex": 8.7,
    "groceriesIndex": 21.1,
    "restaurantIndex": 15.4,
    "purchasingPowerIndex": 14.1,
    "safetyIndex": 51.2,
    "climateIndex": 82.1,
    "healthcareIndex": 46.4,
    "trafficEfficiencyIndex": 32.1,
    "pollutionControlIndex": 24.2,
    "internetSpeedIndex": 18.4,
    "typicalExpenses": {
      "mealInexpensive": "UGX 12,240",
      "coffee": "UGX 7,650",
      "apartment1BedCenter": "UGX 1,122,000",
      "monthlyPass": "UGX 122,400",
      "utilitiesBasic": "UGX 183,600"
    }
  },
  {
    "name": "Kyiv",
    "country": "Ukraine",
    "costOfLivingIndex": 31,
    "rentIndex": 13.8,
    "groceriesIndex": 26.8,
    "restaurantIndex": 25.6,
    "purchasingPowerIndex": 44.2,
    "safetyIndex": 51.4,
    "climateIndex": 65.2,
    "healthcareIndex": 54.1,
    "trafficEfficiencyIndex": 48.2,
    "pollutionControlIndex": 45.4,
    "internetSpeedIndex": 115.4,
    "typicalExpenses": {
      "mealInexpensive": "₴318",
      "coffee": "₴74.50",
      "apartment1BedCenter": "₴19,094",
      "monthlyPass": "₴345",
      "utilitiesBasic": "₴3,713"
    }
  },
  {
    "name": "Sharjah",
    "country": "United Arab Emirates",
    "costOfLivingIndex": 49.4,
    "rentIndex": 24.6,
    "groceriesIndex": 45.2,
    "restaurantIndex": 31.8,
    "purchasingPowerIndex": 88.4,
    "safetyIndex": 84.1,
    "climateIndex": 54.2,
    "healthcareIndex": 72.5,
    "trafficEfficiencyIndex": 64.2,
    "pollutionControlIndex": 68.1,
    "internetSpeedIndex": 102.5,
    "typicalExpenses": {
      "mealInexpensive": "AED 33.70",
      "coffee": "AED 17.30",
      "apartment1BedCenter": "AED 2,970",
      "monthlyPass": "AED 234",
      "utilitiesBasic": "AED 509"
    }
  },
  {
    "name": "Manchester",
    "country": "United Kingdom",
    "costOfLivingIndex": 62.3,
    "rentIndex": 39.2,
    "groceriesIndex": 57,
    "restaurantIndex": 63.6,
    "purchasingPowerIndex": 84.2,
    "safetyIndex": 52.1,
    "climateIndex": 83.4,
    "healthcareIndex": 71.5,
    "trafficEfficiencyIndex": 54.2,
    "pollutionControlIndex": 62.1,
    "internetSpeedIndex": 85.2,
    "typicalExpenses": {
      "mealInexpensive": "£14.56",
      "coffee": "£3.74",
      "apartment1BedCenter": "£1,248",
      "monthlyPass": "£88.40",
      "utilitiesBasic": "£192.40"
    }
  },
  {
    "name": "Seattle",
    "country": "United States",
    "costOfLivingIndex": 90,
    "rentIndex": 69.6,
    "groceriesIndex": 86.4,
    "restaurantIndex": 80,
    "purchasingPowerIndex": 112.5,
    "safetyIndex": 56.4,
    "climateIndex": 82.1,
    "healthcareIndex": 79.2,
    "trafficEfficiencyIndex": 52.8,
    "pollutionControlIndex": 78.1,
    "internetSpeedIndex": 95.4,
    "typicalExpenses": {
      "mealInexpensive": "$23.30",
      "coffee": "$5.60",
      "apartment1BedCenter": "$2,387",
      "monthlyPass": "$105",
      "utilitiesBasic": "$175"
    }
  },
  {
    "name": "Montevideo",
    "country": "Uruguay",
    "costOfLivingIndex": 52.7,
    "rentIndex": 20.5,
    "groceriesIndex": 48.9,
    "restaurantIndex": 47.4,
    "purchasingPowerIndex": 46.2,
    "safetyIndex": 48.9,
    "climateIndex": 84.1,
    "healthcareIndex": 65.8,
    "trafficEfficiencyIndex": 49.5,
    "pollutionControlIndex": 58.2,
    "internetSpeedIndex": 115.4,
    "typicalExpenses": {
      "mealInexpensive": " 583",
      "coffee": " 175",
      "apartment1BedCenter": " 27,581",
      "monthlyPass": " 2,069",
      "utilitiesBasic": " 6,153"
    }
  },
  {
    "name": "Tashkent",
    "country": "Uzbekistan",
    "costOfLivingIndex": 29,
    "rentIndex": 11.4,
    "groceriesIndex": 25.8,
    "restaurantIndex": 22.5,
    "purchasingPowerIndex": 29.5,
    "safetyIndex": 78.4,
    "climateIndex": 71.2,
    "healthcareIndex": 62.5,
    "trafficEfficiencyIndex": 58.1,
    "pollutionControlIndex": 52.4,
    "internetSpeedIndex": 42.5,
    "typicalExpenses": {
      "mealInexpensive": "so'm 45,900",
      "coffee": "so'm 22,440",
      "apartment1BedCenter": "so'm 5,100,000",
      "monthlyPass": "so'm 163,200",
      "utilitiesBasic": "so'm 734,400"
    }
  },
  {
    "name": "Ho Chi Minh City",
    "country": "Vietnam",
    "costOfLivingIndex": 33.4,
    "rentIndex": 13.8,
    "groceriesIndex": 31.9,
    "restaurantIndex": 21.2,
    "purchasingPowerIndex": 31.2,
    "safetyIndex": 47.5,
    "climateIndex": 68.2,
    "healthcareIndex": 58.4,
    "trafficEfficiencyIndex": 22.1,
    "pollutionControlIndex": 24.1,
    "internetSpeedIndex": 82.4,
    "typicalExpenses": {
      "mealInexpensive": "₫53,040",
      "coffee": "₫37,128",
      "apartment1BedCenter": "₫13,790,400",
      "monthlyPass": "₫212,160",
      "utilitiesBasic": "₫1,644,240"
    }
  },
  {
    "name": "Lusaka",
    "country": "Zambia",
    "costOfLivingIndex": 29.6,
    "rentIndex": 14.8,
    "groceriesIndex": 27.5,
    "restaurantIndex": 24.5,
    "purchasingPowerIndex": 25.5,
    "safetyIndex": 48,
    "climateIndex": 82,
    "healthcareIndex": 44,
    "trafficEfficiencyIndex": 40,
    "pollutionControlIndex": 42,
    "internetSpeedIndex": 32,
    "typicalExpenses": {
      "mealInexpensive": "ZMW 6.20",
      "coffee": "ZMW 2.25",
      "apartment1BedCenter": "ZMW 460",
      "monthlyPass": "ZMW 18.70",
      "utilitiesBasic": "ZMW 52.00"
    }
  },
  {
    "name": "Harare",
    "country": "Zimbabwe",
    "costOfLivingIndex": 35.7,
    "rentIndex": 16.8,
    "groceriesIndex": 32.6,
    "restaurantIndex": 28.6,
    "purchasingPowerIndex": 18.4,
    "safetyIndex": 42,
    "climateIndex": 85,
    "healthcareIndex": 38,
    "trafficEfficiencyIndex": 38,
    "pollutionControlIndex": 35,
    "internetSpeedIndex": 30,
    "typicalExpenses": {
      "mealInexpensive": "$8.30",
      "coffee": "$2.60",
      "apartment1BedCenter": "$535",
      "monthlyPass": "$26.00",
      "utilitiesBasic": "$67.60"
    }
  },
  {
    "name": "Gyumri",
    "country": "Armenia",
    "costOfLivingIndex": 28.6,
    "rentIndex": 13.1,
    "groceriesIndex": 25.5,
    "restaurantIndex": 22.4,
    "purchasingPowerIndex": 27,
    "safetyIndex": 71,
    "climateIndex": 65,
    "healthcareIndex": 52,
    "trafficEfficiencyIndex": 60,
    "pollutionControlIndex": 62,
    "internetSpeedIndex": 58,
    "typicalExpenses": {
      "mealInexpensive": "֏ 6.20",
      "coffee": "֏ 2.05",
      "apartment1BedCenter": "֏ 430",
      "monthlyPass": "֏ 11.40",
      "utilitiesBasic": "֏ 57.20"
    }
  },
  {
    "name": "Perth",
    "country": "Australia",
    "costOfLivingIndex": 73.8,
    "rentIndex": 40.6,
    "groceriesIndex": 73.2,
    "restaurantIndex": 67.8,
    "purchasingPowerIndex": 105.4,
    "safetyIndex": 62.5,
    "climateIndex": 84.1,
    "healthcareIndex": 74.8,
    "trafficEfficiencyIndex": 56.4,
    "pollutionControlIndex": 82.1,
    "internetSpeedIndex": 110.8,
    "typicalExpenses": {
      "mealInexpensive": "A$ 23.92",
      "coffee": "A$ 5.41",
      "apartment1BedCenter": "A$ 2,340",
      "monthlyPass": "A$ 114.40",
      "utilitiesBasic": "A$ 265.20"
    }
  },
  {
    "name": "Graz",
    "country": "Austria",
    "costOfLivingIndex": 64.5,
    "rentIndex": 36.1,
    "groceriesIndex": 55.1,
    "restaurantIndex": 51.3,
    "purchasingPowerIndex": 91.4,
    "safetyIndex": 78.1,
    "climateIndex": 82.1,
    "healthcareIndex": 81.5,
    "trafficEfficiencyIndex": 67.6,
    "pollutionControlIndex": 71.9,
    "internetSpeedIndex": 86.3,
    "typicalExpenses": {
      "mealInexpensive": "€14.13",
      "coffee": "€3.58",
      "apartment1BedCenter": "€1,102",
      "monthlyPass": "€66",
      "utilitiesBasic": "€170"
    }
  },
  {
    "name": "Siem Reap",
    "country": "Cambodia",
    "costOfLivingIndex": 28.5,
    "rentIndex": 12.8,
    "groceriesIndex": 28,
    "restaurantIndex": 21.9,
    "purchasingPowerIndex": 26.5,
    "safetyIndex": 68,
    "climateIndex": 65,
    "healthcareIndex": 48,
    "trafficEfficiencyIndex": 55,
    "pollutionControlIndex": 52,
    "internetSpeedIndex": 50,
    "typicalExpenses": {
      "mealInexpensive": "$4.70",
      "coffee": "$1.90",
      "apartment1BedCenter": "$430",
      "monthlyPass": "$12.50",
      "utilitiesBasic": "$57.20"
    }
  },
  {
    "name": "Calgary",
    "country": "Canada",
    "costOfLivingIndex": 71.7,
    "rentIndex": 39.3,
    "groceriesIndex": 69.2,
    "restaurantIndex": 65.4,
    "purchasingPowerIndex": 110.5,
    "safetyIndex": 68.2,
    "climateIndex": 51.4,
    "healthcareIndex": 75.1,
    "trafficEfficiencyIndex": 62.4,
    "pollutionControlIndex": 82.5,
    "internetSpeedIndex": 135.4,
    "typicalExpenses": {
      "mealInexpensive": "C$ 22.88",
      "coffee": "C$ 5.30",
      "apartment1BedCenter": "C$ 1,820",
      "monthlyPass": "C$ 119.60",
      "utilitiesBasic": "C$ 249.60"
    }
  },
  {
    "name": "Guangzhou",
    "country": "China",
    "costOfLivingIndex": 37.1,
    "rentIndex": 16.8,
    "groceriesIndex": 35.7,
    "restaurantIndex": 22.8,
    "purchasingPowerIndex": 59.2,
    "safetyIndex": 71.5,
    "climateIndex": 75.1,
    "healthcareIndex": 68.4,
    "trafficEfficiencyIndex": 62.1,
    "pollutionControlIndex": 54.1,
    "internetSpeedIndex": 115.2,
    "typicalExpenses": {
      "mealInexpensive": "¥31.60",
      "coffee": "¥27.50",
      "apartment1BedCenter": "¥4,455",
      "monthlyPass": "¥212",
      "utilitiesBasic": "¥424"
    }
  },
  {
    "name": "Medellin",
    "country": "Colombia",
    "costOfLivingIndex": 29,
    "rentIndex": 12.3,
    "groceriesIndex": 26.8,
    "restaurantIndex": 20.6,
    "purchasingPowerIndex": 29.5,
    "safetyIndex": 44.2,
    "climateIndex": 95.4,
    "healthcareIndex": 74.2,
    "trafficEfficiencyIndex": 45.8,
    "pollutionControlIndex": 52.1,
    "internetSpeedIndex": 72.5,
    "typicalExpenses": {
      "mealInexpensive": "COP$ 19,094",
      "coffee": "COP$ 6,895",
      "apartment1BedCenter": "COP$ 1,909,440",
      "monthlyPass": "COP$ 127,296",
      "utilitiesBasic": "COP$ 339,456"
    }
  },
  {
    "name": "Limassol",
    "country": "Cyprus",
    "costOfLivingIndex": 62.5,
    "rentIndex": 47.1,
    "groceriesIndex": 57.2,
    "restaurantIndex": 55.2,
    "purchasingPowerIndex": 78.5,
    "safetyIndex": 76.5,
    "climateIndex": 91.2,
    "healthcareIndex": 68.2,
    "trafficEfficiencyIndex": 52.8,
    "pollutionControlIndex": 71.4,
    "internetSpeedIndex": 112.5,
    "typicalExpenses": {
      "mealInexpensive": "€18.00",
      "coffee": "€4.50",
      "apartment1BedCenter": "€1,538",
      "monthlyPass": "€47.90",
      "utilitiesBasic": "€175"
    }
  },
  {
    "name": "Guayaquil",
    "country": "Ecuador",
    "costOfLivingIndex": 31.1,
    "rentIndex": 14.5,
    "groceriesIndex": 28.6,
    "restaurantIndex": 25,
    "purchasingPowerIndex": 32.6,
    "safetyIndex": 35,
    "climateIndex": 68,
    "healthcareIndex": 55,
    "trafficEfficiencyIndex": 42,
    "pollutionControlIndex": 45,
    "internetSpeedIndex": 55,
    "typicalExpenses": {
      "mealInexpensive": "$6.20",
      "coffee": "$2.20",
      "apartment1BedCenter": "$490",
      "monthlyPass": "$20.80",
      "utilitiesBasic": "$52.00"
    }
  },
  {
    "name": "Marseille",
    "country": "France",
    "costOfLivingIndex": 61.2,
    "rentIndex": 33.3,
    "groceriesIndex": 50,
    "restaurantIndex": 50.2,
    "purchasingPowerIndex": 93.1,
    "safetyIndex": 39.4,
    "climateIndex": 88.5,
    "healthcareIndex": 78.2,
    "trafficEfficiencyIndex": 68.2,
    "pollutionControlIndex": 67.2,
    "internetSpeedIndex": 90.7,
    "typicalExpenses": {
      "mealInexpensive": "€13.40",
      "coffee": "€3.39",
      "apartment1BedCenter": "€1,019",
      "monthlyPass": "€62",
      "utilitiesBasic": "€161"
    }
  },
  {
    "name": "Batumi",
    "country": "Georgia",
    "costOfLivingIndex": 34.5,
    "rentIndex": 19.9,
    "groceriesIndex": 28,
    "restaurantIndex": 29.6,
    "purchasingPowerIndex": 32.6,
    "safetyIndex": 75.2,
    "climateIndex": 74,
    "healthcareIndex": 61,
    "trafficEfficiencyIndex": 55,
    "pollutionControlIndex": 58,
    "internetSpeedIndex": 65,
    "typicalExpenses": {
      "mealInexpensive": "₾ 8.80",
      "coffee": "₾ 2.60",
      "apartment1BedCenter": "₾ 695",
      "monthlyPass": "₾ 15.60",
      "utilitiesBasic": "₾ 62.40"
    }
  },
  {
    "name": "Hamburg",
    "country": "Germany",
    "costOfLivingIndex": 72.5,
    "rentIndex": 40.3,
    "groceriesIndex": 60.6,
    "restaurantIndex": 56.7,
    "purchasingPowerIndex": 78.8,
    "safetyIndex": 58.4,
    "climateIndex": 79.1,
    "healthcareIndex": 82.4,
    "trafficEfficiencyIndex": 67.8,
    "pollutionControlIndex": 72.8,
    "internetSpeedIndex": 92.2,
    "typicalExpenses": {
      "mealInexpensive": "€15.87",
      "coffee": "€4.02",
      "apartment1BedCenter": "€1,238",
      "monthlyPass": "€74",
      "utilitiesBasic": "€190"
    }
  },
  {
    "name": "New Delhi",
    "country": "India",
    "costOfLivingIndex": 22.9,
    "rentIndex": 9.7,
    "groceriesIndex": 21.5,
    "restaurantIndex": 18.5,
    "purchasingPowerIndex": 40.5,
    "safetyIndex": 42.1,
    "climateIndex": 58.1,
    "healthcareIndex": 58.2,
    "trafficEfficiencyIndex": 32.1,
    "pollutionControlIndex": 18.5,
    "internetSpeedIndex": 68.2,
    "typicalExpenses": {
      "mealInexpensive": "₹ 312.00",
      "coffee": "₹ 166.40",
      "apartment1BedCenter": "₹ 24,960",
      "monthlyPass": "₹ 416.00",
      "utilitiesBasic": "₹ 4,992"
    }
  },
  {
    "name": "Florence",
    "country": "Italy",
    "costOfLivingIndex": 63.2,
    "rentIndex": 35.3,
    "groceriesIndex": 56.2,
    "restaurantIndex": 62.5,
    "purchasingPowerIndex": 69.2,
    "safetyIndex": 59.1,
    "climateIndex": 88.5,
    "healthcareIndex": 73.4,
    "trafficEfficiencyIndex": 49.5,
    "pollutionControlIndex": 62.4,
    "internetSpeedIndex": 84.1,
    "typicalExpenses": {
      "mealInexpensive": "€16.64",
      "coffee": "€1.66",
      "apartment1BedCenter": "€988",
      "monthlyPass": "€36.40",
      "utilitiesBasic": "€174.72"
    }
  },
  {
    "name": "Kyoto",
    "country": "Japan",
    "costOfLivingIndex": 44.3,
    "rentIndex": 15.5,
    "groceriesIndex": 46.5,
    "restaurantIndex": 32.7,
    "purchasingPowerIndex": 82.5,
    "safetyIndex": 86.4,
    "climateIndex": 71.2,
    "healthcareIndex": 80.5,
    "trafficEfficiencyIndex": 75.4,
    "pollutionControlIndex": 79.1,
    "internetSpeedIndex": 95.5,
    "typicalExpenses": {
      "mealInexpensive": "¥1,061",
      "coffee": "¥477",
      "apartment1BedCenter": "¥76,378",
      "monthlyPass": "¥6,365",
      "utilitiesBasic": "¥19,625"
    }
  },
  {
    "name": "Astana",
    "country": "Kazakhstan",
    "costOfLivingIndex": 34.8,
    "rentIndex": 17.9,
    "groceriesIndex": 29.7,
    "restaurantIndex": 28.8,
    "purchasingPowerIndex": 41.8,
    "safetyIndex": 68.4,
    "climateIndex": 52,
    "healthcareIndex": 60.5,
    "trafficEfficiencyIndex": 62.1,
    "pollutionControlIndex": 55,
    "internetSpeedIndex": 68,
    "typicalExpenses": {
      "mealInexpensive": "₸ 8.30",
      "coffee": "₸ 2.90",
      "apartment1BedCenter": "₸ 640",
      "monthlyPass": "₸ 20.80",
      "utilitiesBasic": "₸ 72.80"
    }
  },
  {
    "name": "Cancun",
    "country": "Mexico",
    "costOfLivingIndex": 38.9,
    "rentIndex": 16.7,
    "groceriesIndex": 36,
    "restaurantIndex": 31.8,
    "purchasingPowerIndex": 42.1,
    "safetyIndex": 48.5,
    "climateIndex": 84.1,
    "healthcareIndex": 65.2,
    "trafficEfficiencyIndex": 55.4,
    "pollutionControlIndex": 61.2,
    "internetSpeedIndex": 68.4,
    "typicalExpenses": {
      "mealInexpensive": "MXN 191",
      "coffee": "MXN 69.40",
      "apartment1BedCenter": "MXN 15,382",
      "monthlyPass": "MXN 583",
      "utilitiesBasic": "MXN 1,538"
    }
  },
  {
    "name": "Marrakech",
    "country": "Morocco",
    "costOfLivingIndex": 29.9,
    "rentIndex": 9.7,
    "groceriesIndex": 27.6,
    "restaurantIndex": 21.8,
    "purchasingPowerIndex": 31.5,
    "safetyIndex": 58.4,
    "climateIndex": 82.1,
    "healthcareIndex": 48.5,
    "trafficEfficiencyIndex": 42.1,
    "pollutionControlIndex": 46.2,
    "internetSpeedIndex": 52.1,
    "typicalExpenses": {
      "mealInexpensive": "MAD 42.80",
      "coffee": "MAD 16.30",
      "apartment1BedCenter": "MAD 4,031",
      "monthlyPass": "MAD 128",
      "utilitiesBasic": "MAD 403"
    }
  },
  {
    "name": "Utrecht",
    "country": "Netherlands",
    "costOfLivingIndex": 75.5,
    "rentIndex": 40.3,
    "groceriesIndex": 63.9,
    "restaurantIndex": 61.7,
    "purchasingPowerIndex": 78.6,
    "safetyIndex": 75.1,
    "climateIndex": 82.4,
    "healthcareIndex": 81.2,
    "trafficEfficiencyIndex": 56.5,
    "pollutionControlIndex": 75.4,
    "internetSpeedIndex": 86.2,
    "typicalExpenses": {
      "mealInexpensive": "€16.54",
      "coffee": "€4.19",
      "apartment1BedCenter": "€1,238",
      "monthlyPass": "€77",
      "utilitiesBasic": "€199"
    }
  },
  {
    "name": "Wellington",
    "country": "New Zealand",
    "costOfLivingIndex": 72.5,
    "rentIndex": 35.8,
    "groceriesIndex": 71.2,
    "restaurantIndex": 66.1,
    "purchasingPowerIndex": 95.8,
    "safetyIndex": 69.5,
    "climateIndex": 81.4,
    "healthcareIndex": 78.1,
    "trafficEfficiencyIndex": 55.8,
    "pollutionControlIndex": 88.5,
    "internetSpeedIndex": 155.6,
    "typicalExpenses": {
      "mealInexpensive": "NZ$ 24.96",
      "coffee": "NZ$ 5.46",
      "apartment1BedCenter": "NZ$ 2,132",
      "monthlyPass": "NZ$ 156.00",
      "utilitiesBasic": "NZ$ 202.80"
    }
  },
  {
    "name": "Cusco",
    "country": "Peru",
    "costOfLivingIndex": 27.3,
    "rentIndex": 11.2,
    "groceriesIndex": 24.5,
    "restaurantIndex": 20.4,
    "purchasingPowerIndex": 27.5,
    "safetyIndex": 58,
    "climateIndex": 76,
    "healthcareIndex": 50,
    "trafficEfficiencyIndex": 48,
    "pollutionControlIndex": 52,
    "internetSpeedIndex": 45,
    "typicalExpenses": {
      "mealInexpensive": "S/ 5.00",
      "coffee": "S/ 2.00",
      "apartment1BedCenter": "S/ 390",
      "monthlyPass": "S/ 14.50",
      "utilitiesBasic": "S/ 41.60"
    }
  },
  {
    "name": "Gdansk",
    "country": "Poland",
    "costOfLivingIndex": 45,
    "rentIndex": 18.9,
    "groceriesIndex": 39.1,
    "restaurantIndex": 37.1,
    "purchasingPowerIndex": 71.2,
    "safetyIndex": 76.2,
    "climateIndex": 65.4,
    "healthcareIndex": 65.1,
    "trafficEfficiencyIndex": 58.2,
    "pollutionControlIndex": 75.4,
    "internetSpeedIndex": 128.4,
    "typicalExpenses": {
      "mealInexpensive": "zł 36.70",
      "coffee": "zł 14.30",
      "apartment1BedCenter": "zł 2,758",
      "monthlyPass": "zł 116",
      "utilitiesBasic": "zł 902"
    }
  },
  {
    "name": "Coimbra",
    "country": "Portugal",
    "costOfLivingIndex": 42.2,
    "rentIndex": 24.4,
    "groceriesIndex": 36.2,
    "restaurantIndex": 33.3,
    "purchasingPowerIndex": 82.8,
    "safetyIndex": 75.2,
    "climateIndex": 91.4,
    "healthcareIndex": 74.2,
    "trafficEfficiencyIndex": 77,
    "pollutionControlIndex": 62.7,
    "internetSpeedIndex": 84.2,
    "typicalExpenses": {
      "mealInexpensive": "€9.25",
      "coffee": "€2.34",
      "apartment1BedCenter": "€749",
      "monthlyPass": "€44",
      "utilitiesBasic": "€111"
    }
  },
  {
    "name": "Kazan",
    "country": "Russia",
    "costOfLivingIndex": 27,
    "rentIndex": 12.8,
    "groceriesIndex": 25.5,
    "restaurantIndex": 22.8,
    "purchasingPowerIndex": 55.4,
    "safetyIndex": 72.8,
    "climateIndex": 58.4,
    "healthcareIndex": 66.5,
    "trafficEfficiencyIndex": 52.1,
    "pollutionControlIndex": 58.3,
    "internetSpeedIndex": 84.5,
    "typicalExpenses": {
      "mealInexpensive": "₽637",
      "coffee": "₽191",
      "apartment1BedCenter": "₽33,946",
      "monthlyPass": "₽1,697",
      "utilitiesBasic": "₽6,895"
    }
  },
  {
    "name": "Johannesburg",
    "country": "South Africa",
    "costOfLivingIndex": 35.4,
    "rentIndex": 11.4,
    "groceriesIndex": 32,
    "restaurantIndex": 29,
    "purchasingPowerIndex": 74.1,
    "safetyIndex": 19.5,
    "climateIndex": 89.1,
    "healthcareIndex": 62.4,
    "trafficEfficiencyIndex": 44.5,
    "pollutionControlIndex": 35.1,
    "internetSpeedIndex": 78.5,
    "typicalExpenses": {
      "mealInexpensive": "R 159",
      "coffee": "R 33.70",
      "apartment1BedCenter": "R 7,213",
      "monthlyPass": "R 796",
      "utilitiesBasic": "R 1,750"
    }
  },
  {
    "name": "Incheon",
    "country": "South Korea",
    "costOfLivingIndex": 55.1,
    "rentIndex": 18.6,
    "groceriesIndex": 59.3,
    "restaurantIndex": 36.1,
    "purchasingPowerIndex": 78.1,
    "safetyIndex": 76.2,
    "climateIndex": 68.4,
    "healthcareIndex": 82.1,
    "trafficEfficiencyIndex": 68.4,
    "pollutionControlIndex": 48.5,
    "internetSpeedIndex": 145.2,
    "typicalExpenses": {
      "mealInexpensive": "₩9,547",
      "coffee": "₩4,774",
      "apartment1BedCenter": "₩689,520",
      "monthlyPass": "₩68,952",
      "utilitiesBasic": "₩153,816"
    }
  },
  {
    "name": "Seville",
    "country": "Spain",
    "costOfLivingIndex": 51,
    "rentIndex": 28.3,
    "groceriesIndex": 43.1,
    "restaurantIndex": 41.6,
    "purchasingPowerIndex": 89.3,
    "safetyIndex": 68.4,
    "climateIndex": 91.2,
    "healthcareIndex": 79.5,
    "trafficEfficiencyIndex": 61.3,
    "pollutionControlIndex": 60.3,
    "internetSpeedIndex": 82.5,
    "typicalExpenses": {
      "mealInexpensive": "€11.17",
      "coffee": "€2.83",
      "apartment1BedCenter": "€863",
      "monthlyPass": "€52",
      "utilitiesBasic": "€134"
    }
  },
  {
    "name": "Bern",
    "country": "Switzerland",
    "costOfLivingIndex": 114.1,
    "rentIndex": 63.6,
    "groceriesIndex": 97.8,
    "restaurantIndex": 91,
    "purchasingPowerIndex": 81.4,
    "safetyIndex": 82.1,
    "climateIndex": 79.4,
    "healthcareIndex": 83.5,
    "trafficEfficiencyIndex": 64.9,
    "pollutionControlIndex": 68.5,
    "internetSpeedIndex": 84.7,
    "typicalExpenses": {
      "mealInexpensive": "CHF 20.80",
      "coffee": "CHF 5.20",
      "apartment1BedCenter": "CHF 1,768",
      "monthlyPass": "CHF 104",
      "utilitiesBasic": "CHF 270"
    }
  },
  {
    "name": "Chiang Mai",
    "country": "Thailand",
    "costOfLivingIndex": 31.8,
    "rentIndex": 11.6,
    "groceriesIndex": 33,
    "restaurantIndex": 15.7,
    "purchasingPowerIndex": 28.4,
    "safetyIndex": 75.2,
    "climateIndex": 78.5,
    "healthcareIndex": 78.1,
    "trafficEfficiencyIndex": 62.4,
    "pollutionControlIndex": 55.2,
    "internetSpeedIndex": 88.4,
    "typicalExpenses": {
      "mealInexpensive": "฿63.20",
      "coffee": "฿79.60",
      "apartment1BedCenter": "฿13,260",
      "monthlyPass": "฿955",
      "utilitiesBasic": "฿1,963"
    }
  },
  {
    "name": "Antalya",
    "country": "Turkey",
    "costOfLivingIndex": 32,
    "rentIndex": 14.4,
    "groceriesIndex": 28.9,
    "restaurantIndex": 23.3,
    "purchasingPowerIndex": 36.2,
    "safetyIndex": 68.5,
    "climateIndex": 89.2,
    "healthcareIndex": 68.4,
    "trafficEfficiencyIndex": 61.2,
    "pollutionControlIndex": 65.1,
    "internetSpeedIndex": 40.2,
    "typicalExpenses": {
      "mealInexpensive": "₺191",
      "coffee": "₺84.70",
      "apartment1BedCenter": "₺17,503",
      "monthlyPass": "₺615",
      "utilitiesBasic": "₺1,856"
    }
  },
  {
    "name": "Belfast",
    "country": "United Kingdom",
    "costOfLivingIndex": 59.2,
    "rentIndex": 32.4,
    "groceriesIndex": 49,
    "restaurantIndex": 46.8,
    "purchasingPowerIndex": 87.9,
    "safetyIndex": 56.4,
    "climateIndex": 82.1,
    "healthcareIndex": 71.5,
    "trafficEfficiencyIndex": 63.6,
    "pollutionControlIndex": 84,
    "internetSpeedIndex": 81.9,
    "typicalExpenses": {
      "mealInexpensive": "£11.02",
      "coffee": "£2.80",
      "apartment1BedCenter": "£842",
      "monthlyPass": "£51",
      "utilitiesBasic": "£132"
    }
  },
  {
    "name": "Boston",
    "country": "United States",
    "costOfLivingIndex": 84,
    "rentIndex": 56.7,
    "groceriesIndex": 79.5,
    "restaurantIndex": 75.7,
    "purchasingPowerIndex": 113.3,
    "safetyIndex": 59.2,
    "climateIndex": 70.4,
    "healthcareIndex": 78.1,
    "trafficEfficiencyIndex": 68.5,
    "pollutionControlIndex": 65,
    "internetSpeedIndex": 85.3,
    "typicalExpenses": {
      "mealInexpensive": "$17.50",
      "coffee": "$4.80",
      "apartment1BedCenter": "$2,122",
      "monthlyPass": "$98.70",
      "utilitiesBasic": "$175"
    }
  },
  {
    "name": "Samarkand",
    "country": "Uzbekistan",
    "costOfLivingIndex": 24,
    "rentIndex": 11.4,
    "groceriesIndex": 22.4,
    "restaurantIndex": 18.9,
    "purchasingPowerIndex": 24.5,
    "safetyIndex": 70,
    "climateIndex": 73,
    "healthcareIndex": 48,
    "trafficEfficiencyIndex": 52,
    "pollutionControlIndex": 50,
    "internetSpeedIndex": 42,
    "typicalExpenses": {
      "mealInexpensive": "so'm 4.70",
      "coffee": "so'm 1.85",
      "apartment1BedCenter": "so'm 390",
      "monthlyPass": "so'm 9.40",
      "utilitiesBasic": "so'm 39.50"
    }
  },
  {
    "name": "Hanoi",
    "country": "Vietnam",
    "costOfLivingIndex": 31,
    "rentIndex": 11.4,
    "groceriesIndex": 29.9,
    "restaurantIndex": 18.8,
    "purchasingPowerIndex": 28.5,
    "safetyIndex": 58.2,
    "climateIndex": 71.4,
    "healthcareIndex": 54.1,
    "trafficEfficiencyIndex": 20.5,
    "pollutionControlIndex": 19.5,
    "internetSpeedIndex": 80.5,
    "typicalExpenses": {
      "mealInexpensive": "₫47,736",
      "coffee": "₫31,824",
      "apartment1BedCenter": "₫10,077,600",
      "monthlyPass": "₫212,160",
      "utilitiesBasic": "₫1,538,160"
    }
  },
  {
    "name": "Adelaide",
    "country": "Australia",
    "costOfLivingIndex": 70.6,
    "rentIndex": 34.9,
    "groceriesIndex": 69.5,
    "restaurantIndex": 63.6,
    "purchasingPowerIndex": 96.1,
    "safetyIndex": 68.4,
    "climateIndex": 86.5,
    "healthcareIndex": 75.2,
    "trafficEfficiencyIndex": 59.1,
    "pollutionControlIndex": 84.6,
    "internetSpeedIndex": 105.4,
    "typicalExpenses": {
      "mealInexpensive": "A$ 21.84",
      "coffee": "A$ 5.15",
      "apartment1BedCenter": "A$ 2,028",
      "monthlyPass": "A$ 109.20",
      "utilitiesBasic": "A$ 239.20"
    }
  },
  {
    "name": "Linz",
    "country": "Austria",
    "costOfLivingIndex": 65.3,
    "rentIndex": 37.1,
    "groceriesIndex": 54.9,
    "restaurantIndex": 52.7,
    "purchasingPowerIndex": 78,
    "safetyIndex": 76.2,
    "climateIndex": 81.4,
    "healthcareIndex": 80.8,
    "trafficEfficiencyIndex": 75,
    "pollutionControlIndex": 72.3,
    "internetSpeedIndex": 84.1,
    "typicalExpenses": {
      "mealInexpensive": "€14.29",
      "coffee": "€3.62",
      "apartment1BedCenter": "€1,134",
      "monthlyPass": "€67",
      "utilitiesBasic": "€172"
    }
  },
  {
    "name": "Ottawa",
    "country": "Canada",
    "costOfLivingIndex": 71.1,
    "rentIndex": 36.9,
    "groceriesIndex": 68.4,
    "restaurantIndex": 65.1,
    "purchasingPowerIndex": 108.1,
    "safetyIndex": 74.3,
    "climateIndex": 54.1,
    "healthcareIndex": 76.8,
    "trafficEfficiencyIndex": 59.5,
    "pollutionControlIndex": 84.1,
    "internetSpeedIndex": 140.8,
    "typicalExpenses": {
      "mealInexpensive": "C$ 21.84",
      "coffee": "C$ 5.15",
      "apartment1BedCenter": "C$ 1,747",
      "monthlyPass": "C$ 130.00",
      "utilitiesBasic": "C$ 223.60"
    }
  },
  {
    "name": "Nice",
    "country": "France",
    "costOfLivingIndex": 69.6,
    "rentIndex": 39.2,
    "groceriesIndex": 58.4,
    "restaurantIndex": 57.7,
    "purchasingPowerIndex": 88.7,
    "safetyIndex": 54.2,
    "climateIndex": 92.4,
    "healthcareIndex": 79.1,
    "trafficEfficiencyIndex": 68.5,
    "pollutionControlIndex": 80,
    "internetSpeedIndex": 85.4,
    "typicalExpenses": {
      "mealInexpensive": "€15.25",
      "coffee": "€3.86",
      "apartment1BedCenter": "€1,196",
      "monthlyPass": "€71",
      "utilitiesBasic": "€183"
    }
  },
  {
    "name": "Cologne",
    "country": "Germany",
    "costOfLivingIndex": 70.6,
    "rentIndex": 37.4,
    "groceriesIndex": 61.4,
    "restaurantIndex": 55.2,
    "purchasingPowerIndex": 88.1,
    "safetyIndex": 54.1,
    "climateIndex": 80.2,
    "healthcareIndex": 81.5,
    "trafficEfficiencyIndex": 56.4,
    "pollutionControlIndex": 71.7,
    "internetSpeedIndex": 83,
    "typicalExpenses": {
      "mealInexpensive": "€15.46",
      "coffee": "€3.92",
      "apartment1BedCenter": "€1,144",
      "monthlyPass": "€72",
      "utilitiesBasic": "€185"
    }
  },
  {
    "name": "Bangalore",
    "country": "India",
    "costOfLivingIndex": 25.9,
    "rentIndex": 9.6,
    "groceriesIndex": 24.5,
    "restaurantIndex": 18.6,
    "purchasingPowerIndex": 58.1,
    "safetyIndex": 52.4,
    "climateIndex": 85.2,
    "healthcareIndex": 69.4,
    "trafficEfficiencyIndex": 28.5,
    "pollutionControlIndex": 36.1,
    "internetSpeedIndex": 98.4,
    "typicalExpenses": {
      "mealInexpensive": "₹ 265",
      "coffee": "₹ 149",
      "apartment1BedCenter": "₹ 23,338",
      "monthlyPass": "₹ 1,591",
      "utilitiesBasic": "₹ 3,395"
    }
  },
  {
    "name": "Venice",
    "country": "Italy",
    "costOfLivingIndex": 69.4,
    "rentIndex": 39.9,
    "groceriesIndex": 62.1,
    "restaurantIndex": 76,
    "purchasingPowerIndex": 66.5,
    "safetyIndex": 63.4,
    "climateIndex": 86.2,
    "healthcareIndex": 71.8,
    "trafficEfficiencyIndex": 45.1,
    "pollutionControlIndex": 58.1,
    "internetSpeedIndex": 82.5,
    "typicalExpenses": {
      "mealInexpensive": "€22.88",
      "coffee": "€2.08",
      "apartment1BedCenter": "€1,196",
      "monthlyPass": "€38.48",
      "utilitiesBasic": "€192.40"
    }
  },
  {
    "name": "Yokohama",
    "country": "Japan",
    "costOfLivingIndex": 45.6,
    "rentIndex": 18.9,
    "groceriesIndex": 46.9,
    "restaurantIndex": 35.2,
    "purchasingPowerIndex": 85.1,
    "safetyIndex": 84.2,
    "climateIndex": 72.5,
    "healthcareIndex": 81.2,
    "trafficEfficiencyIndex": 72.1,
    "pollutionControlIndex": 76.4,
    "internetSpeedIndex": 96.2,
    "typicalExpenses": {
      "mealInexpensive": "¥1,167",
      "coffee": "¥509",
      "apartment1BedCenter": "¥90,168",
      "monthlyPass": "¥7,638",
      "utilitiesBasic": "¥20,367"
    }
  },
  {
    "name": "The Hague",
    "country": "Netherlands",
    "costOfLivingIndex": 74.4,
    "rentIndex": 40.1,
    "groceriesIndex": 64.7,
    "restaurantIndex": 59.1,
    "purchasingPowerIndex": 88.5,
    "safetyIndex": 71.4,
    "climateIndex": 82.5,
    "healthcareIndex": 81.5,
    "trafficEfficiencyIndex": 75.5,
    "pollutionControlIndex": 77.1,
    "internetSpeedIndex": 83.5,
    "typicalExpenses": {
      "mealInexpensive": "€16.29",
      "coffee": "€4.13",
      "apartment1BedCenter": "€1,227",
      "monthlyPass": "€76",
      "utilitiesBasic": "€196"
    }
  },
  {
    "name": "Braga",
    "country": "Portugal",
    "costOfLivingIndex": 43.9,
    "rentIndex": 26.1,
    "groceriesIndex": 38.4,
    "restaurantIndex": 34.8,
    "purchasingPowerIndex": 88.2,
    "safetyIndex": 74.1,
    "climateIndex": 90.2,
    "healthcareIndex": 75.1,
    "trafficEfficiencyIndex": 73.8,
    "pollutionControlIndex": 83.9,
    "internetSpeedIndex": 90.1,
    "typicalExpenses": {
      "mealInexpensive": "€9.61",
      "coffee": "€2.43",
      "apartment1BedCenter": "€801",
      "monthlyPass": "€45",
      "utilitiesBasic": "€115"
    }
  },
  {
    "name": "Sochi",
    "country": "Russia",
    "costOfLivingIndex": 30,
    "rentIndex": 16.7,
    "groceriesIndex": 27.6,
    "restaurantIndex": 29.1,
    "purchasingPowerIndex": 50.1,
    "safetyIndex": 76.5,
    "climateIndex": 85.4,
    "healthcareIndex": 64.2,
    "trafficEfficiencyIndex": 41.2,
    "pollutionControlIndex": 68.4,
    "internetSpeedIndex": 81.5,
    "typicalExpenses": {
      "mealInexpensive": "₽849",
      "coffee": "₽234",
      "apartment1BedCenter": "₽47,736",
      "monthlyPass": "₽1,909",
      "utilitiesBasic": "₽7,426"
    }
  },
  {
    "name": "Malaga",
    "country": "Spain",
    "costOfLivingIndex": 53.3,
    "rentIndex": 29.3,
    "groceriesIndex": 43.2,
    "restaurantIndex": 42.5,
    "purchasingPowerIndex": 71.2,
    "safetyIndex": 72.1,
    "climateIndex": 94.1,
    "healthcareIndex": 80.2,
    "trafficEfficiencyIndex": 77.7,
    "pollutionControlIndex": 62.8,
    "internetSpeedIndex": 91.8,
    "typicalExpenses": {
      "mealInexpensive": "€11.68",
      "coffee": "€2.95",
      "apartment1BedCenter": "€894",
      "monthlyPass": "€54",
      "utilitiesBasic": "€140"
    }
  },
  {
    "name": "Lausanne",
    "country": "Switzerland",
    "costOfLivingIndex": 112.5,
    "rentIndex": 60.9,
    "groceriesIndex": 94.2,
    "restaurantIndex": 89.4,
    "purchasingPowerIndex": 78.8,
    "safetyIndex": 76.4,
    "climateIndex": 81.2,
    "healthcareIndex": 82.1,
    "trafficEfficiencyIndex": 66.7,
    "pollutionControlIndex": 61.1,
    "internetSpeedIndex": 88.5,
    "typicalExpenses": {
      "mealInexpensive": "CHF 20.80",
      "coffee": "CHF 5.20",
      "apartment1BedCenter": "CHF 1,664",
      "monthlyPass": "CHF 104",
      "utilitiesBasic": "CHF 265"
    }
  },
  {
    "name": "Birmingham",
    "country": "United Kingdom",
    "costOfLivingIndex": 60.5,
    "rentIndex": 33.9,
    "groceriesIndex": 49.5,
    "restaurantIndex": 48.2,
    "purchasingPowerIndex": 86.9,
    "safetyIndex": 48.2,
    "climateIndex": 83.4,
    "healthcareIndex": 71.1,
    "trafficEfficiencyIndex": 66.6,
    "pollutionControlIndex": 62.5,
    "internetSpeedIndex": 94.4,
    "typicalExpenses": {
      "mealInexpensive": "£11.25",
      "coffee": "£2.85",
      "apartment1BedCenter": "£884",
      "monthlyPass": "£52",
      "utilitiesBasic": "£135"
    }
  },
  {
    "name": "Houston",
    "country": "United States",
    "costOfLivingIndex": 70.3,
    "rentIndex": 49.2,
    "groceriesIndex": 65.7,
    "restaurantIndex": 63.2,
    "purchasingPowerIndex": 108.4,
    "safetyIndex": 42.1,
    "climateIndex": 80.5,
    "healthcareIndex": 72.4,
    "trafficEfficiencyIndex": 44.9,
    "pollutionControlIndex": 79.3,
    "internetSpeedIndex": 86.5,
    "typicalExpenses": {
      "mealInexpensive": "$14.70",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$82.70",
      "utilitiesBasic": "$146"
    }
  },
  {
    "name": "Da Nang",
    "country": "Vietnam",
    "costOfLivingIndex": 29.1,
    "rentIndex": 13.8,
    "groceriesIndex": 27.5,
    "restaurantIndex": 21.4,
    "purchasingPowerIndex": 32.6,
    "safetyIndex": 74,
    "climateIndex": 72,
    "healthcareIndex": 58,
    "trafficEfficiencyIndex": 62,
    "pollutionControlIndex": 58,
    "internetSpeedIndex": 78,
    "typicalExpenses": {
      "mealInexpensive": "₫4.40",
      "coffee": "₫1.60",
      "apartment1BedCenter": "₫460",
      "monthlyPass": "₫10.40",
      "utilitiesBasic": "₫43.70"
    }
  },
  {
    "name": "Canberra",
    "country": "Australia",
    "costOfLivingIndex": 76.6,
    "rentIndex": 45.4,
    "groceriesIndex": 74.2,
    "restaurantIndex": 69.8,
    "purchasingPowerIndex": 104.2,
    "safetyIndex": 78.1,
    "climateIndex": 78.2,
    "healthcareIndex": 79.5,
    "trafficEfficiencyIndex": 76.4,
    "pollutionControlIndex": 85.1,
    "internetSpeedIndex": 94.2,
    "typicalExpenses": {
      "mealInexpensive": "A$27.60",
      "coffee": "A$5.50",
      "apartment1BedCenter": "A$2,334",
      "monthlyPass": "A$127",
      "utilitiesBasic": "A$265"
    }
  },
  {
    "name": "Innsbruck",
    "country": "Austria",
    "costOfLivingIndex": 68.7,
    "rentIndex": 39.7,
    "groceriesIndex": 58.2,
    "restaurantIndex": 55.2,
    "purchasingPowerIndex": 76.6,
    "safetyIndex": 79.1,
    "climateIndex": 78.2,
    "healthcareIndex": 82.4,
    "trafficEfficiencyIndex": 74.1,
    "pollutionControlIndex": 72,
    "internetSpeedIndex": 86.5,
    "typicalExpenses": {
      "mealInexpensive": "€15.04",
      "coffee": "€3.81",
      "apartment1BedCenter": "€1,217",
      "monthlyPass": "€71",
      "utilitiesBasic": "€181"
    }
  },
  {
    "name": "Edmonton",
    "country": "Canada",
    "costOfLivingIndex": 66.6,
    "rentIndex": 30.8,
    "groceriesIndex": 63,
    "restaurantIndex": 59.6,
    "purchasingPowerIndex": 95.1,
    "safetyIndex": 55.4,
    "climateIndex": 32.1,
    "healthcareIndex": 72.4,
    "trafficEfficiencyIndex": 68.1,
    "pollutionControlIndex": 72.1,
    "internetSpeedIndex": 98.5,
    "typicalExpenses": {
      "mealInexpensive": "C$23.90",
      "coffee": "C$5.40",
      "apartment1BedCenter": "C$1,432",
      "monthlyPass": "C$106",
      "utilitiesBasic": "C$233"
    }
  },
  {
    "name": "Toulouse",
    "country": "France",
    "costOfLivingIndex": 62.6,
    "rentIndex": 36.5,
    "groceriesIndex": 52.2,
    "restaurantIndex": 50,
    "purchasingPowerIndex": 73.5,
    "safetyIndex": 52.8,
    "climateIndex": 85.1,
    "healthcareIndex": 80.2,
    "trafficEfficiencyIndex": 55.3,
    "pollutionControlIndex": 61.8,
    "internetSpeedIndex": 93.1,
    "typicalExpenses": {
      "mealInexpensive": "€13.71",
      "coffee": "€3.47",
      "apartment1BedCenter": "€1,113",
      "monthlyPass": "€64",
      "utilitiesBasic": "€164"
    }
  },
  {
    "name": "Stuttgart",
    "country": "Germany",
    "costOfLivingIndex": 73.4,
    "rentIndex": 42.1,
    "groceriesIndex": 61.5,
    "restaurantIndex": 59.4,
    "purchasingPowerIndex": 93.4,
    "safetyIndex": 64.2,
    "climateIndex": 78.4,
    "healthcareIndex": 83.1,
    "trafficEfficiencyIndex": 71.7,
    "pollutionControlIndex": 83.2,
    "internetSpeedIndex": 88.8,
    "typicalExpenses": {
      "mealInexpensive": "€16.07",
      "coffee": "€4.07",
      "apartment1BedCenter": "€1,290",
      "monthlyPass": "€75",
      "utilitiesBasic": "€192"
    }
  },
  {
    "name": "Naples",
    "country": "Italy",
    "costOfLivingIndex": 56.4,
    "rentIndex": 32.9,
    "groceriesIndex": 47.5,
    "restaurantIndex": 43.9,
    "purchasingPowerIndex": 80,
    "safetyIndex": 41.2,
    "climateIndex": 90.4,
    "healthcareIndex": 68.5,
    "trafficEfficiencyIndex": 65.6,
    "pollutionControlIndex": 65.6,
    "internetSpeedIndex": 82.3,
    "typicalExpenses": {
      "mealInexpensive": "€12.34",
      "coffee": "€3.13",
      "apartment1BedCenter": "€1,009",
      "monthlyPass": "€57",
      "utilitiesBasic": "€148"
    }
  },
  {
    "name": "Eindhoven",
    "country": "Netherlands",
    "costOfLivingIndex": 72.8,
    "rentIndex": 39.3,
    "groceriesIndex": 61.3,
    "restaurantIndex": 59.3,
    "purchasingPowerIndex": 88.8,
    "safetyIndex": 72.5,
    "climateIndex": 82.1,
    "healthcareIndex": 80.4,
    "trafficEfficiencyIndex": 66.1,
    "pollutionControlIndex": 70.3,
    "internetSpeedIndex": 92.4,
    "typicalExpenses": {
      "mealInexpensive": "€15.93",
      "coffee": "€4.04",
      "apartment1BedCenter": "€1,206",
      "monthlyPass": "€75",
      "utilitiesBasic": "€191"
    }
  },
  {
    "name": "Krasnodar",
    "country": "Russia",
    "costOfLivingIndex": 24.9,
    "rentIndex": 11.2,
    "groceriesIndex": 23.1,
    "restaurantIndex": 21.6,
    "purchasingPowerIndex": 52.8,
    "safetyIndex": 68.2,
    "climateIndex": 78.5,
    "healthcareIndex": 61.5,
    "trafficEfficiencyIndex": 40.5,
    "pollutionControlIndex": 56.4,
    "internetSpeedIndex": 83.2,
    "typicalExpenses": {
      "mealInexpensive": "₽530",
      "coffee": "₽169",
      "apartment1BedCenter": "₽28,642",
      "monthlyPass": "₽1,485",
      "utilitiesBasic": "₽6,153"
    }
  },
  {
    "name": "Zaragoza",
    "country": "Spain",
    "costOfLivingIndex": 49.4,
    "rentIndex": 28.6,
    "groceriesIndex": 41.7,
    "restaurantIndex": 39.6,
    "purchasingPowerIndex": 83.6,
    "safetyIndex": 74.5,
    "climateIndex": 89.2,
    "healthcareIndex": 78.4,
    "trafficEfficiencyIndex": 75.7,
    "pollutionControlIndex": 79.1,
    "internetSpeedIndex": 93.8,
    "typicalExpenses": {
      "mealInexpensive": "€10.81",
      "coffee": "€2.74",
      "apartment1BedCenter": "€874",
      "monthlyPass": "€51",
      "utilitiesBasic": "€130"
    }
  },
  {
    "name": "Glasgow",
    "country": "United Kingdom",
    "costOfLivingIndex": 62.3,
    "rentIndex": 33,
    "groceriesIndex": 51.6,
    "restaurantIndex": 51.2,
    "purchasingPowerIndex": 72.4,
    "safetyIndex": 52.1,
    "climateIndex": 80.5,
    "healthcareIndex": 72.4,
    "trafficEfficiencyIndex": 75.9,
    "pollutionControlIndex": 79,
    "internetSpeedIndex": 87.6,
    "typicalExpenses": {
      "mealInexpensive": "£11.60",
      "coffee": "£2.93",
      "apartment1BedCenter": "£863",
      "monthlyPass": "£54",
      "utilitiesBasic": "£139"
    }
  },
  {
    "name": "Dallas",
    "country": "United States",
    "costOfLivingIndex": 72.6,
    "rentIndex": 51.4,
    "groceriesIndex": 70.2,
    "restaurantIndex": 66,
    "purchasingPowerIndex": 102.1,
    "safetyIndex": 49.5,
    "climateIndex": 82.1,
    "healthcareIndex": 70.2,
    "trafficEfficiencyIndex": 46.8,
    "pollutionControlIndex": 70.2,
    "internetSpeedIndex": 99.7,
    "typicalExpenses": {
      "mealInexpensive": "$15.10",
      "coffee": "$4.20",
      "apartment1BedCenter": "$1,909",
      "monthlyPass": "$84.90",
      "utilitiesBasic": "$152"
    }
  },
  {
    "name": "Nha Trang",
    "country": "Vietnam",
    "costOfLivingIndex": 27.7,
    "rentIndex": 12.2,
    "groceriesIndex": 26.5,
    "restaurantIndex": 20.4,
    "purchasingPowerIndex": 30.6,
    "safetyIndex": 72,
    "climateIndex": 78,
    "healthcareIndex": 54,
    "trafficEfficiencyIndex": 60,
    "pollutionControlIndex": 60,
    "internetSpeedIndex": 75,
    "typicalExpenses": {
      "mealInexpensive": "₫4.20",
      "coffee": "₫1.50",
      "apartment1BedCenter": "₫410",
      "monthlyPass": "₫10.40",
      "utilitiesBasic": "₫41.60"
    }
  },
  {
    "name": "Gold Coast",
    "country": "Australia",
    "costOfLivingIndex": 72.7,
    "rentIndex": 42.9,
    "groceriesIndex": 71.5,
    "restaurantIndex": 66.5,
    "purchasingPowerIndex": 95.4,
    "safetyIndex": 68.4,
    "climateIndex": 94.1,
    "healthcareIndex": 74.5,
    "trafficEfficiencyIndex": 65.2,
    "pollutionControlIndex": 78.4,
    "internetSpeedIndex": 92.5,
    "typicalExpenses": {
      "mealInexpensive": "A$25.50",
      "coffee": "A$5.30",
      "apartment1BedCenter": "A$2,228",
      "monthlyPass": "A$117",
      "utilitiesBasic": "A$244"
    }
  },
  {
    "name": "Quebec City",
    "country": "Canada",
    "costOfLivingIndex": 63.9,
    "rentIndex": 25,
    "groceriesIndex": 61.4,
    "restaurantIndex": 56.3,
    "purchasingPowerIndex": 98.4,
    "safetyIndex": 82.1,
    "climateIndex": 35.4,
    "healthcareIndex": 78.4,
    "trafficEfficiencyIndex": 74.2,
    "pollutionControlIndex": 82.5,
    "internetSpeedIndex": 96.4,
    "typicalExpenses": {
      "mealInexpensive": "C$21.20",
      "coffee": "C$5.10",
      "apartment1BedCenter": "C$1,220",
      "monthlyPass": "C$98.10",
      "utilitiesBasic": "C$191"
    }
  },
  {
    "name": "Bordeaux",
    "country": "France",
    "costOfLivingIndex": 64.3,
    "rentIndex": 34.5,
    "groceriesIndex": 56.2,
    "restaurantIndex": 49.8,
    "purchasingPowerIndex": 86.5,
    "safetyIndex": 55.4,
    "climateIndex": 86.2,
    "healthcareIndex": 80.1,
    "trafficEfficiencyIndex": 78.4,
    "pollutionControlIndex": 81.1,
    "internetSpeedIndex": 83.8,
    "typicalExpenses": {
      "mealInexpensive": "€14.08",
      "coffee": "€3.57",
      "apartment1BedCenter": "€1,050",
      "monthlyPass": "€66",
      "utilitiesBasic": "€170"
    }
  },
  {
    "name": "Dusseldorf",
    "country": "Germany",
    "costOfLivingIndex": 72.8,
    "rentIndex": 39.5,
    "groceriesIndex": 62.2,
    "restaurantIndex": 56.8,
    "purchasingPowerIndex": 86,
    "safetyIndex": 62.1,
    "climateIndex": 80.5,
    "healthcareIndex": 82.6,
    "trafficEfficiencyIndex": 71.3,
    "pollutionControlIndex": 80.8,
    "internetSpeedIndex": 86.5,
    "typicalExpenses": {
      "mealInexpensive": "€15.93",
      "coffee": "€4.04",
      "apartment1BedCenter": "€1,206",
      "monthlyPass": "€75",
      "utilitiesBasic": "€191"
    }
  },
  {
    "name": "Turin",
    "country": "Italy",
    "costOfLivingIndex": 60.2,
    "rentIndex": 34,
    "groceriesIndex": 50.1,
    "restaurantIndex": 48.8,
    "purchasingPowerIndex": 83.8,
    "safetyIndex": 52.4,
    "climateIndex": 84.2,
    "healthcareIndex": 73.1,
    "trafficEfficiencyIndex": 70.2,
    "pollutionControlIndex": 75.2,
    "internetSpeedIndex": 93.1,
    "typicalExpenses": {
      "mealInexpensive": "€13.17",
      "coffee": "€3.34",
      "apartment1BedCenter": "€1,040",
      "monthlyPass": "€61",
      "utilitiesBasic": "€158"
    }
  },
  {
    "name": "Kaliningrad",
    "country": "Russia",
    "costOfLivingIndex": 25.6,
    "rentIndex": 11.7,
    "groceriesIndex": 23.9,
    "restaurantIndex": 21.9,
    "purchasingPowerIndex": 52.2,
    "safetyIndex": 74.2,
    "climateIndex": 65.1,
    "healthcareIndex": 63.5,
    "trafficEfficiencyIndex": 50.4,
    "pollutionControlIndex": 63.1,
    "internetSpeedIndex": 85.1,
    "typicalExpenses": {
      "mealInexpensive": "₽583",
      "coffee": "₽181",
      "apartment1BedCenter": "₽29,702",
      "monthlyPass": "₽1,591",
      "utilitiesBasic": "₽6,365"
    }
  },
  {
    "name": "Bilbao",
    "country": "Spain",
    "costOfLivingIndex": 55.1,
    "rentIndex": 28.8,
    "groceriesIndex": 48.3,
    "restaurantIndex": 43.9,
    "purchasingPowerIndex": 70.2,
    "safetyIndex": 71.2,
    "climateIndex": 87.5,
    "healthcareIndex": 81.1,
    "trafficEfficiencyIndex": 66.6,
    "pollutionControlIndex": 63.7,
    "internetSpeedIndex": 92.1,
    "typicalExpenses": {
      "mealInexpensive": "€12.05",
      "coffee": "€3.06",
      "apartment1BedCenter": "€884",
      "monthlyPass": "€56",
      "utilitiesBasic": "€145"
    }
  },
  {
    "name": "Leeds",
    "country": "United Kingdom",
    "costOfLivingIndex": 59.6,
    "rentIndex": 34.2,
    "groceriesIndex": 52,
    "restaurantIndex": 49.1,
    "purchasingPowerIndex": 86,
    "safetyIndex": 51.5,
    "climateIndex": 83.1,
    "healthcareIndex": 71.2,
    "trafficEfficiencyIndex": 68.9,
    "pollutionControlIndex": 80.6,
    "internetSpeedIndex": 93.3,
    "typicalExpenses": {
      "mealInexpensive": "£11.09",
      "coffee": "£2.81",
      "apartment1BedCenter": "£884",
      "monthlyPass": "£52",
      "utilitiesBasic": "£133"
    }
  },
  {
    "name": "Austin",
    "country": "United States",
    "costOfLivingIndex": 75.8,
    "rentIndex": 54.2,
    "groceriesIndex": 69.8,
    "restaurantIndex": 68.4,
    "purchasingPowerIndex": 110.4,
    "safetyIndex": 61.2,
    "climateIndex": 84.6,
    "healthcareIndex": 74.5,
    "trafficEfficiencyIndex": 41.4,
    "pollutionControlIndex": 62.2,
    "internetSpeedIndex": 88.2,
    "typicalExpenses": {
      "mealInexpensive": "$15.80",
      "coffee": "$4.30",
      "apartment1BedCenter": "$2,016",
      "monthlyPass": "$89.10",
      "utilitiesBasic": "$158"
    }
  },
  {
    "name": "Strasbourg",
    "country": "France",
    "costOfLivingIndex": 65.3,
    "rentIndex": 36.6,
    "groceriesIndex": 57.2,
    "restaurantIndex": 50.6,
    "purchasingPowerIndex": 90.1,
    "safetyIndex": 61.2,
    "climateIndex": 82.5,
    "healthcareIndex": 81.4,
    "trafficEfficiencyIndex": 64.2,
    "pollutionControlIndex": 83.6,
    "internetSpeedIndex": 86.1,
    "typicalExpenses": {
      "mealInexpensive": "€14.29",
      "coffee": "€3.62",
      "apartment1BedCenter": "€1,123",
      "monthlyPass": "€67",
      "utilitiesBasic": "€172"
    }
  },
  {
    "name": "Nuremberg",
    "country": "Germany",
    "costOfLivingIndex": 65.4,
    "rentIndex": 24.6,
    "groceriesIndex": 59.1,
    "restaurantIndex": 57.5,
    "purchasingPowerIndex": 98.5,
    "safetyIndex": 78.4,
    "climateIndex": 72.1,
    "healthcareIndex": 76.5,
    "trafficEfficiencyIndex": 72.1,
    "pollutionControlIndex": 78.2,
    "internetSpeedIndex": 94.2,
    "typicalExpenses": {
      "mealInexpensive": "€15.40",
      "coffee": "€3.80",
      "apartment1BedCenter": "€902",
      "monthlyPass": "€79.60",
      "utilitiesBasic": "€255"
    }
  },
  {
    "name": "Bologna",
    "country": "Italy",
    "costOfLivingIndex": 64.9,
    "rentIndex": 36,
    "groceriesIndex": 54.6,
    "restaurantIndex": 50.4,
    "purchasingPowerIndex": 78.4,
    "safetyIndex": 58.1,
    "climateIndex": 85.5,
    "healthcareIndex": 76.2,
    "trafficEfficiencyIndex": 77.5,
    "pollutionControlIndex": 83.4,
    "internetSpeedIndex": 94.2,
    "typicalExpenses": {
      "mealInexpensive": "€14.22",
      "coffee": "€3.60",
      "apartment1BedCenter": "€1,102",
      "monthlyPass": "€67",
      "utilitiesBasic": "€171"
    }
  },
  {
    "name": "Nizhny Novgorod",
    "country": "Russia",
    "costOfLivingIndex": 25.6,
    "rentIndex": 12,
    "groceriesIndex": 24.3,
    "restaurantIndex": 22.2,
    "purchasingPowerIndex": 53.6,
    "safetyIndex": 67.4,
    "climateIndex": 53.2,
    "healthcareIndex": 61.5,
    "trafficEfficiencyIndex": 49.5,
    "pollutionControlIndex": 48.2,
    "internetSpeedIndex": 84.8,
    "typicalExpenses": {
      "mealInexpensive": "₽583",
      "coffee": "₽175",
      "apartment1BedCenter": "₽29,702",
      "monthlyPass": "₽1,644",
      "utilitiesBasic": "₽6,471"
    }
  },
  {
    "name": "Granada",
    "country": "Spain",
    "costOfLivingIndex": 46,
    "rentIndex": 16.8,
    "groceriesIndex": 42.7,
    "restaurantIndex": 39.2,
    "purchasingPowerIndex": 72.1,
    "safetyIndex": 74.2,
    "climateIndex": 82.1,
    "healthcareIndex": 78.2,
    "trafficEfficiencyIndex": 65.4,
    "pollutionControlIndex": 74.1,
    "internetSpeedIndex": 88.4,
    "typicalExpenses": {
      "mealInexpensive": "€11.70",
      "coffee": "€1.90",
      "apartment1BedCenter": "€658",
      "monthlyPass": "€40.30",
      "utilitiesBasic": "€122"
    }
  },
  {
    "name": "Denver",
    "country": "United States",
    "costOfLivingIndex": 78.2,
    "rentIndex": 57.1,
    "groceriesIndex": 74.7,
    "restaurantIndex": 71.2,
    "purchasingPowerIndex": 100.4,
    "safetyIndex": 55.4,
    "climateIndex": 80.1,
    "healthcareIndex": 76.2,
    "trafficEfficiencyIndex": 60.8,
    "pollutionControlIndex": 72.3,
    "internetSpeedIndex": 99.4,
    "typicalExpenses": {
      "mealInexpensive": "$16.30",
      "coffee": "$4.50",
      "apartment1BedCenter": "$2,122",
      "monthlyPass": "$91.20",
      "utilitiesBasic": "$163"
    }
  },
  {
    "name": "Leipzig",
    "country": "Germany",
    "costOfLivingIndex": 62.6,
    "rentIndex": 21.2,
    "groceriesIndex": 56.9,
    "restaurantIndex": 53.9,
    "purchasingPowerIndex": 94.2,
    "safetyIndex": 72.1,
    "climateIndex": 71.5,
    "healthcareIndex": 75.1,
    "trafficEfficiencyIndex": 71.4,
    "pollutionControlIndex": 75.4,
    "internetSpeedIndex": 92.8,
    "typicalExpenses": {
      "mealInexpensive": "€13.30",
      "coffee": "€3.60",
      "apartment1BedCenter": "€764",
      "monthlyPass": "€72.10",
      "utilitiesBasic": "€233"
    }
  },
  {
    "name": "Genoa",
    "country": "Italy",
    "costOfLivingIndex": 59.1,
    "rentIndex": 31.7,
    "groceriesIndex": 48.4,
    "restaurantIndex": 48.2,
    "purchasingPowerIndex": 81.7,
    "safetyIndex": 51.2,
    "climateIndex": 88.1,
    "healthcareIndex": 72.4,
    "trafficEfficiencyIndex": 60.3,
    "pollutionControlIndex": 71,
    "internetSpeedIndex": 85.2,
    "typicalExpenses": {
      "mealInexpensive": "€12.95",
      "coffee": "€3.28",
      "apartment1BedCenter": "€967",
      "monthlyPass": "€60",
      "utilitiesBasic": "€155"
    }
  },
  {
    "name": "Atlanta",
    "country": "United States",
    "costOfLivingIndex": 72.7,
    "rentIndex": 49.3,
    "groceriesIndex": 67,
    "restaurantIndex": 66.7,
    "purchasingPowerIndex": 106.4,
    "safetyIndex": 37.5,
    "climateIndex": 85.2,
    "healthcareIndex": 71.4,
    "trafficEfficiencyIndex": 63.7,
    "pollutionControlIndex": 60.2,
    "internetSpeedIndex": 97.5,
    "typicalExpenses": {
      "mealInexpensive": "$15.10",
      "coffee": "$4.20",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$84.90",
      "utilitiesBasic": "$152"
    }
  },
  {
    "name": "Palermo",
    "country": "Italy",
    "costOfLivingIndex": 52.1,
    "rentIndex": 29.5,
    "groceriesIndex": 43.4,
    "restaurantIndex": 41.2,
    "purchasingPowerIndex": 89.8,
    "safetyIndex": 48.5,
    "climateIndex": 91.5,
    "healthcareIndex": 67.2,
    "trafficEfficiencyIndex": 62.1,
    "pollutionControlIndex": 70.3,
    "internetSpeedIndex": 88.4,
    "typicalExpenses": {
      "mealInexpensive": "€11.41",
      "coffee": "€2.89",
      "apartment1BedCenter": "€905",
      "monthlyPass": "€53",
      "utilitiesBasic": "€137"
    }
  },
  {
    "name": "Philadelphia",
    "country": "United States",
    "costOfLivingIndex": 75.5,
    "rentIndex": 53.6,
    "groceriesIndex": 70,
    "restaurantIndex": 67.7,
    "purchasingPowerIndex": 107.3,
    "safetyIndex": 39.8,
    "climateIndex": 75.1,
    "healthcareIndex": 75.8,
    "trafficEfficiencyIndex": 69.3,
    "pollutionControlIndex": 67.4,
    "internetSpeedIndex": 93.3,
    "typicalExpenses": {
      "mealInexpensive": "$15.70",
      "coffee": "$4.30",
      "apartment1BedCenter": "$2,016",
      "monthlyPass": "$88.00",
      "utilitiesBasic": "$157"
    }
  },
  {
    "name": "Verona",
    "country": "Italy",
    "costOfLivingIndex": 59.5,
    "rentIndex": 22.5,
    "groceriesIndex": 53.2,
    "restaurantIndex": 52.2,
    "purchasingPowerIndex": 78.5,
    "safetyIndex": 71.2,
    "climateIndex": 75.4,
    "healthcareIndex": 79.2,
    "trafficEfficiencyIndex": 64.1,
    "pollutionControlIndex": 68.2,
    "internetSpeedIndex": 91.2,
    "typicalExpenses": {
      "mealInexpensive": "€15.90",
      "coffee": "€1.70",
      "apartment1BedCenter": "€827",
      "monthlyPass": "€44.60",
      "utilitiesBasic": "€170"
    }
  },
  {
    "name": "Washington D.C.",
    "country": "United States",
    "costOfLivingIndex": 86.9,
    "rentIndex": 59.5,
    "groceriesIndex": 80.4,
    "restaurantIndex": 77.4,
    "purchasingPowerIndex": 99.9,
    "safetyIndex": 42.5,
    "climateIndex": 78.4,
    "healthcareIndex": 79.1,
    "trafficEfficiencyIndex": 52.7,
    "pollutionControlIndex": 73.6,
    "internetSpeedIndex": 90.3,
    "typicalExpenses": {
      "mealInexpensive": "$18.10",
      "coffee": "$5.00",
      "apartment1BedCenter": "$2,228",
      "monthlyPass": "$101.80",
      "utilitiesBasic": "$181"
    }
  },
  {
    "name": "Phoenix",
    "country": "United States",
    "costOfLivingIndex": 69.7,
    "rentIndex": 47.4,
    "groceriesIndex": 64.6,
    "restaurantIndex": 63.8,
    "purchasingPowerIndex": 99.7,
    "safetyIndex": 51.4,
    "climateIndex": 72.5,
    "healthcareIndex": 73.4,
    "trafficEfficiencyIndex": 60.2,
    "pollutionControlIndex": 76.4,
    "internetSpeedIndex": 91.2,
    "typicalExpenses": {
      "mealInexpensive": "$14.50",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$81.70",
      "utilitiesBasic": "$145"
    }
  },
  {
    "name": "San Diego",
    "country": "United States",
    "costOfLivingIndex": 86.6,
    "rentIndex": 60.8,
    "groceriesIndex": 83.2,
    "restaurantIndex": 79.9,
    "purchasingPowerIndex": 111.5,
    "safetyIndex": 63.1,
    "climateIndex": 96.2,
    "healthcareIndex": 78.4,
    "trafficEfficiencyIndex": 43.1,
    "pollutionControlIndex": 61.9,
    "internetSpeedIndex": 97,
    "typicalExpenses": {
      "mealInexpensive": "$18.10",
      "coffee": "$5.00",
      "apartment1BedCenter": "$2,281",
      "monthlyPass": "$101.80",
      "utilitiesBasic": "$180"
    }
  },
  {
    "name": "San Jose",
    "country": "United States",
    "costOfLivingIndex": 89.8,
    "rentIndex": 63.6,
    "groceriesIndex": 86.7,
    "restaurantIndex": 82.4,
    "purchasingPowerIndex": 97.9,
    "safetyIndex": 60.5,
    "climateIndex": 88.1,
    "healthcareIndex": 80.5,
    "trafficEfficiencyIndex": 55.2,
    "pollutionControlIndex": 59.4,
    "internetSpeedIndex": 95.2,
    "typicalExpenses": {
      "mealInexpensive": "$18.70",
      "coffee": "$5.10",
      "apartment1BedCenter": "$2,387",
      "monthlyPass": "$105",
      "utilitiesBasic": "$187"
    }
  },
  {
    "name": "Jacksonville",
    "country": "United States",
    "costOfLivingIndex": 65.4,
    "rentIndex": 48,
    "groceriesIndex": 60.6,
    "restaurantIndex": 60.1,
    "purchasingPowerIndex": 110.4,
    "safetyIndex": 44.8,
    "climateIndex": 85.4,
    "healthcareIndex": 68.2,
    "trafficEfficiencyIndex": 49.9,
    "pollutionControlIndex": 64.4,
    "internetSpeedIndex": 99.7,
    "typicalExpenses": {
      "mealInexpensive": "$13.60",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$76.40",
      "utilitiesBasic": "$136"
    }
  },
  {
    "name": "San Antonio",
    "country": "United States",
    "costOfLivingIndex": 63.5,
    "rentIndex": 43.4,
    "groceriesIndex": 60,
    "restaurantIndex": 59.2,
    "purchasingPowerIndex": 96.4,
    "safetyIndex": 51.2,
    "climateIndex": 83.1,
    "healthcareIndex": 69.1,
    "trafficEfficiencyIndex": 57.2,
    "pollutionControlIndex": 55.6,
    "internetSpeedIndex": 91.6,
    "typicalExpenses": {
      "mealInexpensive": "$13.20",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,591",
      "monthlyPass": "$74.30",
      "utilitiesBasic": "$133"
    }
  },
  {
    "name": "Columbus",
    "country": "United States",
    "costOfLivingIndex": 64.6,
    "rentIndex": 46,
    "groceriesIndex": 60.8,
    "restaurantIndex": 56.4,
    "purchasingPowerIndex": 112.1,
    "safetyIndex": 54.1,
    "climateIndex": 70.5,
    "healthcareIndex": 71.5,
    "trafficEfficiencyIndex": 56.9,
    "pollutionControlIndex": 67.8,
    "internetSpeedIndex": 92.2,
    "typicalExpenses": {
      "mealInexpensive": "$13.50",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$75.30",
      "utilitiesBasic": "$135"
    }
  },
  {
    "name": "Indianapolis",
    "country": "United States",
    "costOfLivingIndex": 63.2,
    "rentIndex": 46.1,
    "groceriesIndex": 59.7,
    "restaurantIndex": 56,
    "purchasingPowerIndex": 96.6,
    "safetyIndex": 41.5,
    "climateIndex": 70.1,
    "healthcareIndex": 70.4,
    "trafficEfficiencyIndex": 47,
    "pollutionControlIndex": 75.1,
    "internetSpeedIndex": 87.1,
    "typicalExpenses": {
      "mealInexpensive": "$13.20",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$74.30",
      "utilitiesBasic": "$132"
    }
  },
  {
    "name": "Charlotte",
    "country": "United States",
    "costOfLivingIndex": 69.6,
    "rentIndex": 46.8,
    "groceriesIndex": 67.2,
    "restaurantIndex": 64.6,
    "purchasingPowerIndex": 109.4,
    "safetyIndex": 52.4,
    "climateIndex": 80.2,
    "healthcareIndex": 71.2,
    "trafficEfficiencyIndex": 49.9,
    "pollutionControlIndex": 78.7,
    "internetSpeedIndex": 93.5,
    "typicalExpenses": {
      "mealInexpensive": "$14.50",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$81.70",
      "utilitiesBasic": "$145"
    }
  },
  {
    "name": "Fort Worth",
    "country": "United States",
    "costOfLivingIndex": 67.4,
    "rentIndex": 49.2,
    "groceriesIndex": 62.3,
    "restaurantIndex": 60.7,
    "purchasingPowerIndex": 112.6,
    "safetyIndex": 51.5,
    "climateIndex": 82.4,
    "healthcareIndex": 68.4,
    "trafficEfficiencyIndex": 56.3,
    "pollutionControlIndex": 57.8,
    "internetSpeedIndex": 93.9,
    "typicalExpenses": {
      "mealInexpensive": "$14.00",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$78.50",
      "utilitiesBasic": "$140"
    }
  },
  {
    "name": "El Paso",
    "country": "United States",
    "costOfLivingIndex": 57.1,
    "rentIndex": 41.7,
    "groceriesIndex": 52.8,
    "restaurantIndex": 50,
    "purchasingPowerIndex": 102.6,
    "safetyIndex": 62.4,
    "climateIndex": 81.5,
    "healthcareIndex": 62.5,
    "trafficEfficiencyIndex": 69,
    "pollutionControlIndex": 67.9,
    "internetSpeedIndex": 88.3,
    "typicalExpenses": {
      "mealInexpensive": "$11.90",
      "coffee": "$3.30",
      "apartment1BedCenter": "$1,538",
      "monthlyPass": "$66.80",
      "utilitiesBasic": "$119"
    }
  },
  {
    "name": "Nashville",
    "country": "United States",
    "costOfLivingIndex": 71.5,
    "rentIndex": 52.3,
    "groceriesIndex": 66.7,
    "restaurantIndex": 64.4,
    "purchasingPowerIndex": 114.9,
    "safetyIndex": 47.8,
    "climateIndex": 81.2,
    "healthcareIndex": 72.1,
    "trafficEfficiencyIndex": 50.2,
    "pollutionControlIndex": 75.2,
    "internetSpeedIndex": 87.5,
    "typicalExpenses": {
      "mealInexpensive": "$14.90",
      "coffee": "$4.10",
      "apartment1BedCenter": "$1,963",
      "monthlyPass": "$83.80",
      "utilitiesBasic": "$149"
    }
  },
  {
    "name": "Memphis",
    "country": "United States",
    "costOfLivingIndex": 59.5,
    "rentIndex": 44.1,
    "groceriesIndex": 54.5,
    "restaurantIndex": 55.3,
    "purchasingPowerIndex": 100.7,
    "safetyIndex": 21.5,
    "climateIndex": 81.4,
    "healthcareIndex": 65.4,
    "trafficEfficiencyIndex": 58.9,
    "pollutionControlIndex": 79.8,
    "internetSpeedIndex": 94.5,
    "typicalExpenses": {
      "mealInexpensive": "$12.40",
      "coffee": "$3.40",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$70.00",
      "utilitiesBasic": "$124"
    }
  },
  {
    "name": "Detroit",
    "country": "United States",
    "costOfLivingIndex": 64.2,
    "rentIndex": 44.9,
    "groceriesIndex": 61,
    "restaurantIndex": 58.3,
    "purchasingPowerIndex": 112.4,
    "safetyIndex": 28.4,
    "climateIndex": 68.2,
    "healthcareIndex": 67.5,
    "trafficEfficiencyIndex": 61.4,
    "pollutionControlIndex": 75,
    "internetSpeedIndex": 85.5,
    "typicalExpenses": {
      "mealInexpensive": "$13.40",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$75.30",
      "utilitiesBasic": "$134"
    }
  },
  {
    "name": "Portland",
    "country": "United States",
    "costOfLivingIndex": 78.8,
    "rentIndex": 57.7,
    "groceriesIndex": 76.3,
    "restaurantIndex": 70.4,
    "purchasingPowerIndex": 113.1,
    "safetyIndex": 48.5,
    "climateIndex": 81.5,
    "healthcareIndex": 75.2,
    "trafficEfficiencyIndex": 56,
    "pollutionControlIndex": 75.7,
    "internetSpeedIndex": 89.5,
    "typicalExpenses": {
      "mealInexpensive": "$16.40",
      "coffee": "$4.50",
      "apartment1BedCenter": "$2,122",
      "monthlyPass": "$92.30",
      "utilitiesBasic": "$164"
    }
  },
  {
    "name": "Oklahoma City",
    "country": "United States",
    "costOfLivingIndex": 60,
    "rentIndex": 40.2,
    "groceriesIndex": 57.4,
    "restaurantIndex": 53.2,
    "purchasingPowerIndex": 100.5,
    "safetyIndex": 45.2,
    "climateIndex": 79.4,
    "healthcareIndex": 66.8,
    "trafficEfficiencyIndex": 40,
    "pollutionControlIndex": 61.6,
    "internetSpeedIndex": 94.4,
    "typicalExpenses": {
      "mealInexpensive": "$12.50",
      "coffee": "$3.40",
      "apartment1BedCenter": "$1,485",
      "monthlyPass": "$70.00",
      "utilitiesBasic": "$125"
    }
  },
  {
    "name": "Las Vegas",
    "country": "United States",
    "costOfLivingIndex": 69.4,
    "rentIndex": 49,
    "groceriesIndex": 64.7,
    "restaurantIndex": 64.1,
    "purchasingPowerIndex": 102.5,
    "safetyIndex": 44.1,
    "climateIndex": 75.4,
    "healthcareIndex": 65.2,
    "trafficEfficiencyIndex": 58.9,
    "pollutionControlIndex": 65,
    "internetSpeedIndex": 86.9,
    "typicalExpenses": {
      "mealInexpensive": "$14.50",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$81.70",
      "utilitiesBasic": "$144"
    }
  },
  {
    "name": "Louisville",
    "country": "United States",
    "costOfLivingIndex": 62.3,
    "rentIndex": 41.5,
    "groceriesIndex": 57.6,
    "restaurantIndex": 57.4,
    "purchasingPowerIndex": 108.4,
    "safetyIndex": 42.8,
    "climateIndex": 76.2,
    "healthcareIndex": 69.4,
    "trafficEfficiencyIndex": 51.8,
    "pollutionControlIndex": 55.4,
    "internetSpeedIndex": 89.9,
    "typicalExpenses": {
      "mealInexpensive": "$13.00",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,538",
      "monthlyPass": "$73.20",
      "utilitiesBasic": "$129"
    }
  },
  {
    "name": "Baltimore",
    "country": "United States",
    "costOfLivingIndex": 68,
    "rentIndex": 49.7,
    "groceriesIndex": 63.6,
    "restaurantIndex": 59.8,
    "purchasingPowerIndex": 114.6,
    "safetyIndex": 26.5,
    "climateIndex": 76.5,
    "healthcareIndex": 74.1,
    "trafficEfficiencyIndex": 40.7,
    "pollutionControlIndex": 70.1,
    "internetSpeedIndex": 85.8,
    "typicalExpenses": {
      "mealInexpensive": "$14.20",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,856",
      "monthlyPass": "$79.60",
      "utilitiesBasic": "$142"
    }
  },
  {
    "name": "Milwaukee",
    "country": "United States",
    "costOfLivingIndex": 64.5,
    "rentIndex": 43,
    "groceriesIndex": 62,
    "restaurantIndex": 59.1,
    "purchasingPowerIndex": 97,
    "safetyIndex": 34.2,
    "climateIndex": 65.4,
    "healthcareIndex": 71.8,
    "trafficEfficiencyIndex": 61.9,
    "pollutionControlIndex": 69.9,
    "internetSpeedIndex": 92,
    "typicalExpenses": {
      "mealInexpensive": "$13.50",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,591",
      "monthlyPass": "$75.30",
      "utilitiesBasic": "$135"
    }
  },
  {
    "name": "Albuquerque",
    "country": "United States",
    "costOfLivingIndex": 61.2,
    "rentIndex": 41.2,
    "groceriesIndex": 59.5,
    "restaurantIndex": 53.8,
    "purchasingPowerIndex": 105.1,
    "safetyIndex": 32.8,
    "climateIndex": 82.4,
    "healthcareIndex": 66.5,
    "trafficEfficiencyIndex": 63.3,
    "pollutionControlIndex": 60.4,
    "internetSpeedIndex": 88.5,
    "typicalExpenses": {
      "mealInexpensive": "$12.80",
      "coffee": "$3.50",
      "apartment1BedCenter": "$1,538",
      "monthlyPass": "$72.10",
      "utilitiesBasic": "$127"
    }
  },
  {
    "name": "Tucson",
    "country": "United States",
    "costOfLivingIndex": 62.6,
    "rentIndex": 45.9,
    "groceriesIndex": 61.2,
    "restaurantIndex": 57.2,
    "purchasingPowerIndex": 110.8,
    "safetyIndex": 48.1,
    "climateIndex": 78.5,
    "healthcareIndex": 68.1,
    "trafficEfficiencyIndex": 47.8,
    "pollutionControlIndex": 73.3,
    "internetSpeedIndex": 96.8,
    "typicalExpenses": {
      "mealInexpensive": "$13.00",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$73.20",
      "utilitiesBasic": "$131"
    }
  },
  {
    "name": "Fresno",
    "country": "United States",
    "costOfLivingIndex": 67.6,
    "rentIndex": 46.8,
    "groceriesIndex": 66.1,
    "restaurantIndex": 62.9,
    "purchasingPowerIndex": 95.8,
    "safetyIndex": 41.2,
    "climateIndex": 83.4,
    "healthcareIndex": 64.2,
    "trafficEfficiencyIndex": 49.4,
    "pollutionControlIndex": 79.4,
    "internetSpeedIndex": 89.7,
    "typicalExpenses": {
      "mealInexpensive": "$14.10",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$79.60",
      "utilitiesBasic": "$141"
    }
  },
  {
    "name": "Sacramento",
    "country": "United States",
    "costOfLivingIndex": 75.4,
    "rentIndex": 55.1,
    "groceriesIndex": 69.5,
    "restaurantIndex": 66.6,
    "purchasingPowerIndex": 100.6,
    "safetyIndex": 48.4,
    "climateIndex": 86.1,
    "healthcareIndex": 72.8,
    "trafficEfficiencyIndex": 40.7,
    "pollutionControlIndex": 70.6,
    "internetSpeedIndex": 92.6,
    "typicalExpenses": {
      "mealInexpensive": "$15.70",
      "coffee": "$4.30",
      "apartment1BedCenter": "$2,069",
      "monthlyPass": "$88.00",
      "utilitiesBasic": "$157"
    }
  },
  {
    "name": "Mesa",
    "country": "United States",
    "costOfLivingIndex": 66.4,
    "rentIndex": 44.3,
    "groceriesIndex": 64.7,
    "restaurantIndex": 61.3,
    "purchasingPowerIndex": 114.6,
    "safetyIndex": 58.2,
    "climateIndex": 73.1,
    "healthcareIndex": 67.4,
    "trafficEfficiencyIndex": 59.7,
    "pollutionControlIndex": 55.3,
    "internetSpeedIndex": 86.9,
    "typicalExpenses": {
      "mealInexpensive": "$13.80",
      "coffee": "$3.80",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$77.40",
      "utilitiesBasic": "$138"
    }
  },
  {
    "name": "Kansas City",
    "country": "United States",
    "costOfLivingIndex": 63.9,
    "rentIndex": 47.1,
    "groceriesIndex": 61.8,
    "restaurantIndex": 57.8,
    "purchasingPowerIndex": 109.9,
    "safetyIndex": 39.5,
    "climateIndex": 72.4,
    "healthcareIndex": 70.1,
    "trafficEfficiencyIndex": 48.5,
    "pollutionControlIndex": 74.4,
    "internetSpeedIndex": 98.1,
    "typicalExpenses": {
      "mealInexpensive": "$13.30",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$75.30",
      "utilitiesBasic": "$134"
    }
  },
  {
    "name": "Omaha",
    "country": "United States",
    "costOfLivingIndex": 61.6,
    "rentIndex": 44.4,
    "groceriesIndex": 58.2,
    "restaurantIndex": 56.1,
    "purchasingPowerIndex": 99.9,
    "safetyIndex": 58.1,
    "climateIndex": 69.5,
    "healthcareIndex": 71.2,
    "trafficEfficiencyIndex": 48,
    "pollutionControlIndex": 62.9,
    "internetSpeedIndex": 88,
    "typicalExpenses": {
      "mealInexpensive": "$12.80",
      "coffee": "$3.50",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$72.10",
      "utilitiesBasic": "$128"
    }
  },
  {
    "name": "Colorado Springs",
    "country": "United States",
    "costOfLivingIndex": 68.6,
    "rentIndex": 47.2,
    "groceriesIndex": 66.1,
    "restaurantIndex": 59.9,
    "purchasingPowerIndex": 110.6,
    "safetyIndex": 59.4,
    "climateIndex": 76.1,
    "healthcareIndex": 71.5,
    "trafficEfficiencyIndex": 47,
    "pollutionControlIndex": 64,
    "internetSpeedIndex": 86.7,
    "typicalExpenses": {
      "mealInexpensive": "$14.30",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$80.60",
      "utilitiesBasic": "$143"
    }
  },
  {
    "name": "Raleigh",
    "country": "United States",
    "costOfLivingIndex": 67.7,
    "rentIndex": 46.6,
    "groceriesIndex": 65.5,
    "restaurantIndex": 61.1,
    "purchasingPowerIndex": 104.4,
    "safetyIndex": 66.2,
    "climateIndex": 80.4,
    "healthcareIndex": 75.4,
    "trafficEfficiencyIndex": 68.4,
    "pollutionControlIndex": 60.4,
    "internetSpeedIndex": 88.3,
    "typicalExpenses": {
      "mealInexpensive": "$14.10",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$79.60",
      "utilitiesBasic": "$141"
    }
  },
  {
    "name": "Virginia Beach",
    "country": "United States",
    "costOfLivingIndex": 64.9,
    "rentIndex": 45.9,
    "groceriesIndex": 62.7,
    "restaurantIndex": 59.3,
    "purchasingPowerIndex": 111,
    "safetyIndex": 61.5,
    "climateIndex": 81.2,
    "healthcareIndex": 70.5,
    "trafficEfficiencyIndex": 49.8,
    "pollutionControlIndex": 67.6,
    "internetSpeedIndex": 95.1,
    "typicalExpenses": {
      "mealInexpensive": "$13.50",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$76.40",
      "utilitiesBasic": "$136"
    }
  },
  {
    "name": "Long Beach",
    "country": "United States",
    "costOfLivingIndex": 82.7,
    "rentIndex": 56.1,
    "groceriesIndex": 78.6,
    "restaurantIndex": 75,
    "purchasingPowerIndex": 111.5,
    "safetyIndex": 46.8,
    "climateIndex": 94.1,
    "healthcareIndex": 72.1,
    "trafficEfficiencyIndex": 52.8,
    "pollutionControlIndex": 64.2,
    "internetSpeedIndex": 89.2,
    "typicalExpenses": {
      "mealInexpensive": "$17.20",
      "coffee": "$4.70",
      "apartment1BedCenter": "$2,069",
      "monthlyPass": "$96.50",
      "utilitiesBasic": "$172"
    }
  },
  {
    "name": "Oakland",
    "country": "United States",
    "costOfLivingIndex": 83,
    "rentIndex": 56.4,
    "groceriesIndex": 78.8,
    "restaurantIndex": 75.7,
    "purchasingPowerIndex": 105.9,
    "safetyIndex": 31.4,
    "climateIndex": 86.5,
    "healthcareIndex": 74.5,
    "trafficEfficiencyIndex": 54.5,
    "pollutionControlIndex": 77.4,
    "internetSpeedIndex": 86,
    "typicalExpenses": {
      "mealInexpensive": "$17.30",
      "coffee": "$4.80",
      "apartment1BedCenter": "$2,069",
      "monthlyPass": "$97.60",
      "utilitiesBasic": "$173"
    }
  },
  {
    "name": "Minneapolis",
    "country": "United States",
    "costOfLivingIndex": 74.8,
    "rentIndex": 50.4,
    "groceriesIndex": 72,
    "restaurantIndex": 67.8,
    "purchasingPowerIndex": 98.5,
    "safetyIndex": 45.8,
    "climateIndex": 58.2,
    "healthcareIndex": 77.4,
    "trafficEfficiencyIndex": 50.9,
    "pollutionControlIndex": 79,
    "internetSpeedIndex": 88.8,
    "typicalExpenses": {
      "mealInexpensive": "$15.60",
      "coffee": "$4.30",
      "apartment1BedCenter": "$1,856",
      "monthlyPass": "$88.00",
      "utilitiesBasic": "$156"
    }
  },
  {
    "name": "Tulsa",
    "country": "United States",
    "costOfLivingIndex": 57.4,
    "rentIndex": 41.7,
    "groceriesIndex": 53.4,
    "restaurantIndex": 52.8,
    "purchasingPowerIndex": 102.9,
    "safetyIndex": 44.1,
    "climateIndex": 79.2,
    "healthcareIndex": 66.5,
    "trafficEfficiencyIndex": 45.1,
    "pollutionControlIndex": 59.8,
    "internetSpeedIndex": 89.9,
    "typicalExpenses": {
      "mealInexpensive": "$12.00",
      "coffee": "$3.30",
      "apartment1BedCenter": "$1,538",
      "monthlyPass": "$66.80",
      "utilitiesBasic": "$120"
    }
  },
  {
    "name": "Bakersfield",
    "country": "United States",
    "costOfLivingIndex": 64.3,
    "rentIndex": 46.6,
    "groceriesIndex": 60.2,
    "restaurantIndex": 59.4,
    "purchasingPowerIndex": 108,
    "safetyIndex": 38.5,
    "climateIndex": 81.4,
    "healthcareIndex": 61.2,
    "trafficEfficiencyIndex": 59.6,
    "pollutionControlIndex": 78.2,
    "internetSpeedIndex": 95.4,
    "typicalExpenses": {
      "mealInexpensive": "$13.40",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$75.30",
      "utilitiesBasic": "$134"
    }
  },
  {
    "name": "Tampa",
    "country": "United States",
    "costOfLivingIndex": 68.7,
    "rentIndex": 46.3,
    "groceriesIndex": 64.7,
    "restaurantIndex": 61.2,
    "purchasingPowerIndex": 112.9,
    "safetyIndex": 54.2,
    "climateIndex": 88.5,
    "healthcareIndex": 71.4,
    "trafficEfficiencyIndex": 48.6,
    "pollutionControlIndex": 70.3,
    "internetSpeedIndex": 99,
    "typicalExpenses": {
      "mealInexpensive": "$14.30",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$80.60",
      "utilitiesBasic": "$143"
    }
  },
  {
    "name": "Wichita",
    "country": "United States",
    "costOfLivingIndex": 57.1,
    "rentIndex": 39.5,
    "groceriesIndex": 52.2,
    "restaurantIndex": 49.7,
    "purchasingPowerIndex": 97.5,
    "safetyIndex": 52.1,
    "climateIndex": 71.4,
    "healthcareIndex": 68.2,
    "trafficEfficiencyIndex": 64.7,
    "pollutionControlIndex": 73.6,
    "internetSpeedIndex": 88,
    "typicalExpenses": {
      "mealInexpensive": "$11.90",
      "coffee": "$3.30",
      "apartment1BedCenter": "$1,485",
      "monthlyPass": "$66.80",
      "utilitiesBasic": "$119"
    }
  },
  {
    "name": "Arlington",
    "country": "United States",
    "costOfLivingIndex": 65.7,
    "rentIndex": 46.3,
    "groceriesIndex": 63.9,
    "restaurantIndex": 59.6,
    "purchasingPowerIndex": 112.4,
    "safetyIndex": 56.4,
    "climateIndex": 82.1,
    "healthcareIndex": 69.5,
    "trafficEfficiencyIndex": 62,
    "pollutionControlIndex": 62.9,
    "internetSpeedIndex": 94.6,
    "typicalExpenses": {
      "mealInexpensive": "$13.70",
      "coffee": "$3.80",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$77.40",
      "utilitiesBasic": "$137"
    }
  },
  {
    "name": "New Orleans",
    "country": "United States",
    "costOfLivingIndex": 68.4,
    "rentIndex": 47.5,
    "groceriesIndex": 66.3,
    "restaurantIndex": 59.8,
    "purchasingPowerIndex": 102.4,
    "safetyIndex": 25.8,
    "climateIndex": 84.1,
    "healthcareIndex": 65.8,
    "trafficEfficiencyIndex": 53.5,
    "pollutionControlIndex": 59.3,
    "internetSpeedIndex": 91.1,
    "typicalExpenses": {
      "mealInexpensive": "$14.30",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$80.60",
      "utilitiesBasic": "$142"
    }
  },
  {
    "name": "Cleveland",
    "country": "United States",
    "costOfLivingIndex": 62.5,
    "rentIndex": 43.7,
    "groceriesIndex": 60.8,
    "restaurantIndex": 56.9,
    "purchasingPowerIndex": 112.5,
    "safetyIndex": 35.1,
    "climateIndex": 68.4,
    "healthcareIndex": 76.5,
    "trafficEfficiencyIndex": 55.6,
    "pollutionControlIndex": 62.5,
    "internetSpeedIndex": 92.4,
    "typicalExpenses": {
      "mealInexpensive": "$13.00",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$73.20",
      "utilitiesBasic": "$131"
    }
  },
  {
    "name": "Anaheim",
    "country": "United States",
    "costOfLivingIndex": 80.6,
    "rentIndex": 56.1,
    "groceriesIndex": 77.9,
    "restaurantIndex": 73.3,
    "purchasingPowerIndex": 98.4,
    "safetyIndex": 51.5,
    "climateIndex": 94.2,
    "healthcareIndex": 73.1,
    "trafficEfficiencyIndex": 43,
    "pollutionControlIndex": 66.1,
    "internetSpeedIndex": 98.2,
    "typicalExpenses": {
      "mealInexpensive": "$16.80",
      "coffee": "$4.60",
      "apartment1BedCenter": "$2,069",
      "monthlyPass": "$94.40",
      "utilitiesBasic": "$168"
    }
  },
  {
    "name": "Honolulu",
    "country": "United States",
    "costOfLivingIndex": 93.1,
    "rentIndex": 67.4,
    "groceriesIndex": 86.4,
    "restaurantIndex": 82.2,
    "purchasingPowerIndex": 96.8,
    "safetyIndex": 56.2,
    "climateIndex": 91.5,
    "healthcareIndex": 76.4,
    "trafficEfficiencyIndex": 56.1,
    "pollutionControlIndex": 71.3,
    "internetSpeedIndex": 91.1,
    "typicalExpenses": {
      "mealInexpensive": "$19.40",
      "coffee": "$5.30",
      "apartment1BedCenter": "$2,493",
      "monthlyPass": "$109",
      "utilitiesBasic": "$194"
    }
  },
  {
    "name": "Santa Ana",
    "country": "United States",
    "costOfLivingIndex": 79.8,
    "rentIndex": 57,
    "groceriesIndex": 77.4,
    "restaurantIndex": 71.8,
    "purchasingPowerIndex": 103.9,
    "safetyIndex": 53.4,
    "climateIndex": 94.1,
    "healthcareIndex": 70.2,
    "trafficEfficiencyIndex": 52.4,
    "pollutionControlIndex": 79.3,
    "internetSpeedIndex": 98.8,
    "typicalExpenses": {
      "mealInexpensive": "$16.60",
      "coffee": "$4.60",
      "apartment1BedCenter": "$2,122",
      "monthlyPass": "$93.40",
      "utilitiesBasic": "$167"
    }
  },
  {
    "name": "Riverside",
    "country": "United States",
    "costOfLivingIndex": 72.5,
    "rentIndex": 50,
    "groceriesIndex": 70.2,
    "restaurantIndex": 63.4,
    "purchasingPowerIndex": 113.8,
    "safetyIndex": 44.5,
    "climateIndex": 88.2,
    "healthcareIndex": 66.4,
    "trafficEfficiencyIndex": 69.7,
    "pollutionControlIndex": 68.3,
    "internetSpeedIndex": 93.3,
    "typicalExpenses": {
      "mealInexpensive": "$15.10",
      "coffee": "$4.20",
      "apartment1BedCenter": "$1,856",
      "monthlyPass": "$84.90",
      "utilitiesBasic": "$151"
    }
  },
  {
    "name": "Corpus Christi",
    "country": "United States",
    "costOfLivingIndex": 58.5,
    "rentIndex": 39.1,
    "groceriesIndex": 57.3,
    "restaurantIndex": 51.3,
    "purchasingPowerIndex": 110.2,
    "safetyIndex": 51.8,
    "climateIndex": 82.5,
    "healthcareIndex": 63.5,
    "trafficEfficiencyIndex": 41,
    "pollutionControlIndex": 67.1,
    "internetSpeedIndex": 93.6,
    "typicalExpenses": {
      "mealInexpensive": "$12.20",
      "coffee": "$3.40",
      "apartment1BedCenter": "$1,432",
      "monthlyPass": "$69.00",
      "utilitiesBasic": "$122"
    }
  },
  {
    "name": "Lexington",
    "country": "United States",
    "costOfLivingIndex": 61.2,
    "rentIndex": 42.8,
    "groceriesIndex": 57.9,
    "restaurantIndex": 57,
    "purchasingPowerIndex": 112.4,
    "safetyIndex": 58.4,
    "climateIndex": 74.1,
    "healthcareIndex": 71.2,
    "trafficEfficiencyIndex": 55.8,
    "pollutionControlIndex": 72.9,
    "internetSpeedIndex": 89.7,
    "typicalExpenses": {
      "mealInexpensive": "$12.80",
      "coffee": "$3.50",
      "apartment1BedCenter": "$1,591",
      "monthlyPass": "$72.10",
      "utilitiesBasic": "$127"
    }
  },
  {
    "name": "Henderson",
    "country": "United States",
    "costOfLivingIndex": 70,
    "rentIndex": 48.5,
    "groceriesIndex": 67.1,
    "restaurantIndex": 62.7,
    "purchasingPowerIndex": 105.6,
    "safetyIndex": 61.2,
    "climateIndex": 75.2,
    "healthcareIndex": 66.4,
    "trafficEfficiencyIndex": 67.9,
    "pollutionControlIndex": 69,
    "internetSpeedIndex": 88.3,
    "typicalExpenses": {
      "mealInexpensive": "$14.60",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$81.70",
      "utilitiesBasic": "$146"
    }
  },
  {
    "name": "Stockton",
    "country": "United States",
    "costOfLivingIndex": 66.6,
    "rentIndex": 46.3,
    "groceriesIndex": 62.6,
    "restaurantIndex": 60.6,
    "purchasingPowerIndex": 100.3,
    "safetyIndex": 35.8,
    "climateIndex": 85.1,
    "healthcareIndex": 62.4,
    "trafficEfficiencyIndex": 66.5,
    "pollutionControlIndex": 70.2,
    "internetSpeedIndex": 97.6,
    "typicalExpenses": {
      "mealInexpensive": "$13.90",
      "coffee": "$3.80",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$78.50",
      "utilitiesBasic": "$139"
    }
  },
  {
    "name": "Saint Paul",
    "country": "United States",
    "costOfLivingIndex": 72.8,
    "rentIndex": 52.4,
    "groceriesIndex": 70.7,
    "restaurantIndex": 63.6,
    "purchasingPowerIndex": 109,
    "safetyIndex": 50.4,
    "climateIndex": 58.4,
    "healthcareIndex": 76.2,
    "trafficEfficiencyIndex": 42.6,
    "pollutionControlIndex": 55.9,
    "internetSpeedIndex": 85.9,
    "typicalExpenses": {
      "mealInexpensive": "$15.20",
      "coffee": "$4.20",
      "apartment1BedCenter": "$1,963",
      "monthlyPass": "$84.90",
      "utilitiesBasic": "$152"
    }
  },
  {
    "name": "Cincinnati",
    "country": "United States",
    "costOfLivingIndex": 63.2,
    "rentIndex": 45.4,
    "groceriesIndex": 58.2,
    "restaurantIndex": 56.4,
    "purchasingPowerIndex": 103.8,
    "safetyIndex": 51.5,
    "climateIndex": 72.1,
    "healthcareIndex": 73.1,
    "trafficEfficiencyIndex": 55.7,
    "pollutionControlIndex": 78.4,
    "internetSpeedIndex": 88.7,
    "typicalExpenses": {
      "mealInexpensive": "$13.20",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$74.30",
      "utilitiesBasic": "$132"
    }
  },
  {
    "name": "St. Louis",
    "country": "United States",
    "costOfLivingIndex": 62.6,
    "rentIndex": 42.8,
    "groceriesIndex": 59.9,
    "restaurantIndex": 55.9,
    "purchasingPowerIndex": 98.8,
    "safetyIndex": 29.5,
    "climateIndex": 72.4,
    "healthcareIndex": 71.4,
    "trafficEfficiencyIndex": 53.6,
    "pollutionControlIndex": 62.2,
    "internetSpeedIndex": 91.9,
    "typicalExpenses": {
      "mealInexpensive": "$13.00",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,591",
      "monthlyPass": "$73.20",
      "utilitiesBasic": "$131"
    }
  },
  {
    "name": "Pittsburgh",
    "country": "United States",
    "costOfLivingIndex": 66.4,
    "rentIndex": 46.2,
    "groceriesIndex": 64.1,
    "restaurantIndex": 61.7,
    "purchasingPowerIndex": 102,
    "safetyIndex": 54.8,
    "climateIndex": 69.5,
    "healthcareIndex": 75.2,
    "trafficEfficiencyIndex": 63.4,
    "pollutionControlIndex": 71.5,
    "internetSpeedIndex": 97.9,
    "typicalExpenses": {
      "mealInexpensive": "$13.80",
      "coffee": "$3.80",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$77.40",
      "utilitiesBasic": "$138"
    }
  },
  {
    "name": "Greensboro",
    "country": "United States",
    "costOfLivingIndex": 58.4,
    "rentIndex": 40.2,
    "groceriesIndex": 53.9,
    "restaurantIndex": 51.2,
    "purchasingPowerIndex": 97.6,
    "safetyIndex": 52.1,
    "climateIndex": 78.1,
    "healthcareIndex": 69.2,
    "trafficEfficiencyIndex": 45.5,
    "pollutionControlIndex": 57.3,
    "internetSpeedIndex": 89.5,
    "typicalExpenses": {
      "mealInexpensive": "$12.20",
      "coffee": "$3.40",
      "apartment1BedCenter": "$1,485",
      "monthlyPass": "$69.00",
      "utilitiesBasic": "$122"
    }
  },
  {
    "name": "Lincoln",
    "country": "United States",
    "costOfLivingIndex": 62.3,
    "rentIndex": 42.9,
    "groceriesIndex": 59.1,
    "restaurantIndex": 57.2,
    "purchasingPowerIndex": 99.3,
    "safetyIndex": 61.4,
    "climateIndex": 69.1,
    "healthcareIndex": 70.5,
    "trafficEfficiencyIndex": 52.1,
    "pollutionControlIndex": 60.6,
    "internetSpeedIndex": 91.4,
    "typicalExpenses": {
      "mealInexpensive": "$13.00",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,591",
      "monthlyPass": "$73.20",
      "utilitiesBasic": "$129"
    }
  },
  {
    "name": "Anchorage",
    "country": "United States",
    "costOfLivingIndex": 77.9,
    "rentIndex": 52.1,
    "groceriesIndex": 74.7,
    "restaurantIndex": 71.5,
    "purchasingPowerIndex": 107.5,
    "safetyIndex": 48.2,
    "climateIndex": 42.1,
    "healthcareIndex": 65.8,
    "trafficEfficiencyIndex": 60.8,
    "pollutionControlIndex": 56.7,
    "internetSpeedIndex": 91.7,
    "typicalExpenses": {
      "mealInexpensive": "$16.20",
      "coffee": "$4.50",
      "apartment1BedCenter": "$1,963",
      "monthlyPass": "$91.20",
      "utilitiesBasic": "$162"
    }
  },
  {
    "name": "Plano",
    "country": "United States",
    "costOfLivingIndex": 68.4,
    "rentIndex": 46.2,
    "groceriesIndex": 64.7,
    "restaurantIndex": 59.7,
    "purchasingPowerIndex": 104.5,
    "safetyIndex": 72.5,
    "climateIndex": 82.4,
    "healthcareIndex": 72.4,
    "trafficEfficiencyIndex": 65.9,
    "pollutionControlIndex": 70.7,
    "internetSpeedIndex": 92.2,
    "typicalExpenses": {
      "mealInexpensive": "$14.30",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$80.60",
      "utilitiesBasic": "$142"
    }
  },
  {
    "name": "Orlando",
    "country": "United States",
    "costOfLivingIndex": 70.3,
    "rentIndex": 48,
    "groceriesIndex": 65.7,
    "restaurantIndex": 65.4,
    "purchasingPowerIndex": 106,
    "safetyIndex": 48.5,
    "climateIndex": 87.2,
    "healthcareIndex": 69.5,
    "trafficEfficiencyIndex": 41.9,
    "pollutionControlIndex": 62.4,
    "internetSpeedIndex": 94.4,
    "typicalExpenses": {
      "mealInexpensive": "$14.70",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$82.70",
      "utilitiesBasic": "$146"
    }
  },
  {
    "name": "Irvine",
    "country": "United States",
    "costOfLivingIndex": 84.9,
    "rentIndex": 60.2,
    "groceriesIndex": 82.4,
    "restaurantIndex": 75.9,
    "purchasingPowerIndex": 100.3,
    "safetyIndex": 78.2,
    "climateIndex": 94.5,
    "healthcareIndex": 78.2,
    "trafficEfficiencyIndex": 57.4,
    "pollutionControlIndex": 68.7,
    "internetSpeedIndex": 99.8,
    "typicalExpenses": {
      "mealInexpensive": "$17.70",
      "coffee": "$4.90",
      "apartment1BedCenter": "$2,228",
      "monthlyPass": "$99.70",
      "utilitiesBasic": "$177"
    }
  },
  {
    "name": "Newark",
    "country": "United States",
    "costOfLivingIndex": 72.5,
    "rentIndex": 51.4,
    "groceriesIndex": 68.4,
    "restaurantIndex": 64,
    "purchasingPowerIndex": 113.8,
    "safetyIndex": 36.4,
    "climateIndex": 78.1,
    "healthcareIndex": 68.5,
    "trafficEfficiencyIndex": 69.2,
    "pollutionControlIndex": 65.3,
    "internetSpeedIndex": 97.7,
    "typicalExpenses": {
      "mealInexpensive": "$15.10",
      "coffee": "$4.20",
      "apartment1BedCenter": "$1,909",
      "monthlyPass": "$84.90",
      "utilitiesBasic": "$151"
    }
  },
  {
    "name": "Toledo",
    "country": "United States",
    "costOfLivingIndex": 57.4,
    "rentIndex": 37.9,
    "groceriesIndex": 55.1,
    "restaurantIndex": 52.3,
    "purchasingPowerIndex": 99.1,
    "safetyIndex": 42.5,
    "climateIndex": 67.4,
    "healthcareIndex": 68.1,
    "trafficEfficiencyIndex": 58.3,
    "pollutionControlIndex": 77.8,
    "internetSpeedIndex": 99.1,
    "typicalExpenses": {
      "mealInexpensive": "$12.00",
      "coffee": "$3.30",
      "apartment1BedCenter": "$1,432",
      "monthlyPass": "$66.80",
      "utilitiesBasic": "$120"
    }
  },
  {
    "name": "Durham",
    "country": "United States",
    "costOfLivingIndex": 65.4,
    "rentIndex": 47.2,
    "groceriesIndex": 60.9,
    "restaurantIndex": 58.1,
    "purchasingPowerIndex": 98.7,
    "safetyIndex": 51.8,
    "climateIndex": 80.2,
    "healthcareIndex": 76.4,
    "trafficEfficiencyIndex": 69.4,
    "pollutionControlIndex": 70.9,
    "internetSpeedIndex": 90.6,
    "typicalExpenses": {
      "mealInexpensive": "$13.60",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$76.40",
      "utilitiesBasic": "$136"
    }
  },
  {
    "name": "Chula Vista",
    "country": "United States",
    "costOfLivingIndex": 79.5,
    "rentIndex": 54.9,
    "groceriesIndex": 77.2,
    "restaurantIndex": 73,
    "purchasingPowerIndex": 108.7,
    "safetyIndex": 64.1,
    "climateIndex": 96.5,
    "healthcareIndex": 72.8,
    "trafficEfficiencyIndex": 48.2,
    "pollutionControlIndex": 78.1,
    "internetSpeedIndex": 89.5,
    "typicalExpenses": {
      "mealInexpensive": "$16.60",
      "coffee": "$4.60",
      "apartment1BedCenter": "$2,016",
      "monthlyPass": "$93.40",
      "utilitiesBasic": "$166"
    }
  },
  {
    "name": "Fort Wayne",
    "country": "United States",
    "costOfLivingIndex": 57.5,
    "rentIndex": 41.2,
    "groceriesIndex": 52.8,
    "restaurantIndex": 52.4,
    "purchasingPowerIndex": 102,
    "safetyIndex": 58.4,
    "climateIndex": 68.2,
    "healthcareIndex": 69.2,
    "trafficEfficiencyIndex": 60.7,
    "pollutionControlIndex": 77,
    "internetSpeedIndex": 89.3,
    "typicalExpenses": {
      "mealInexpensive": "$12.00",
      "coffee": "$3.30",
      "apartment1BedCenter": "$1,538",
      "monthlyPass": "$67.90",
      "utilitiesBasic": "$120"
    }
  },
  {
    "name": "Jersey City",
    "country": "United States",
    "costOfLivingIndex": 87.8,
    "rentIndex": 62.7,
    "groceriesIndex": 81.2,
    "restaurantIndex": 77.2,
    "purchasingPowerIndex": 98.7,
    "safetyIndex": 54.1,
    "climateIndex": 78.5,
    "healthcareIndex": 72.1,
    "trafficEfficiencyIndex": 69.1,
    "pollutionControlIndex": 63.2,
    "internetSpeedIndex": 89.8,
    "typicalExpenses": {
      "mealInexpensive": "$18.30",
      "coffee": "$5.00",
      "apartment1BedCenter": "$2,334",
      "monthlyPass": "$103",
      "utilitiesBasic": "$183"
    }
  },
  {
    "name": "St. Petersburg",
    "country": "United States",
    "costOfLivingIndex": 68.3,
    "rentIndex": 47.6,
    "groceriesIndex": 65,
    "restaurantIndex": 59.6,
    "purchasingPowerIndex": 106,
    "safetyIndex": 58.2,
    "climateIndex": 87.1,
    "healthcareIndex": 70.4,
    "trafficEfficiencyIndex": 54.7,
    "pollutionControlIndex": 61.4,
    "internetSpeedIndex": 96,
    "typicalExpenses": {
      "mealInexpensive": "$14.20",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$79.60",
      "utilitiesBasic": "$142"
    }
  },
  {
    "name": "Laredo",
    "country": "United States",
    "costOfLivingIndex": 54.1,
    "rentIndex": 39.6,
    "groceriesIndex": 50.4,
    "restaurantIndex": 48.6,
    "purchasingPowerIndex": 114.5,
    "safetyIndex": 60.1,
    "climateIndex": 82.4,
    "healthcareIndex": 59.2,
    "trafficEfficiencyIndex": 54.7,
    "pollutionControlIndex": 61.1,
    "internetSpeedIndex": 89.5,
    "typicalExpenses": {
      "mealInexpensive": "$11.30",
      "coffee": "$3.10",
      "apartment1BedCenter": "$1,485",
      "monthlyPass": "$63.60",
      "utilitiesBasic": "$112"
    }
  },
  {
    "name": "Madison",
    "country": "United States",
    "costOfLivingIndex": 67.7,
    "rentIndex": 48.6,
    "groceriesIndex": 63.5,
    "restaurantIndex": 62.6,
    "purchasingPowerIndex": 107.5,
    "safetyIndex": 67.4,
    "climateIndex": 63.2,
    "healthcareIndex": 78.5,
    "trafficEfficiencyIndex": 58.6,
    "pollutionControlIndex": 71.4,
    "internetSpeedIndex": 90.9,
    "typicalExpenses": {
      "mealInexpensive": "$14.10",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$79.60",
      "utilitiesBasic": "$141"
    }
  },
  {
    "name": "Chandler",
    "country": "United States",
    "costOfLivingIndex": 69.4,
    "rentIndex": 48.6,
    "groceriesIndex": 67.5,
    "restaurantIndex": 60.6,
    "purchasingPowerIndex": 97.6,
    "safetyIndex": 65.2,
    "climateIndex": 73.4,
    "healthcareIndex": 69.1,
    "trafficEfficiencyIndex": 61.3,
    "pollutionControlIndex": 56.8,
    "internetSpeedIndex": 87.4,
    "typicalExpenses": {
      "mealInexpensive": "$14.50",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$81.70",
      "utilitiesBasic": "$144"
    }
  },
  {
    "name": "Buffalo",
    "country": "United States",
    "costOfLivingIndex": 63.5,
    "rentIndex": 46.4,
    "groceriesIndex": 60.9,
    "restaurantIndex": 57.4,
    "purchasingPowerIndex": 99.2,
    "safetyIndex": 48.5,
    "climateIndex": 62.1,
    "healthcareIndex": 71.5,
    "trafficEfficiencyIndex": 52.9,
    "pollutionControlIndex": 58.2,
    "internetSpeedIndex": 89,
    "typicalExpenses": {
      "mealInexpensive": "$13.20",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$74.30",
      "utilitiesBasic": "$133"
    }
  },
  {
    "name": "Lubbock",
    "country": "United States",
    "costOfLivingIndex": 56.4,
    "rentIndex": 40.4,
    "groceriesIndex": 53.2,
    "restaurantIndex": 52.1,
    "purchasingPowerIndex": 114.6,
    "safetyIndex": 48.2,
    "climateIndex": 80.1,
    "healthcareIndex": 65.2,
    "trafficEfficiencyIndex": 62.4,
    "pollutionControlIndex": 58.5,
    "internetSpeedIndex": 86.6,
    "typicalExpenses": {
      "mealInexpensive": "$11.80",
      "coffee": "$3.20",
      "apartment1BedCenter": "$1,485",
      "monthlyPass": "$65.80",
      "utilitiesBasic": "$118"
    }
  },
  {
    "name": "Scottsdale",
    "country": "United States",
    "costOfLivingIndex": 78.6,
    "rentIndex": 53,
    "groceriesIndex": 73.9,
    "restaurantIndex": 69.6,
    "purchasingPowerIndex": 99.2,
    "safetyIndex": 74.1,
    "climateIndex": 74.2,
    "healthcareIndex": 75.4,
    "trafficEfficiencyIndex": 68.4,
    "pollutionControlIndex": 66.2,
    "internetSpeedIndex": 98.6,
    "typicalExpenses": {
      "mealInexpensive": "$16.40",
      "coffee": "$4.50",
      "apartment1BedCenter": "$1,963",
      "monthlyPass": "$92.30",
      "utilitiesBasic": "$163"
    }
  },
  {
    "name": "Reno",
    "country": "United States",
    "costOfLivingIndex": 68.7,
    "rentIndex": 47.4,
    "groceriesIndex": 64.2,
    "restaurantIndex": 64,
    "purchasingPowerIndex": 109.9,
    "safetyIndex": 54.5,
    "climateIndex": 76.1,
    "healthcareIndex": 68.4,
    "trafficEfficiencyIndex": 54.5,
    "pollutionControlIndex": 78.7,
    "internetSpeedIndex": 99.3,
    "typicalExpenses": {
      "mealInexpensive": "$14.30",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$80.60",
      "utilitiesBasic": "$143"
    }
  },
  {
    "name": "Glendale",
    "country": "United States",
    "costOfLivingIndex": 67.3,
    "rentIndex": 47,
    "groceriesIndex": 62.6,
    "restaurantIndex": 59.5,
    "purchasingPowerIndex": 101.4,
    "safetyIndex": 50.2,
    "climateIndex": 73.2,
    "healthcareIndex": 67.1,
    "trafficEfficiencyIndex": 58.9,
    "pollutionControlIndex": 57.9,
    "internetSpeedIndex": 94.9,
    "typicalExpenses": {
      "mealInexpensive": "$14.00",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$78.50",
      "utilitiesBasic": "$140"
    }
  },
  {
    "name": "Gilbert",
    "country": "United States",
    "costOfLivingIndex": 69.7,
    "rentIndex": 49,
    "groceriesIndex": 65.7,
    "restaurantIndex": 63.8,
    "purchasingPowerIndex": 110.2,
    "safetyIndex": 76.4,
    "climateIndex": 73.1,
    "healthcareIndex": 69.5,
    "trafficEfficiencyIndex": 59.7,
    "pollutionControlIndex": 71.1,
    "internetSpeedIndex": 93.5,
    "typicalExpenses": {
      "mealInexpensive": "$14.50",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$81.70",
      "utilitiesBasic": "$145"
    }
  },
  {
    "name": "Winston-Salem",
    "country": "United States",
    "costOfLivingIndex": 59.1,
    "rentIndex": 43.8,
    "groceriesIndex": 54,
    "restaurantIndex": 51.7,
    "purchasingPowerIndex": 96.4,
    "safetyIndex": 52.8,
    "climateIndex": 78.4,
    "healthcareIndex": 70.1,
    "trafficEfficiencyIndex": 62.9,
    "pollutionControlIndex": 61.2,
    "internetSpeedIndex": 87.7,
    "typicalExpenses": {
      "mealInexpensive": "$12.30",
      "coffee": "$3.40",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$69.00",
      "utilitiesBasic": "$123"
    }
  },
  {
    "name": "North Las Vegas",
    "country": "United States",
    "costOfLivingIndex": 65.3,
    "rentIndex": 43.4,
    "groceriesIndex": 61.6,
    "restaurantIndex": 58.2,
    "purchasingPowerIndex": 114.1,
    "safetyIndex": 41.5,
    "climateIndex": 75.1,
    "healthcareIndex": 62.4,
    "trafficEfficiencyIndex": 63,
    "pollutionControlIndex": 73.8,
    "internetSpeedIndex": 91.1,
    "typicalExpenses": {
      "mealInexpensive": "$13.60",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,591",
      "monthlyPass": "$76.40",
      "utilitiesBasic": "$136"
    }
  },
  {
    "name": "Norfolk",
    "country": "United States",
    "costOfLivingIndex": 62.3,
    "rentIndex": 44.1,
    "groceriesIndex": 57,
    "restaurantIndex": 57.1,
    "purchasingPowerIndex": 103.5,
    "safetyIndex": 46.2,
    "climateIndex": 80.5,
    "healthcareIndex": 68.2,
    "trafficEfficiencyIndex": 65.5,
    "pollutionControlIndex": 76.6,
    "internetSpeedIndex": 91.6,
    "typicalExpenses": {
      "mealInexpensive": "$13.00",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$73.20",
      "utilitiesBasic": "$129"
    }
  },
  {
    "name": "Chesapeake",
    "country": "United States",
    "costOfLivingIndex": 64.2,
    "rentIndex": 43.1,
    "groceriesIndex": 61.1,
    "restaurantIndex": 59.4,
    "purchasingPowerIndex": 98,
    "safetyIndex": 63.1,
    "climateIndex": 80.1,
    "healthcareIndex": 69.5,
    "trafficEfficiencyIndex": 64.2,
    "pollutionControlIndex": 75.5,
    "internetSpeedIndex": 86.6,
    "typicalExpenses": {
      "mealInexpensive": "$13.40",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,591",
      "monthlyPass": "$75.30",
      "utilitiesBasic": "$134"
    }
  },
  {
    "name": "Garland",
    "country": "United States",
    "costOfLivingIndex": 62.6,
    "rentIndex": 41.6,
    "groceriesIndex": 60.9,
    "restaurantIndex": 55.5,
    "purchasingPowerIndex": 103.4,
    "safetyIndex": 54.5,
    "climateIndex": 82.1,
    "healthcareIndex": 64.1,
    "trafficEfficiencyIndex": 46.8,
    "pollutionControlIndex": 71.9,
    "internetSpeedIndex": 86.4,
    "typicalExpenses": {
      "mealInexpensive": "$13.00",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,538",
      "monthlyPass": "$73.20",
      "utilitiesBasic": "$131"
    }
  },
  {
    "name": "Irving",
    "country": "United States",
    "costOfLivingIndex": 64.9,
    "rentIndex": 44.5,
    "groceriesIndex": 63.4,
    "restaurantIndex": 57.6,
    "purchasingPowerIndex": 107.3,
    "safetyIndex": 57.2,
    "climateIndex": 82.4,
    "healthcareIndex": 66.2,
    "trafficEfficiencyIndex": 57.7,
    "pollutionControlIndex": 57.6,
    "internetSpeedIndex": 92.7,
    "typicalExpenses": {
      "mealInexpensive": "$13.50",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$76.40",
      "utilitiesBasic": "$136"
    }
  },
  {
    "name": "Hialeah",
    "country": "United States",
    "costOfLivingIndex": 72.7,
    "rentIndex": 48.6,
    "groceriesIndex": 67.4,
    "restaurantIndex": 67.4,
    "purchasingPowerIndex": 104,
    "safetyIndex": 55.4,
    "climateIndex": 82.1,
    "healthcareIndex": 62.1,
    "trafficEfficiencyIndex": 43.4,
    "pollutionControlIndex": 66.2,
    "internetSpeedIndex": 93.3,
    "typicalExpenses": {
      "mealInexpensive": "$15.10",
      "coffee": "$4.20",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$84.90",
      "utilitiesBasic": "$152"
    }
  },
  {
    "name": "Fremont",
    "country": "United States",
    "costOfLivingIndex": 86.7,
    "rentIndex": 60.2,
    "groceriesIndex": 83.7,
    "restaurantIndex": 79.5,
    "purchasingPowerIndex": 112.7,
    "safetyIndex": 71.4,
    "climateIndex": 86.2,
    "healthcareIndex": 75.8,
    "trafficEfficiencyIndex": 62.7,
    "pollutionControlIndex": 62.4,
    "internetSpeedIndex": 87.9,
    "typicalExpenses": {
      "mealInexpensive": "$18.10",
      "coffee": "$5.00",
      "apartment1BedCenter": "$2,228",
      "monthlyPass": "$101.80",
      "utilitiesBasic": "$180"
    }
  },
  {
    "name": "Boise",
    "country": "United States",
    "costOfLivingIndex": 66,
    "rentIndex": 44.7,
    "groceriesIndex": 63.3,
    "restaurantIndex": 59.2,
    "purchasingPowerIndex": 106.8,
    "safetyIndex": 66.1,
    "climateIndex": 73.2,
    "healthcareIndex": 71.2,
    "trafficEfficiencyIndex": 54,
    "pollutionControlIndex": 74.3,
    "internetSpeedIndex": 85.8,
    "typicalExpenses": {
      "mealInexpensive": "$13.70",
      "coffee": "$3.80",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$77.40",
      "utilitiesBasic": "$138"
    }
  },
  {
    "name": "Richmond",
    "country": "United States",
    "costOfLivingIndex": 66.3,
    "rentIndex": 46.4,
    "groceriesIndex": 60.8,
    "restaurantIndex": 58.4,
    "purchasingPowerIndex": 104.6,
    "safetyIndex": 48.2,
    "climateIndex": 79.5,
    "healthcareIndex": 72.4,
    "trafficEfficiencyIndex": 45.1,
    "pollutionControlIndex": 57.5,
    "internetSpeedIndex": 95.4,
    "typicalExpenses": {
      "mealInexpensive": "$13.80",
      "coffee": "$3.80",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$77.40",
      "utilitiesBasic": "$138"
    }
  },
  {
    "name": "Baton Rouge",
    "country": "United States",
    "costOfLivingIndex": 60.5,
    "rentIndex": 44.5,
    "groceriesIndex": 56.5,
    "restaurantIndex": 56.5,
    "purchasingPowerIndex": 96,
    "safetyIndex": 32.5,
    "climateIndex": 82.1,
    "healthcareIndex": 64.5,
    "trafficEfficiencyIndex": 42.1,
    "pollutionControlIndex": 75.3,
    "internetSpeedIndex": 85.3,
    "typicalExpenses": {
      "mealInexpensive": "$12.60",
      "coffee": "$3.50",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$71.10",
      "utilitiesBasic": "$126"
    }
  },
  {
    "name": "Spokane",
    "country": "United States",
    "costOfLivingIndex": 64.3,
    "rentIndex": 45.5,
    "groceriesIndex": 62.6,
    "restaurantIndex": 58.8,
    "purchasingPowerIndex": 99,
    "safetyIndex": 49.1,
    "climateIndex": 71.5,
    "healthcareIndex": 71.1,
    "trafficEfficiencyIndex": 58.4,
    "pollutionControlIndex": 65.4,
    "internetSpeedIndex": 94.9,
    "typicalExpenses": {
      "mealInexpensive": "$13.40",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$75.30",
      "utilitiesBasic": "$134"
    }
  },
  {
    "name": "Des Moines",
    "country": "United States",
    "costOfLivingIndex": 60.2,
    "rentIndex": 42.2,
    "groceriesIndex": 56.3,
    "restaurantIndex": 56,
    "purchasingPowerIndex": 103.4,
    "safetyIndex": 60.2,
    "climateIndex": 68.4,
    "healthcareIndex": 72.8,
    "trafficEfficiencyIndex": 52.4,
    "pollutionControlIndex": 76.2,
    "internetSpeedIndex": 85.9,
    "typicalExpenses": {
      "mealInexpensive": "$12.50",
      "coffee": "$3.40",
      "apartment1BedCenter": "$1,591",
      "monthlyPass": "$70.00",
      "utilitiesBasic": "$125"
    }
  },
  {
    "name": "Tacoma",
    "country": "United States",
    "costOfLivingIndex": 73.7,
    "rentIndex": 49.6,
    "groceriesIndex": 70.5,
    "restaurantIndex": 64.5,
    "purchasingPowerIndex": 96.4,
    "safetyIndex": 42.1,
    "climateIndex": 81.2,
    "healthcareIndex": 70.1,
    "trafficEfficiencyIndex": 43.3,
    "pollutionControlIndex": 73.4,
    "internetSpeedIndex": 96,
    "typicalExpenses": {
      "mealInexpensive": "$15.40",
      "coffee": "$4.20",
      "apartment1BedCenter": "$1,856",
      "monthlyPass": "$85.90",
      "utilitiesBasic": "$154"
    }
  },
  {
    "name": "San Bernardino",
    "country": "United States",
    "costOfLivingIndex": 69.4,
    "rentIndex": 50.9,
    "groceriesIndex": 65.5,
    "restaurantIndex": 64,
    "purchasingPowerIndex": 100.8,
    "safetyIndex": 31.5,
    "climateIndex": 85.2,
    "healthcareIndex": 61.5,
    "trafficEfficiencyIndex": 50.1,
    "pollutionControlIndex": 57.7,
    "internetSpeedIndex": 85.4,
    "typicalExpenses": {
      "mealInexpensive": "$14.50",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,909",
      "monthlyPass": "$81.70",
      "utilitiesBasic": "$144"
    }
  },
  {
    "name": "Modesto",
    "country": "United States",
    "costOfLivingIndex": 68.7,
    "rentIndex": 49.8,
    "groceriesIndex": 64.5,
    "restaurantIndex": 60.2,
    "purchasingPowerIndex": 102.3,
    "safetyIndex": 44.2,
    "climateIndex": 84.1,
    "healthcareIndex": 63.2,
    "trafficEfficiencyIndex": 43.3,
    "pollutionControlIndex": 79.5,
    "internetSpeedIndex": 91.2,
    "typicalExpenses": {
      "mealInexpensive": "$14.30",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,856",
      "monthlyPass": "$80.60",
      "utilitiesBasic": "$143"
    }
  },
  {
    "name": "Fontana",
    "country": "United States",
    "costOfLivingIndex": 69.3,
    "rentIndex": 50,
    "groceriesIndex": 63.9,
    "restaurantIndex": 64.3,
    "purchasingPowerIndex": 105.2,
    "safetyIndex": 54.1,
    "climateIndex": 85.4,
    "healthcareIndex": 62.4,
    "trafficEfficiencyIndex": 59.9,
    "pollutionControlIndex": 77.6,
    "internetSpeedIndex": 95.6,
    "typicalExpenses": {
      "mealInexpensive": "$14.40",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,856",
      "monthlyPass": "$81.70",
      "utilitiesBasic": "$144"
    }
  },
  {
    "name": "Santa Clarita",
    "country": "United States",
    "costOfLivingIndex": 78.8,
    "rentIndex": 54.9,
    "groceriesIndex": 76.5,
    "restaurantIndex": 70.2,
    "purchasingPowerIndex": 105.2,
    "safetyIndex": 72.1,
    "climateIndex": 88.1,
    "healthcareIndex": 71.5,
    "trafficEfficiencyIndex": 66.7,
    "pollutionControlIndex": 70,
    "internetSpeedIndex": 98.6,
    "typicalExpenses": {
      "mealInexpensive": "$16.40",
      "coffee": "$4.50",
      "apartment1BedCenter": "$2,016",
      "monthlyPass": "$92.30",
      "utilitiesBasic": "$164"
    }
  },
  {
    "name": "Oxnard",
    "country": "United States",
    "costOfLivingIndex": 78.2,
    "rentIndex": 52.6,
    "groceriesIndex": 75.1,
    "restaurantIndex": 72.1,
    "purchasingPowerIndex": 95.7,
    "safetyIndex": 58.4,
    "climateIndex": 94.2,
    "healthcareIndex": 69.8,
    "trafficEfficiencyIndex": 63.2,
    "pollutionControlIndex": 78.8,
    "internetSpeedIndex": 96.8,
    "typicalExpenses": {
      "mealInexpensive": "$16.30",
      "coffee": "$4.50",
      "apartment1BedCenter": "$1,963",
      "monthlyPass": "$91.20",
      "utilitiesBasic": "$163"
    }
  },
  {
    "name": "Birmingham (AL)",
    "country": "United States",
    "costOfLivingIndex": 60.2,
    "rentIndex": 39.8,
    "groceriesIndex": 58.7,
    "restaurantIndex": 53.1,
    "purchasingPowerIndex": 97,
    "safetyIndex": 28.5,
    "climateIndex": 82.4,
    "healthcareIndex": 70.1,
    "trafficEfficiencyIndex": 62.8,
    "pollutionControlIndex": 73.9,
    "internetSpeedIndex": 86.9,
    "typicalExpenses": {
      "mealInexpensive": "$12.50",
      "coffee": "$3.40",
      "apartment1BedCenter": "$1,485",
      "monthlyPass": "$70.00",
      "utilitiesBasic": "$125"
    }
  },
  {
    "name": "Huntsville",
    "country": "United States",
    "costOfLivingIndex": 62.5,
    "rentIndex": 44.5,
    "groceriesIndex": 59.1,
    "restaurantIndex": 58.3,
    "purchasingPowerIndex": 103.9,
    "safetyIndex": 56.2,
    "climateIndex": 80.5,
    "healthcareIndex": 71.5,
    "trafficEfficiencyIndex": 60.8,
    "pollutionControlIndex": 72.1,
    "internetSpeedIndex": 88.7,
    "typicalExpenses": {
      "mealInexpensive": "$13.00",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$73.20",
      "utilitiesBasic": "$131"
    }
  },
  {
    "name": "Fayetteville",
    "country": "United States",
    "costOfLivingIndex": 59.6,
    "rentIndex": 41.1,
    "groceriesIndex": 57.8,
    "restaurantIndex": 52.1,
    "purchasingPowerIndex": 108.1,
    "safetyIndex": 54.1,
    "climateIndex": 78.2,
    "healthcareIndex": 68.4,
    "trafficEfficiencyIndex": 47.3,
    "pollutionControlIndex": 71.8,
    "internetSpeedIndex": 90.6,
    "typicalExpenses": {
      "mealInexpensive": "$12.40",
      "coffee": "$3.40",
      "apartment1BedCenter": "$1,538",
      "monthlyPass": "$70.00",
      "utilitiesBasic": "$124"
    }
  },
  {
    "name": "Rochester (NY)",
    "country": "United States",
    "costOfLivingIndex": 62.3,
    "rentIndex": 46.2,
    "groceriesIndex": 61,
    "restaurantIndex": 55.7,
    "purchasingPowerIndex": 111.2,
    "safetyIndex": 48.5,
    "climateIndex": 61.5,
    "healthcareIndex": 73.5,
    "trafficEfficiencyIndex": 57.7,
    "pollutionControlIndex": 64.6,
    "internetSpeedIndex": 86,
    "typicalExpenses": {
      "mealInexpensive": "$13.00",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$73.20",
      "utilitiesBasic": "$129"
    }
  },
  {
    "name": "Tempe",
    "country": "United States",
    "costOfLivingIndex": 69.3,
    "rentIndex": 48.9,
    "groceriesIndex": 64.7,
    "restaurantIndex": 63.1,
    "purchasingPowerIndex": 112.3,
    "safetyIndex": 56.4,
    "climateIndex": 73.5,
    "healthcareIndex": 68.2,
    "trafficEfficiencyIndex": 48.5,
    "pollutionControlIndex": 67.2,
    "internetSpeedIndex": 96.9,
    "typicalExpenses": {
      "mealInexpensive": "$14.40",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$81.70",
      "utilitiesBasic": "$144"
    }
  },
  {
    "name": "Cape Coral",
    "country": "United States",
    "costOfLivingIndex": 66.6,
    "rentIndex": 46.1,
    "groceriesIndex": 62.4,
    "restaurantIndex": 58.2,
    "purchasingPowerIndex": 100.8,
    "safetyIndex": 67.1,
    "climateIndex": 87.2,
    "healthcareIndex": 68.5,
    "trafficEfficiencyIndex": 61.3,
    "pollutionControlIndex": 68.2,
    "internetSpeedIndex": 92.7,
    "typicalExpenses": {
      "mealInexpensive": "$13.90",
      "coffee": "$3.80",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$78.50",
      "utilitiesBasic": "$139"
    }
  },
  {
    "name": "Coral Springs",
    "country": "United States",
    "costOfLivingIndex": 71.4,
    "rentIndex": 49.5,
    "groceriesIndex": 68.3,
    "restaurantIndex": 63.9,
    "purchasingPowerIndex": 102.2,
    "safetyIndex": 65.4,
    "climateIndex": 82.1,
    "healthcareIndex": 67.4,
    "trafficEfficiencyIndex": 46.9,
    "pollutionControlIndex": 69.9,
    "internetSpeedIndex": 94.7,
    "typicalExpenses": {
      "mealInexpensive": "$14.90",
      "coffee": "$4.10",
      "apartment1BedCenter": "$1,856",
      "monthlyPass": "$83.80",
      "utilitiesBasic": "$149"
    }
  },
  {
    "name": "Fort Lauderdale",
    "country": "United States",
    "costOfLivingIndex": 75.5,
    "rentIndex": 51.9,
    "groceriesIndex": 71.2,
    "restaurantIndex": 67.8,
    "purchasingPowerIndex": 100,
    "safetyIndex": 48.1,
    "climateIndex": 82.5,
    "healthcareIndex": 70.5,
    "trafficEfficiencyIndex": 52.9,
    "pollutionControlIndex": 64.1,
    "internetSpeedIndex": 95.2,
    "typicalExpenses": {
      "mealInexpensive": "$15.70",
      "coffee": "$4.30",
      "apartment1BedCenter": "$1,909",
      "monthlyPass": "$88.00",
      "utilitiesBasic": "$157"
    }
  },
  {
    "name": "West Palm Beach",
    "country": "United States",
    "costOfLivingIndex": 74.4,
    "rentIndex": 53.9,
    "groceriesIndex": 68.5,
    "restaurantIndex": 68.2,
    "purchasingPowerIndex": 104.2,
    "safetyIndex": 50.2,
    "climateIndex": 82.4,
    "healthcareIndex": 69.8,
    "trafficEfficiencyIndex": 56,
    "pollutionControlIndex": 73.8,
    "internetSpeedIndex": 95.7,
    "typicalExpenses": {
      "mealInexpensive": "$15.50",
      "coffee": "$4.30",
      "apartment1BedCenter": "$2,016",
      "monthlyPass": "$87.00",
      "utilitiesBasic": "$155"
    }
  },
  {
    "name": "Tallahassee",
    "country": "United States",
    "costOfLivingIndex": 63.6,
    "rentIndex": 44.3,
    "groceriesIndex": 60.3,
    "restaurantIndex": 58.1,
    "purchasingPowerIndex": 105.2,
    "safetyIndex": 44.5,
    "climateIndex": 84.1,
    "healthcareIndex": 68.1,
    "trafficEfficiencyIndex": 61.9,
    "pollutionControlIndex": 57.6,
    "internetSpeedIndex": 91.1,
    "typicalExpenses": {
      "mealInexpensive": "$13.30",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$74.30",
      "utilitiesBasic": "$133"
    }
  },
  {
    "name": "Gainesville",
    "country": "United States",
    "costOfLivingIndex": 62.3,
    "rentIndex": 44.6,
    "groceriesIndex": 60.7,
    "restaurantIndex": 54.4,
    "purchasingPowerIndex": 102.1,
    "safetyIndex": 48.2,
    "climateIndex": 84.5,
    "healthcareIndex": 71.2,
    "trafficEfficiencyIndex": 54.3,
    "pollutionControlIndex": 75.9,
    "internetSpeedIndex": 88.7,
    "typicalExpenses": {
      "mealInexpensive": "$13.00",
      "coffee": "$3.60",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$73.20",
      "utilitiesBasic": "$129"
    }
  },
  {
    "name": "Port St. Lucie",
    "country": "United States",
    "costOfLivingIndex": 65.4,
    "rentIndex": 46.3,
    "groceriesIndex": 63.8,
    "restaurantIndex": 60.1,
    "purchasingPowerIndex": 107.1,
    "safetyIndex": 64.2,
    "climateIndex": 84.2,
    "healthcareIndex": 66.5,
    "trafficEfficiencyIndex": 54.3,
    "pollutionControlIndex": 66.6,
    "internetSpeedIndex": 89.1,
    "typicalExpenses": {
      "mealInexpensive": "$13.60",
      "coffee": "$3.70",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$76.40",
      "utilitiesBasic": "$136"
    }
  },
  {
    "name": "Pembroke Pines",
    "country": "United States",
    "costOfLivingIndex": 71.8,
    "rentIndex": 47.8,
    "groceriesIndex": 67.8,
    "restaurantIndex": 66.4,
    "purchasingPowerIndex": 109.8,
    "safetyIndex": 61.5,
    "climateIndex": 82.4,
    "healthcareIndex": 67.2,
    "trafficEfficiencyIndex": 51.2,
    "pollutionControlIndex": 57,
    "internetSpeedIndex": 94.1,
    "typicalExpenses": {
      "mealInexpensive": "$15.00",
      "coffee": "$4.10",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$83.80",
      "utilitiesBasic": "$150"
    }
  },
  {
    "name": "Hollywood",
    "country": "United States",
    "costOfLivingIndex": 72.5,
    "rentIndex": 51.9,
    "groceriesIndex": 68,
    "restaurantIndex": 66.6,
    "purchasingPowerIndex": 108.5,
    "safetyIndex": 52.4,
    "climateIndex": 82.5,
    "healthcareIndex": 68.4,
    "trafficEfficiencyIndex": 66.3,
    "pollutionControlIndex": 61.5,
    "internetSpeedIndex": 97.2,
    "typicalExpenses": {
      "mealInexpensive": "$15.10",
      "coffee": "$4.20",
      "apartment1BedCenter": "$1,909",
      "monthlyPass": "$84.90",
      "utilitiesBasic": "$151"
    }
  },
  {
    "name": "Miramar",
    "country": "United States",
    "costOfLivingIndex": 70.8,
    "rentIndex": 50.9,
    "groceriesIndex": 67.5,
    "restaurantIndex": 64.5,
    "purchasingPowerIndex": 101.2,
    "safetyIndex": 58.1,
    "climateIndex": 82.1,
    "healthcareIndex": 66.5,
    "trafficEfficiencyIndex": 44.5,
    "pollutionControlIndex": 62.6,
    "internetSpeedIndex": 91.7,
    "typicalExpenses": {
      "mealInexpensive": "$14.70",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,909",
      "monthlyPass": "$82.70",
      "utilitiesBasic": "$148"
    }
  },
  {
    "name": "Clearwater",
    "country": "United States",
    "costOfLivingIndex": 67.4,
    "rentIndex": 48.6,
    "groceriesIndex": 64.8,
    "restaurantIndex": 62.1,
    "purchasingPowerIndex": 114.4,
    "safetyIndex": 59.2,
    "climateIndex": 87.4,
    "healthcareIndex": 68.1,
    "trafficEfficiencyIndex": 42.5,
    "pollutionControlIndex": 63.4,
    "internetSpeedIndex": 85.6,
    "typicalExpenses": {
      "mealInexpensive": "$14.00",
      "coffee": "$3.90",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$78.50",
      "utilitiesBasic": "$140"
    }
  },
  {
    "name": "Pompano Beach",
    "country": "United States",
    "costOfLivingIndex": 70.3,
    "rentIndex": 47.4,
    "groceriesIndex": 68.4,
    "restaurantIndex": 62.2,
    "purchasingPowerIndex": 101.7,
    "safetyIndex": 47.5,
    "climateIndex": 82.2,
    "healthcareIndex": 65.4,
    "trafficEfficiencyIndex": 49.2,
    "pollutionControlIndex": 71.3,
    "internetSpeedIndex": 91.6,
    "typicalExpenses": {
      "mealInexpensive": "$14.70",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$82.70",
      "utilitiesBasic": "$146"
    }
  },
  {
    "name": "Fort Myers",
    "country": "United States",
    "costOfLivingIndex": 65.7,
    "rentIndex": 45.2,
    "groceriesIndex": 60.9,
    "restaurantIndex": 57.3,
    "purchasingPowerIndex": 105.2,
    "safetyIndex": 52.8,
    "climateIndex": 87.5,
    "healthcareIndex": 68.2,
    "trafficEfficiencyIndex": 57.8,
    "pollutionControlIndex": 61.2,
    "internetSpeedIndex": 86.9,
    "typicalExpenses": {
      "mealInexpensive": "$13.70",
      "coffee": "$3.80",
      "apartment1BedCenter": "$1,697",
      "monthlyPass": "$77.40",
      "utilitiesBasic": "$137"
    }
  },
  {
    "name": "Sarasota",
    "country": "United States",
    "costOfLivingIndex": 69.4,
    "rentIndex": 49.6,
    "groceriesIndex": 65.2,
    "restaurantIndex": 60.9,
    "purchasingPowerIndex": 115,
    "safetyIndex": 62.4,
    "climateIndex": 87.1,
    "healthcareIndex": 70.5,
    "trafficEfficiencyIndex": 64,
    "pollutionControlIndex": 65.4,
    "internetSpeedIndex": 97.8,
    "typicalExpenses": {
      "mealInexpensive": "$14.50",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,856",
      "monthlyPass": "$81.70",
      "utilitiesBasic": "$144"
    }
  },
  {
    "name": "Naples",
    "country": "United States",
    "costOfLivingIndex": 79.8,
    "rentIndex": 56.2,
    "groceriesIndex": 73.9,
    "restaurantIndex": 73.8,
    "purchasingPowerIndex": 98.8,
    "safetyIndex": 74.5,
    "climateIndex": 87.2,
    "healthcareIndex": 72.1,
    "trafficEfficiencyIndex": 55.5,
    "pollutionControlIndex": 63.4,
    "internetSpeedIndex": 93.5,
    "typicalExpenses": {
      "mealInexpensive": "$16.60",
      "coffee": "$4.60",
      "apartment1BedCenter": "$2,069",
      "monthlyPass": "$93.40",
      "utilitiesBasic": "$167"
    }
  },
  {
    "name": "Pensacola",
    "country": "United States",
    "costOfLivingIndex": 60.2,
    "rentIndex": 40.2,
    "groceriesIndex": 56.8,
    "restaurantIndex": 52.4,
    "purchasingPowerIndex": 106.7,
    "safetyIndex": 48.5,
    "climateIndex": 82.5,
    "healthcareIndex": 65.2,
    "trafficEfficiencyIndex": 54.6,
    "pollutionControlIndex": 58.9,
    "internetSpeedIndex": 85.4,
    "typicalExpenses": {
      "mealInexpensive": "$12.50",
      "coffee": "$3.40",
      "apartment1BedCenter": "$1,485",
      "monthlyPass": "$70.00",
      "utilitiesBasic": "$125"
    }
  },
  {
    "name": "Key West",
    "country": "United States",
    "costOfLivingIndex": 86.6,
    "rentIndex": 60.1,
    "groceriesIndex": 80.7,
    "restaurantIndex": 77.3,
    "purchasingPowerIndex": 97.1,
    "safetyIndex": 68.2,
    "climateIndex": 88.4,
    "healthcareIndex": 66.5,
    "trafficEfficiencyIndex": 53.6,
    "pollutionControlIndex": 56.8,
    "internetSpeedIndex": 90.6,
    "typicalExpenses": {
      "mealInexpensive": "$18.10",
      "coffee": "$5.00",
      "apartment1BedCenter": "$2,228",
      "monthlyPass": "$101.80",
      "utilitiesBasic": "$180"
    }
  },
  {
    "name": "Knoxville",
    "country": "United States",
    "costOfLivingIndex": 60.6,
    "rentIndex": 40.8,
    "groceriesIndex": 58.5,
    "restaurantIndex": 55.2,
    "purchasingPowerIndex": 95.5,
    "safetyIndex": 54.2,
    "climateIndex": 76.5,
    "healthcareIndex": 70.4,
    "trafficEfficiencyIndex": 58,
    "pollutionControlIndex": 74.1,
    "internetSpeedIndex": 89.5,
    "typicalExpenses": {
      "mealInexpensive": "$12.60",
      "coffee": "$3.50",
      "apartment1BedCenter": "$1,538",
      "monthlyPass": "$71.10",
      "utilitiesBasic": "$126"
    }
  },
  {
    "name": "Chattanooga",
    "country": "United States",
    "costOfLivingIndex": 59.2,
    "rentIndex": 43.4,
    "groceriesIndex": 54.7,
    "restaurantIndex": 51.8,
    "purchasingPowerIndex": 113.8,
    "safetyIndex": 45.4,
    "climateIndex": 76.2,
    "healthcareIndex": 68.1,
    "trafficEfficiencyIndex": 48.8,
    "pollutionControlIndex": 58.7,
    "internetSpeedIndex": 88.5,
    "typicalExpenses": {
      "mealInexpensive": "$12.40",
      "coffee": "$3.40",
      "apartment1BedCenter": "$1,591",
      "monthlyPass": "$69.00",
      "utilitiesBasic": "$123"
    }
  },
  {
    "name": "Clarksville",
    "country": "United States",
    "costOfLivingIndex": 57.4,
    "rentIndex": 42.1,
    "groceriesIndex": 53.7,
    "restaurantIndex": 52.4,
    "purchasingPowerIndex": 105.6,
    "safetyIndex": 51.2,
    "climateIndex": 76.4,
    "healthcareIndex": 65.2,
    "trafficEfficiencyIndex": 55.6,
    "pollutionControlIndex": 79.5,
    "internetSpeedIndex": 97.2,
    "typicalExpenses": {
      "mealInexpensive": "$12.00",
      "coffee": "$3.30",
      "apartment1BedCenter": "$1,591",
      "monthlyPass": "$66.80",
      "utilitiesBasic": "$120"
    }
  },
  {
    "name": "Murfreesboro",
    "country": "United States",
    "costOfLivingIndex": 60.2,
    "rentIndex": 44.6,
    "groceriesIndex": 58.9,
    "restaurantIndex": 56,
    "purchasingPowerIndex": 96.8,
    "safetyIndex": 58.1,
    "climateIndex": 76.1,
    "healthcareIndex": 67.4,
    "trafficEfficiencyIndex": 57.9,
    "pollutionControlIndex": 69.3,
    "internetSpeedIndex": 90.3,
    "typicalExpenses": {
      "mealInexpensive": "$12.50",
      "coffee": "$3.40",
      "apartment1BedCenter": "$1,644",
      "monthlyPass": "$70.00",
      "utilitiesBasic": "$125"
    }
  },
  {
    "name": "Mobile",
    "country": "United States",
    "costOfLivingIndex": 57.1,
    "rentIndex": 37.9,
    "groceriesIndex": 55.2,
    "restaurantIndex": 49.7,
    "purchasingPowerIndex": 104.2,
    "safetyIndex": 41.5,
    "climateIndex": 83.2,
    "healthcareIndex": 64.1,
    "trafficEfficiencyIndex": 55.4,
    "pollutionControlIndex": 78.6,
    "internetSpeedIndex": 88.2,
    "typicalExpenses": {
      "mealInexpensive": "$11.90",
      "coffee": "$3.30",
      "apartment1BedCenter": "$1,432",
      "monthlyPass": "$66.80",
      "utilitiesBasic": "$119"
    }
  },
  {
    "name": "Montgomery",
    "country": "United States",
    "costOfLivingIndex": 56.4,
    "rentIndex": 37.6,
    "groceriesIndex": 54.3,
    "restaurantIndex": 52.1,
    "purchasingPowerIndex": 100.5,
    "safetyIndex": 34.5,
    "climateIndex": 82.1,
    "healthcareIndex": 65.2,
    "trafficEfficiencyIndex": 58.6,
    "pollutionControlIndex": 60,
    "internetSpeedIndex": 98.9,
    "typicalExpenses": {
      "mealInexpensive": "$11.80",
      "coffee": "$3.20",
      "apartment1BedCenter": "$1,379",
      "monthlyPass": "$65.80",
      "utilitiesBasic": "$118"
    }
  },
  {
    "name": "Tuscaloosa",
    "country": "United States",
    "costOfLivingIndex": 58.1,
    "rentIndex": 40.6,
    "groceriesIndex": 55.4,
    "restaurantIndex": 52.6,
    "purchasingPowerIndex": 96.6,
    "safetyIndex": 48.2,
    "climateIndex": 82.4,
    "healthcareIndex": 67.5,
    "trafficEfficiencyIndex": 44.5,
    "pollutionControlIndex": 71.7,
    "internetSpeedIndex": 91.2,
    "typicalExpenses": {
      "mealInexpensive": "$12.10",
      "coffee": "$3.30",
      "apartment1BedCenter": "$1,485",
      "monthlyPass": "$67.90",
      "utilitiesBasic": "$121"
    }
  },
  {
    "name": "Gulfport",
    "country": "United States",
    "costOfLivingIndex": 55.8,
    "rentIndex": 37.1,
    "groceriesIndex": 53.8,
    "restaurantIndex": 48.7,
    "purchasingPowerIndex": 114.4,
    "safetyIndex": 44.2,
    "climateIndex": 83.1,
    "healthcareIndex": 62.4,
    "trafficEfficiencyIndex": 55.7,
    "pollutionControlIndex": 56.3,
    "internetSpeedIndex": 100,
    "typicalExpenses": {
      "mealInexpensive": "$11.60",
      "coffee": "$3.20",
      "apartment1BedCenter": "$1,379",
      "monthlyPass": "$65.80",
      "utilitiesBasic": "$117"
    }
  },
  {
    "name": "Jackson",
    "country": "United States",
    "costOfLivingIndex": 56.1,
    "rentIndex": 39.6,
    "groceriesIndex": 52.9,
    "restaurantIndex": 48.8,
    "purchasingPowerIndex": 101.1,
    "safetyIndex": 28.1,
    "climateIndex": 81.2,
    "healthcareIndex": 63.1,
    "trafficEfficiencyIndex": 64.2,
    "pollutionControlIndex": 68.4,
    "internetSpeedIndex": 86.8,
    "typicalExpenses": {
      "mealInexpensive": "$11.70",
      "coffee": "$3.20",
      "apartment1BedCenter": "$1,485",
      "monthlyPass": "$65.80",
      "utilitiesBasic": "$117"
    }
  },
  {
    "name": "Little Rock",
    "country": "United States",
    "costOfLivingIndex": 58.5,
    "rentIndex": 40.5,
    "groceriesIndex": 54,
    "restaurantIndex": 53,
    "purchasingPowerIndex": 107.4,
    "safetyIndex": 31.2,
    "climateIndex": 78.4,
    "healthcareIndex": 67.2,
    "trafficEfficiencyIndex": 57.1,
    "pollutionControlIndex": 77.4,
    "internetSpeedIndex": 93.4,
    "typicalExpenses": {
      "mealInexpensive": "$12.20",
      "coffee": "$3.40",
      "apartment1BedCenter": "$1,485",
      "monthlyPass": "$69.00",
      "utilitiesBasic": "$122"
    }
  },
  {
    "name": "Fort Smith",
    "country": "United States",
    "costOfLivingIndex": 53.3,
    "rentIndex": 35.4,
    "groceriesIndex": 48.5,
    "restaurantIndex": 49.7,
    "purchasingPowerIndex": 113.4,
    "safetyIndex": 48.1,
    "climateIndex": 78.1,
    "healthcareIndex": 61.2,
    "trafficEfficiencyIndex": 69.7,
    "pollutionControlIndex": 60.6,
    "internetSpeedIndex": 96.9,
    "typicalExpenses": {
      "mealInexpensive": "$11.10",
      "coffee": "$3.10",
      "apartment1BedCenter": "$1,326",
      "monthlyPass": "$62.60",
      "utilitiesBasic": "$111"
    }
  },
  {
    "name": "Springdale",
    "country": "United States",
    "costOfLivingIndex": 57.1,
    "rentIndex": 40.7,
    "groceriesIndex": 52.4,
    "restaurantIndex": 51.8,
    "purchasingPowerIndex": 105.1,
    "safetyIndex": 54.2,
    "climateIndex": 78.5,
    "healthcareIndex": 64.1,
    "trafficEfficiencyIndex": 51.8,
    "pollutionControlIndex": 66.2,
    "internetSpeedIndex": 94.3,
    "typicalExpenses": {
      "mealInexpensive": "$11.90",
      "coffee": "$3.30",
      "apartment1BedCenter": "$1,485",
      "monthlyPass": "$66.80",
      "utilitiesBasic": "$119"
    }
  },
  {
    "name": "Worcester",
    "country": "United States",
    "costOfLivingIndex": 71.4,
    "rentIndex": 47.8,
    "groceriesIndex": 68.3,
    "restaurantIndex": 64.5,
    "purchasingPowerIndex": 110.9,
    "safetyIndex": 56.2,
    "climateIndex": 67.4,
    "healthcareIndex": 74.1,
    "trafficEfficiencyIndex": 42.8,
    "pollutionControlIndex": 71.8,
    "internetSpeedIndex": 95.6,
    "typicalExpenses": {
      "mealInexpensive": "$14.90",
      "coffee": "$4.10",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$83.80",
      "utilitiesBasic": "$149"
    }
  },
  {
    "name": "Providence",
    "country": "United States",
    "costOfLivingIndex": 73.7,
    "rentIndex": 51.2,
    "groceriesIndex": 68.6,
    "restaurantIndex": 65,
    "purchasingPowerIndex": 102.5,
    "safetyIndex": 50.1,
    "climateIndex": 70.2,
    "healthcareIndex": 75.4,
    "trafficEfficiencyIndex": 60.8,
    "pollutionControlIndex": 65,
    "internetSpeedIndex": 85.1,
    "typicalExpenses": {
      "mealInexpensive": "$15.40",
      "coffee": "$4.20",
      "apartment1BedCenter": "$1,909",
      "monthlyPass": "$85.90",
      "utilitiesBasic": "$154"
    }
  },
  {
    "name": "Hartford",
    "country": "United States",
    "costOfLivingIndex": 72.4,
    "rentIndex": 50.5,
    "groceriesIndex": 67.5,
    "restaurantIndex": 66,
    "purchasingPowerIndex": 108,
    "safetyIndex": 41.2,
    "climateIndex": 69.4,
    "healthcareIndex": 72.5,
    "trafficEfficiencyIndex": 47,
    "pollutionControlIndex": 77.9,
    "internetSpeedIndex": 92.9,
    "typicalExpenses": {
      "mealInexpensive": "$15.10",
      "coffee": "$4.20",
      "apartment1BedCenter": "$1,856",
      "monthlyPass": "$84.90",
      "utilitiesBasic": "$151"
    }
  },
  {
    "name": "New Haven",
    "country": "United States",
    "costOfLivingIndex": 76.6,
    "rentIndex": 51.3,
    "groceriesIndex": 74.3,
    "restaurantIndex": 69.5,
    "purchasingPowerIndex": 99.9,
    "safetyIndex": 44.5,
    "climateIndex": 70.5,
    "healthcareIndex": 74.1,
    "trafficEfficiencyIndex": 53.5,
    "pollutionControlIndex": 74.8,
    "internetSpeedIndex": 86.5,
    "typicalExpenses": {
      "mealInexpensive": "$16.00",
      "coffee": "$4.40",
      "apartment1BedCenter": "$1,909",
      "monthlyPass": "$90.20",
      "utilitiesBasic": "$159"
    }
  },
  {
    "name": "Bridgeport",
    "country": "United States",
    "costOfLivingIndex": 77.5,
    "rentIndex": 55.3,
    "groceriesIndex": 73,
    "restaurantIndex": 68.2,
    "purchasingPowerIndex": 104.4,
    "safetyIndex": 46.1,
    "climateIndex": 70.1,
    "healthcareIndex": 71.4,
    "trafficEfficiencyIndex": 61.8,
    "pollutionControlIndex": 74.3,
    "internetSpeedIndex": 87.3,
    "typicalExpenses": {
      "mealInexpensive": "$16.10",
      "coffee": "$4.40",
      "apartment1BedCenter": "$2,069",
      "monthlyPass": "$91.20",
      "utilitiesBasic": "$161"
    }
  },
  {
    "name": "Stamford",
    "country": "United States",
    "costOfLivingIndex": 85.6,
    "rentIndex": 59.3,
    "groceriesIndex": 82.4,
    "restaurantIndex": 78.1,
    "purchasingPowerIndex": 103.9,
    "safetyIndex": 68.2,
    "climateIndex": 70.2,
    "healthcareIndex": 76.1,
    "trafficEfficiencyIndex": 58.7,
    "pollutionControlIndex": 77.1,
    "internetSpeedIndex": 98.4,
    "typicalExpenses": {
      "mealInexpensive": "$17.80",
      "coffee": "$4.90",
      "apartment1BedCenter": "$2,228",
      "monthlyPass": "$100.80",
      "utilitiesBasic": "$178"
    }
  },
  {
    "name": "Eugene",
    "country": "United States",
    "costOfLivingIndex": 69.3,
    "rentIndex": 48.8,
    "groceriesIndex": 66.3,
    "restaurantIndex": 62.3,
    "purchasingPowerIndex": 100.8,
    "safetyIndex": 52.4,
    "climateIndex": 81.4,
    "healthcareIndex": 72.1,
    "trafficEfficiencyIndex": 54,
    "pollutionControlIndex": 62.4,
    "internetSpeedIndex": 85.9,
    "typicalExpenses": {
      "mealInexpensive": "$14.40",
      "coffee": "$4.00",
      "apartment1BedCenter": "$1,803",
      "monthlyPass": "$81.70",
      "utilitiesBasic": "$144"
    }
  },
  {
    "name": "Salem",
    "country": "United States",
    "costOfLivingIndex": 66.4,
    "rentIndex": 46.8,
    "groceriesIndex": 62.5,
    "restaurantIndex": 58.4,
    "purchasingPowerIndex": 106.7,
    "safetyIndex": 48.1,
    "climateIndex": 81.2,
    "healthcareIndex": 69.4,
    "trafficEfficiencyIndex": 52.8,
    "pollutionControlIndex": 77.1,
    "internetSpeedIndex": 90.3,
    "typicalExpenses": {
      "mealInexpensive": "$13.80",
      "coffee": "$3.80",
      "apartment1BedCenter": "$1,750",
      "monthlyPass": "$77.40",
      "utilitiesBasic": "$138"
    }
  },
  {
    "name": "Bellevue",
    "country": "United States",
    "costOfLivingIndex": 89.1,
    "rentIndex": 63.2,
    "groceriesIndex": 86.3,
    "restaurantIndex": 80.1,
    "purchasingPowerIndex": 110.1,
    "safetyIndex": 72.4,
    "climateIndex": 81.5,
    "healthcareIndex": 78.1,
    "trafficEfficiencyIndex": 64.9,
    "pollutionControlIndex": 63.6,
    "internetSpeedIndex": 92.7,
    "typicalExpenses": {
      "mealInexpensive": "$18.60",
      "coffee": "$5.10",
      "apartment1BedCenter": "$2,334",
      "monthlyPass": "$104",
      "utilitiesBasic": "$186"
    }
  },
  {
    "name": "Redmond",
    "country": "United States",
    "costOfLivingIndex": 86.6,
    "rentIndex": 61,
    "groceriesIndex": 83.1,
    "restaurantIndex": 79.5,
    "purchasingPowerIndex": 102,
    "safetyIndex": 74.2,
    "climateIndex": 81.2,
    "healthcareIndex": 77.4,
    "trafficEfficiencyIndex": 68.6,
    "pollutionControlIndex": 61.2,
    "internetSpeedIndex": 97.2,
    "typicalExpenses": {
      "mealInexpensive": "$18.10",
      "coffee": "$5.00",
      "apartment1BedCenter": "$2,281",
      "monthlyPass": "$101.80",
      "utilitiesBasic": "$180"
    }
  }
];
